import { prodEnvironment } from "@/env/env";
// import mapboxgl, { AnyPaint } from 'mapbox-gl'
import { actionSheetController, alertController } from "@ionic/vue";
// import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
// import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
// import { Geolocation } from '@capacitor/geolocation';
// import { Dialog } from '@capacitor/dialog';
import { ref, watch } from "vue";
// import { Preferences } from '@capacitor/preferences';
// import { Device } from '@capacitor/device';
// import { RulerControl } from 'mapbox-gl-controls';
// import MapboxDraw from "@mapbox/mapbox-gl-draw";
import * as turf from "@turf/turf";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import datagouv from "../assets/json/datagouv.json";
import basegespot from "../assets/json/gespot.json";
//import baseOrangeGespot from "../assets/json/base_gespot.json";
import adjacences from "../assets/json/communes_adjacentes.json";
import PathFinder from "geojson-path-finder";

import {
  FeatureCollection,
  MultiLineString,
  LineString,
  Feature,
} from "geojson";
import { point, nearestPoint, distance } from "@turf/turf";
import {
  ajouterCouche,
  ajouterSource,
  appuisActif,
  chambresActif,
  conduiteActif,
  consententActionSheet,
  immeubleActif,
  inseeActif,
  chargementAppuisAChaud
} from "./map.services";
// import { NearestPoint } from '@turf/nearest-point';
import baseFibre from "@/assets/json/fibres.json";

import { c6versC3a } from "./gcblo.services";
//import ExcelJS from "exceljs";
import * as ExcelJS from "exceljs";

export const zoneAdjacences = ref();
export const imagesBuffers = ref<any[]>([]);
export const allImagesBuffers = ref<any[]>([]);

export const checkedGeojson = ref(false);
export const checkedShapefile = ref(false);
export const checkedD13 = ref(false);
export const checkedC4 = ref(false);
export const checkedC3A = ref(false);
export const checkedC7 = ref(false);
export const checkedRemplacement = ref(false);
export const checkedDFT = ref(false);

export const coef_d13 = ref(2);

export let excelData: any[] = [];
export let lignesC6: any[] = [];
export let C6Brute: any[] = [];
export let parcours: any[] = [];
export let parcours_fibre: any[] = [];
export let cablesFromC6: any[] = [];
export let compteurAppuisHorsCommunes = 0;
export let completementAutreCommune = false;
export let communes_annexes: any[] = [];
export const messageAlerte = ref('');
export const messageAlerte2 = ref('');
export const isOpenCheckShape = ref(false);
export const setOpen = (state: boolean) => {
  isOpenCheckShape.value = state;
};

export const nomAppuiSelection = ref("")
export const posAppuiSelection = ref(1);
export const totalAppuiSelection = ref(100);
export const coordonneesAppuiSelection = ref("")
export const nomCommandePrecision = ref("");
export const inspectionProjectionOpen = ref(false);
export const inspectionProjectionData = ref<any | null>(null);
export const cancelLectureC6 = ref(false);
export const inspectionProjectionSeen = ref(false);
export const inspectionProjectionDecision = ref<"confirm" | "cancel" | null>(null);
let inspectionProjectionResolver: (() => void) | null = null;
export function waitInspectionProjection(): Promise<void> {
  inspectionProjectionDecision.value = null;
  return new Promise((resolve) => {
    inspectionProjectionResolver = () => {
      inspectionProjectionResolver = null;
      resolve();
    };
  });
}
export function confirmInspectionProjection() {
  inspectionProjectionOpen.value = false;
  inspectionProjectionDecision.value = "confirm";
  if (inspectionProjectionResolver) inspectionProjectionResolver();
}
export function cancelInspectionProjectionFn() {
  cancelLectureC6.value = true;
  inspectionProjectionDecision.value = "cancel";
  inspectionProjectionOpen.value = false;
  if (inspectionProjectionResolver) inspectionProjectionResolver();
}
/////////////
//
// calibragePhotoState
// 0 = Le nombre de photos correspond au parcours
// 1 = Le nombre de photos correspond au parcours d'appuis avec de la fibre dessus
// 2 = Le nombre de photos correspond au parcours d'appuis avec de la fibre dessus mais seulement les FranceTelecom
// 3 = Le nombre de photos ne correspond à rien
//
/////////////
export let calibragePhotoState = 0;
export let tableauBlobC6: { annexes: any[] } = { annexes: [] };
export let tableauBlobFiches: any[] = [];
export let tableauBlobC4: any[] = [];
export let annexesC4: any[] = [];
export let annexesC6: any[] = [];
export let parcours_ft: any[] = [];
export const listeRemarques = ref<{ message: string[]; societe: string[] }>({
  message: [],
  societe: [],
});

export let nom_commune: any;

import proj4 from "proj4";
import { utilisateurSiren } from "./auth.services";
import { presentToast } from "./user.services";
import { Dialog } from "@capacitor/dialog";
import { Encoding } from "@capacitor/filesystem";

export const ponds: Record<string, any> = {};
export const hoveredPond = ref<string | null>(null);

export let blobC7: any;
export let blobC6: any;
export let blobC3A: any;

export let blobGeoJson: any;
export let blobShp: any;
export let siren_cible = "000";

export const isOpenC6gcblo = ref(false);
export const isOpenDFTgcblo = ref(false);
export const isOpenAlertPath = ref(false);
export const isOpenArrangePath = ref(false);
export const isOpenRapportBlo = ref(false);

export const pathEC = ref(true);
export const chambresEC = ref(true);
export const conduitesEC = ref(true);
export const traceEC = ref(true);
export const titreChambre = ref("Attente");
export const titreConduites = ref("Attente");
export const titreTrace = ref("Attente");
export const titrePath = ref("Calcul du chemin en cours..");


export const encoursc6Dft = ref(false);
export const encoursc7Dft = ref(false);
export const encoursc4Dft = ref(false);
export const encoursFichesDft = ref(false);
export const encoursc3b = ref(false);
export const encoursPlanDft = ref(false);

export const encoursc6 = ref(false);
export const encoursc7 = ref(false);
export const encoursc4 = ref(false);
export const encoursc3a = ref(false);
export const encoursPlan = ref(false);
export const encoursGJSON = ref(false);
export const encoursFiches = ref(false);
export const encoursc6titre = ref("Attente");
export const encoursc7titre = ref("Attente");
export const encoursc4titre = ref("Attente");
export const encoursc3atitre = ref("Attente");
export const encoursPlantitre = ref("Attente");
export const encoursFichesTitre = ref("Attente");
export const encoursPlanGtitre = ref("Attente");
export const comptageC6 = ref(0);
export const comptageC7 = ref(0);
export const comptageC3A = ref(0);
export const comptageCorrection = ref(0);

//Cable par noms
export const tableauCable = ref();
export const tableauCommande = ref();

//DFT parcours
export const retourArriere = ref(false)
export const indexParcours = ref(0);

//GCBLO Cables
export const inseeCommande = ref("")
export const fciCommande = ref("");
export const nomCommande = ref("");
export const departCommande = ref("");
export const arriveeCommande = ref("");
export const alveole = ref("");
export const capacite = ref("");
export const apbo = ref("");
export const bpbo = ref("");
export const commentaireAPBO = ref("");
export const commentaireBPBO = ref("");
export const commentaire = ref("");
export const idCommande = ref("");

export const commandeTable = ref([
  {
    _id: "String", //aléatoire
    id: "String", //aléatoire
    depart: [], //chambre ou appui de départ
    arrivee: [], //chambre ou appui d'arrivée
    longueur: "String",
    diametre: "String", //diametre du cable
    alveole: "String", //diametre alveole 28 33 45 60 80 100 150 - spéciaux transition
    capacite: "String", //combien de fibres dans le cable
    apbo: "String", //Equipement dans le depart
    bpbo: "String", //Equipement dans l'arrivee
    commentaire: "String",
    precision: "SAINTREMYDEPROVENCE_PM06_AER14_MC", //Nom de la commande - PARADOU_PM08_SOUT_MC
    insee: "String",
    siren: "String",
    fci: "F12345070623",
    etat: "RNR", // CEV: Commande En Cours de validation - CV: Commande Validée - TEV: Travaux En Cours de validation - TV: Travaux Validés
    nature: "String", //Massif Complexe ou du Massif Simple - Ponctuelle Complexe ou Ponctuelle Simple
    retard: false, //Boolean pour Travaux en retard
    coordinates: [],
    user_creation: "",
  },
]);

interface FeatureS {
  type: string;
  DEPART: string;
  ARRIVEE: string;
  properties: {
    CODE_CH1: string;
    NUM_APPUI: string;
  };
  geometry: {
    type: string;
    coordinates: any[];
  };
}

interface FeatureShpApp {
  type: string;
  properties: {
    NOM: any;
    SUIVANT: any;
    BOITIER: any;
    REMPLACEMENT: any;
    TYPE: any;
  };
  geometry: {
    type: string;
    coordinates: any[];
  };
}

export const filtreCommande = ref("TOUS");


// Écoute les erreurs globales non capturées
const normalizeMessage = (value: any) => {
  try {
    return (value || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  } catch {
    return (value || "").toString().toLowerCase();
  }
};

const shouldCopyGenericError = (message: string) => {
  const normalized = normalizeMessage(message);
  return normalized.includes("erreur non repertoriee");
};

const copyErrorDetailToClipboard = async (detail: string) => {
  if (!detail) return;
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(detail);
      return;
    }
  } catch {
    // Fall through to legacy copy
  }
  try {
    const textarea = document.createElement("textarea");
    textarea.value = detail;
    textarea.setAttribute("readonly", "true");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  } catch (err) {
    console.warn("[clipboard] copy failed", err);
  }
};
window.addEventListener('error', function(event) {
  alert(`Erreur : ${event.message}\nSource : ${event.filename}\nLigne : ${event.lineno}\nColonne : ${event.colno}`);
});

// Écoute les rejets de promesses non gérés
window.addEventListener('unhandledrejection', function(event) {
  const reason = event?.reason?.toString?.() || "";
  const fallback = () => {
    messageAlerte.value = `Erreur non répertoriée`;
    messageAlerte2.value = reason;
    setOpen(true);
    if (shouldCopyGenericError(messageAlerte.value)) {
      copyErrorDetailToClipboard(reason);
    }
  };
  if (!reason) {
    fallback();
    return;
  }
  fetch(`${prodEnvironment.baseUrl}api/erreurs/resolve`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ reason }),
  })
    .then(async (res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const payload = await res.json();
      const msg = payload?.message || `Erreur non répertoriée`;
      const detail = payload?.detail || reason;
      messageAlerte.value = msg;
      messageAlerte2.value = detail;
      setOpen(true);
      if (shouldCopyGenericError(messageAlerte.value)) {
        copyErrorDetailToClipboard(reason);
      }
    })
    .catch(() => fallback());
});


watch(filtreCommande, (newValue, oldValue) => {
  filtrerCommande(newValue);
});

export async function ouvrirRapport(cmd: any) {
  const precision = typeof cmd === "string" ? cmd : cmd?.precision;
  const rawId = typeof cmd === "object" ? (cmd?._id || cmd?.id || cmd?.mongoId || cmd?.commande_id) : null;
  const cmdId = typeof rawId === "string" && /^[0-9a-fA-F]{24}$/.test(rawId) ? rawId : null;
  const cmdPrecision = precision || (typeof cmd === "object" ? cmd?.precision : "");
  const cmdFci = typeof cmd === "object" ? cmd?.fci || "" : "";
  const cmdEtat = typeof cmd === "object" ? cmd?.etat || "" : "";
  // Mémorise l'ObjectId de la commande pour les exports (shapefile, zip, etc.)
  idCommande.value = cmdId || "";

  let payload: any = null;

  // Essaye par commandeId pour récupérer les câbles
  if (cmdId) {
    try {
      const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/get/commande/id/${cmdId}`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      if (res.ok) {
        payload = await res.json();
      }
    } catch (e) {
      console.error("[ouvrirRapport] fetch cables by id failed", e);
    }
  }

  // Fallback par precision si besoin
  if (!payload && precision) {
    try {
      const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/get/commande/${precision}`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      if (res.ok) {
        payload = await res.json();
      }
    } catch (e) {
      console.error("[ouvrirRapport] fetch cables by precision failed", e);
    }
  }

  const list = Array.isArray(payload) ? payload : [];
  // Harmonisation : si une commande est connue, on force precision/fci/etat issus de la commande sur les câbles
  const harmonized = list.map((c) => ({
    ...c,
    precision: cmdPrecision || c.precision,
    fci: cmdFci || c.fci,
    etat: cmdEtat || c.etat,
  }));

  tableauCommande.value = harmonized;
  const first = tableauCommande.value[0] || {};
  nomCommande.value = cmdPrecision || first.precision || "";
  fciCommande.value = cmdFci || first.fci || "";
  if (tableauCommande.value.length) {
    isOpenRapportBlo.value = true;
  }
  return tableauCommande;
}

export async function getCommandeTable() {
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/gcblo/get/commandes`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  commandeTable.value = await response.json();
  return await commandeTable;
}

/** True si modepose / alvéole indique une pose aérienne (AER, aérien…). */
export function isPoseAerienne(hint?: string | null): boolean {
  if (hint == null || hint === "") return false;
  const s = String(hint)
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return s === "AER" || s === "AERIEN" || s.includes("AERIEN");
}

/** Diamètre ingénierie souterrain (FO → mm). */
export function ingenierieDiametre(capacite: string | null) {
  if (capacite === null) {
    return "1";
  }
  let diametre = "1";
  switch (String(capacite)) {
    case "12":
      diametre = "6";
      break;
    case "24":
    case "36":
      diametre = "7";
      break;
    case "48":
      diametre = "9";
      break;
    case "72":
      diametre = "11";
      break;
    case "96":
      diametre = "12.5";
      break;
    case "144":
      diametre = "13";
      break;
    case "288":
      diametre = "14";
      break;
    case "432":
      diametre = "15.5"; // 15,2 arrondi
      break;
    case "576":
      diametre = "17"; // 16,7 arrondi
      break;
    case "720":
      diametre = "18";
      break;
  }
  return diametre;
}

/**
 * Diamètre ingénierie aérien CAP-FT (FO → mm arrondi).
 * Aligné L1092-12-P / 13-P / 14-P / L1048 / L1092-15-P.
 */
export function ingenierieDiametreAerien(capacite: string | null) {
  if (capacite === null) {
    return "1";
  }
  switch (String(capacite)) {
    case "12":
      return "8";
    case "24":
    case "36":
      return "10"; // 9,6 → 10
    case "48":
    case "72":
      return "12.5"; // 12,4 → 12,5
    case "96":
    case "144":
      return "14.5";
    default:
      return "1";
  }
}

/** Capacité depuis diamètre souterrain (mm → FO). Inclut d’anciens diamètres pour rétrocompat. */
export function ingenierieCapacite(diametre: string | null) {
  if (diametre === null) {
    return "12";
  }
  let capacite = "?";

  switch (String(diametre)) {
    case "6":
      capacite = "12";
      break;
    case "7":
      capacite = "24"; // 24 et 36 FO partagent 7 mm
      break;
    case "8":
      capacite = "24";
      break;
    case "8.5":
      capacite = "36";
      break;
    case "9":
      capacite = "48";
      break;
    case "9.5":
      capacite = "48";
      break;
    case "10.5":
      capacite = "72";
      break;
    case "11":
      capacite = "72";
      break;
    case "11.5":
      capacite = "144";
      break;
    case "12.5":
      capacite = "96";
      break;
    case "13":
      capacite = "144";
      break;
    case "14":
      capacite = "288";
      break;
    case "15.5":
      capacite = "432";
      break;
    case "16.5":
      capacite = "576";
      break;
    case "17":
      capacite = "576";
      break;
    case "18":
      capacite = "720";
      break;
  }

  return capacite;
}

/** Capacité depuis diamètre aérien CAP-FT (mm → FO). */
export function ingenierieCapaciteAerien(diametre: string | null) {
  if (diametre === null) {
    return "12";
  }
  switch (String(diametre)) {
    case "8":
      return "12";
    case "9.4":
    case "9.5":
    case "9.6":
    case "10":
      return "24"; // 24 et 36 FO
    case "12":
    case "12.4":
    case "12.5":
      return "48"; // 48 et 72 FO
    case "14.5":
      return "144"; // 96 et 144 FO
    default:
      return "?";
  }
}

/** Choisit la table souterrain / aérien selon modepose ou alvéole. */
export function ingenierieDiametrePourPose(
  capacite: string | null,
  poseHint?: string | null
) {
  return isPoseAerienne(poseHint)
    ? ingenierieDiametreAerien(capacite)
    : ingenierieDiametre(capacite);
}

export function ingenierieCapacitePourPose(
  diametre: string | null,
  poseHint?: string | null
) {
  return isPoseAerienne(poseHint)
    ? ingenierieCapaciteAerien(diametre)
    : ingenierieCapacite(diametre);
}

export function ingenierieExtremites(composition: string | null) {
  if (composition == "adduction") {
    return 1;
  }

  if (composition === null) {
    return 1;
  }

  if (composition.includes("Ø")) {
    return composition.split("Ø")[0]
  }
  if (composition.includes("Ã˜")) {
    return composition.split("Ã˜")[0]
  }
  return 0;
}

export function ingenierieComposition(composition: string | null, fullSout?: boolean) {
  if (composition.toLowerCase() == "adduction" || composition.toLowerCase().includes("add")) {
    return "adduction";
  }

  if (composition.toLowerCase() == "transition" || composition.toLowerCase().includes("tra")) {
    return "transition";
  }


  if (composition === null && fullSout === false) {
    return "AER";
  }

  if (composition === null && fullSout === true) {
    return "45";
  }

  // Extract numbers from the string using regular expression
  const numbers = composition.match(/\b(?:28|33|45|60|77|75|80|100|150)\b/g);
  let alveole = "AER";

  if (numbers && numbers.length > 0) {
    // Convert the matched numbers to integers
    const integerNumbers = numbers.map(Number);

    // Find the smallest number
    const smallestNumber = Math.min(...integerNumbers);
    alveole = smallestNumber.toString();

    // Handle specific cases
    switch (smallestNumber) {
      case 28:
      case 33:
        alveole = "45";
        break;
      case 77:
        alveole = "80";
        break;
      case 75:
          alveole = "80";
        break;
      // Add more cases as needed
      default:
        break;
    }
  }

  if (alveole === "AER" && fullSout === true) {
    return "45";
  }

  return alveole;
}

export function convertMultiLineStringToLineString(
  featureCollection: FeatureCollection<MultiLineString>
): FeatureCollection<LineString> {
  const lineStrings: Feature<LineString>[] = [];

  featureCollection.features.forEach((feature) => {
    if (feature.geometry && feature.geometry.type === "MultiLineString") {
      // Convert each MultiLineString to LineString
      const coordinates = feature.geometry.coordinates.flat();
      const lineString: Feature<LineString> = {
        type: "Feature",
        properties: feature.properties,
        geometry: {
          type: "LineString",
          coordinates,
        },
      };
      lineStrings.push(lineString);
    }
  });

  return {
    type: "FeatureCollection",
    features: lineStrings,
  };
}

export function snapConduite(coord1: any, coord2: any) {
  const point1 = point(coord1);
  const point2 = point(coord2);
  const chambreAppuisArcep = [
    ...(chambresActif?.features || []),
    ...(appuisActif?.features || []),
    ...(immeubleActif?.features || []),
  ];

  const geojson = {
    type: "FeatureCollection" as const, // Use 'as const' to narrow down the type to the literal "FeatureCollection"
    features: chambreAppuisArcep,
  };
  //console.log('GEO pour nearest', geojson)

  const nearest = nearestPoint(point1, geojson);
  const nearest2 = nearestPoint(point2, geojson);
  return [nearest, nearest2];
}

export function extremitesConduites(coord1: any, thresholdInMeters: number) {
  //console.log(coord1);
  const point1 = point(coord1);
  let nearest = nearestPoint(point1, chambresActif);
  const distanceInMeters: number = distance(point1, nearest, {
    units: "meters",
  });
  if (distanceInMeters <= thresholdInMeters) {
    return nearest.properties.CODE_CH2 + "/" + nearest.properties.CODE_CH1;
  }
  nearest = nearestPoint(point1, appuisActif);
  const distanceInMeters2: number = distance(point1, nearest, {
    units: "meters",
  });
  if (distanceInMeters2 <= thresholdInMeters) {
    return inseeActif + "/" + nearest.properties.NUM_APPUI.replace(/^0+/, "");
  }
  nearest = nearestPoint(point1, immeubleActif);
  const distanceInMeters3: number = distance(point1, nearest, {
    units: "meters",
  });
  if (distanceInMeters3 <= thresholdInMeters) {
    return "adduction";
  }
}

export function extremitesConduitesAsObject(
  coord1: any,
  thresholdInMeters: number
) {
  //console.log(coord1);
  const point1 = point(coord1);
  let nearest = nearestPoint(point1, chambresActif);
  const distanceInMeters: number = distance(point1, nearest, {
    units: "meters",
  });
  if (distanceInMeters <= thresholdInMeters) {
    //console.log(nearest)
    nearest.properties.TYPE = "chambre";
    return nearest;
  }
  nearest = nearestPoint(point1, appuisActif);
  const distanceInMeters2: number = distance(point1, nearest, {
    units: "meters",
  });
  if (distanceInMeters2 <= thresholdInMeters) {
    nearest.properties.TYPE = "appui";
    return nearest;
  }
  nearest = nearestPoint(point1, immeubleActif);
  const distanceInMeters3: number = distance(point1, nearest, {
    units: "meters",
  });
  if (distanceInMeters3 <= thresholdInMeters) {
    nearest.properties.TYPE = "immeuble";
    return nearest;
  }
}

export async function geojsonPathFinder(collection: any, A: any, B: any) {
  const lineStringFeatureCollection =
    convertMultiLineStringToLineString(collection);
  const pathFinder = new PathFinder(lineStringFeatureCollection);
  const path = pathFinder.findPath(A, B);
  return path;
}

export async function pathToArray(
  collection2: any,
  path: any,
  mesChambres: any[]
) {
  path?.path.forEach((segment: any) => {
    const point1 = point(segment);
    const nearest = nearestPoint(point1, collection2);
    const distanceInMeters: number = distance(point1, nearest, {
      units: "meters",
    });
    const thresholdInMeters = 0.5;
    if (
      distanceInMeters <= thresholdInMeters &&
      !mesChambres.includes(nearest.properties.CODE_CH1)
    ) {
      mesChambres.push(nearest);
    }
    if (
      distanceInMeters <= thresholdInMeters &&
      !mesChambres.includes(nearest.properties.NUM_APPUI)
    ) {
      mesChambres.push(nearest);
    }
  });
  return mesChambres;
}

export async function arrayToGeojson(
  collection: any,
  mesChambres: any[],
  matchingMultiLineStrings: any[]
) {
  collection.features.forEach(
    (feature: {
      properties: { COMPOSITIO: string; NUM_APPUI: string; SHAPE_LEN: any };
      geometry: { type: string; coordinates: any[] };
    }) => {
      const referencePoint1 = point([
        feature.geometry.coordinates[0][0][0],
        feature.geometry.coordinates[0][0][1],
      ]);
      const referencePoint2 = point([
        feature.geometry.coordinates[0][
        feature.geometry.coordinates[0].length - 1
        ][0],
        feature.geometry.coordinates[0][
        feature.geometry.coordinates[0].length - 1
        ][1],
      ]);
      const obj = {
        properties: {
          COMMANDE: "",
          FCI: "",
          ARRIVEE: "",
          DEPART: "",
          ALVEOLE: "",
          LONGUEUR: "",
        },
        entite_a: {},
        entite_b: {},
        geometry: {},
      };
      mesChambres.forEach((chambre: any) => {
        const distanceInMeters: number = distance(referencePoint1, chambre, {
          units: "meters",
        });
        if (distanceInMeters < 0.5) {
          obj.properties.DEPART =
            chambre.properties.CODE_CH2 + "/" + chambre.properties.CODE_CH1;
          obj.geometry = feature.geometry;
          obj.entite_a = chambre;
        }
        const distanceInMeter2: number = distance(referencePoint2, chambre, {
          units: "meters",
        });
        if (distanceInMeter2 < 0.5) {
          obj.properties.ARRIVEE =
            chambre.properties.CODE_CH2 + "/" + chambre.properties.CODE_CH1;
          obj.entite_b = chambre;
        }
      });
      if (obj.properties.ARRIVEE != "" && obj.properties.DEPART != "") {
        obj.properties.ALVEOLE = ingenierieComposition(
          feature.properties.COMPOSITIO
        );
        obj.properties.COMMANDE = nomCommande.value;
        obj.properties.FCI = fciCommande.value;
        obj.properties.LONGUEUR = feature.properties.SHAPE_LEN;

        matchingMultiLineStrings.push(obj);
      }
    }
  );
  const finalGeoJSON3 = {
    type: "FeatureCollection",
    features: matchingMultiLineStrings,
  };
  //console.log(finalGeoJSON3)
  //console.log(mesChambres)

  // Dictionnaire pour compter les occurrences de chaque point
  const pointCount: { [key: string]: number } = mesChambres.reduce((acc, point) => {
    acc[point.properties.CODE_CH1] = 0;
    return acc;
  }, {} as { [key: string]: number });

  const filteredLinestrings = [];
  for (const linestring of matchingMultiLineStrings) {
    const entite_a = linestring.entite_a.properties.CODE_CH1;
    const entite_b = linestring.entite_b.properties.CODE_CH1;

    if (pointCount[entite_a] < 2 && pointCount[entite_b] < 2) {
        filteredLinestrings.push(linestring);
        pointCount[entite_a]++;
        pointCount[entite_b]++;
    }
  }
  
  //console.log(filteredLinestrings);
  const finalGeoJSON3B = {
    type: "FeatureCollection",
    features: filteredLinestrings,
  };
  ajouterSource(finalGeoJSON3B, "chemin");
  
  ajouterCouche("chemin");
  return finalGeoJSON3;
}

// export function findShortestPath(collection: any, A: any, B: any, collection2: any, collection3: any) {
//   return true;
// }

export function reverseCoordinatesOrder(coordinates: number[][]): number[][] {
  const reversedCoordinates = coordinates.slice().reverse();
  return reversedCoordinates;
}

export type ChambresEnvironsResult = {
  propositions: any[];
  propositions_conduite: any[];
  error?: { title: string; message: string };
};

type ObjetContext = { kind: "chambre" | "appui" | "conduite" | "point"; code: string };

/** Libellé français « La chambre X », « L'appui Y », etc. à partir des propriétés PIT / fiche. */
export function resolveObjetContext(source: unknown): ObjetContext {
  const props = (source as { properties?: Record<string, unknown> })?.properties
    ?? (source as Record<string, unknown>)
    ?? {};

  if (props.NUM_APPUI) {
    return { kind: "appui", code: String(props.NUM_APPUI).trim() || "?" };
  }
  const codeCh1 = props.CODE_CH1 != null ? String(props.CODE_CH1).trim() : "";
  if (codeCh1 && codeCh1 !== "A" && codeCh1 !== "terminer") {
    return { kind: "chambre", code: codeCh1 };
  }
  if (props.CODE_COND) {
    return { kind: "conduite", code: String(props.CODE_COND).trim() || "?" };
  }
  if (props.COMPOSITIO) {
    return { kind: "conduite", code: String(props.COMPOSITIO).trim() || "?" };
  }
  if (props.label) {
    return { kind: "point", code: String(props.label).trim() || "?" };
  }
  if (props.id) {
    return { kind: "point", code: String(props.id).trim() || "?" };
  }
  return { kind: "point", code: "?" };
}

export function objetArticleLabel(ctx: ObjetContext): string {
  switch (ctx.kind) {
    case "appui":
      return `L'appui ${ctx.code}`;
    case "conduite":
      return `La conduite ${ctx.code}`;
    case "chambre":
      return `La chambre ${ctx.code}`;
    default:
      return `Le point technique ${ctx.code}`;
  }
}

function isValidLngLat(coord: unknown): coord is [number, number] {
  if (!Array.isArray(coord) || coord.length < 2) return false;
  const lng = Number(coord[0]);
  const lat = Number(coord[1]);
  return Number.isFinite(lng) && Number.isFinite(lat);
}

function isValidTurfPointFeature(feature: unknown): feature is Feature {
  if (!feature || typeof feature !== "object") return false;
  const geom = (feature as Feature).geometry;
  return geom?.type === "Point" && isValidLngLat(geom.coordinates);
}

/** Extrait les sommets d'une conduite (LineString ou 1er tronçon MultiLineString). */
export function getConduiteLineCoords(geometry: {
  type?: string;
  coordinates?: unknown;
}): [number, number][] | null {
  if (!geometry?.coordinates || !Array.isArray(geometry.coordinates)) return null;

  if (geometry.type === "LineString") {
    const line = geometry.coordinates as unknown[];
    if (line.length < 2) return null;
    const out: [number, number][] = [];
    for (const c of line) {
      if (!isValidLngLat(c)) return null;
      out.push([c[0], c[1]]);
    }
    return out;
  }

  if (geometry.type === "MultiLineString") {
    const parts = geometry.coordinates as unknown[];
    if (!parts.length || !Array.isArray(parts[0])) return null;
    return getConduiteLineCoords({
      type: "LineString",
      coordinates: parts[0],
    });
  }

  return null;
}

export function pitChambresConduitesReady(objetLabel?: string): {
  ok: boolean;
  title: string;
  message: string;
} {
  const chambreCount = chambresActif?.features?.length ?? 0;
  const conduiteCount = conduiteActif?.features?.length ?? 0;
  const depuis = objetLabel ? ` pour ${objetLabel}` : "";

  if (!chambreCount) {
    return {
      ok: false,
      title: "PIT non chargé",
      message:
        `Les chambres du PIT ne sont pas disponibles${depuis}. Attendez la fin du chargement du PIT (couche Chambres visible sur la carte), puis rouvrez la fiche.`,
    };
  }
  if (!conduiteCount) {
    return {
      ok: false,
      title: "Conduites manquantes",
      message:
        `Les conduites du PIT ne sont pas chargées${depuis}. Rechargez le PIT pour cette commune avant de tracer un câble.`,
    };
  }
  return { ok: true, title: "", message: "" };
}

/** `coord` attendu : « latitude, longitude » (comme la fiche chambre). */
export function parseChambreCoordLatLng(coord: string): [number, number] | null {
  const parts = String(coord || "")
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length < 2) return null;
  const lat = parseFloat(parts[0]);
  const lng = parseFloat(parts[1]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return [lng, lat];
}

async function showCablePathAlert(header: string, message: string): Promise<void> {
  const alert = await alertController.create({
    header,
    message,
    buttons: ["OK"],
  });
  await alert.present();
}

function resolveNearestChambre(fromLngLat: [number, number]): Feature | null {
  const hit = nearestPoint(point(fromLngLat), chambresActif);
  return isValidTurfPointFeature(hit) ? hit : null;
}

function safeDistanceMeters(from: unknown, to: unknown): number | null {
  if (!isValidTurfPointFeature(from) && !isValidLngLat(from)) return null;
  if (!isValidTurfPointFeature(to) && !isValidLngLat(to)) return null;
  try {
    const d = distance(from as any, to as any, { units: "meters" });
    return Number.isFinite(d) ? d : null;
  } catch {
    return null;
  }
}

export async function cableRapide(coord: string, first: any) {
  const departCtx = resolveObjetContext(first);
  const departLabel = objetArticleLabel(departCtx);

  const pit = pitChambresConduitesReady(departLabel);
  if (!pit.ok) {
    await showCablePathAlert(pit.title, pit.message);
    return false;
  }

  const originLngLat = parseChambreCoordLatLng(coord);
  if (!originLngLat) {
    const coordAffiche = String(coord || "").trim() || "non renseignées";
    await showCablePathAlert(
      "Coordonnées invalides",
      `${departLabel} n'a pas de coordonnées correctes (${coordAffiche}). Fermez la fiche, recliquez l'objet sur la carte, puis réessayez.`
    );
    return false;
  }

  const listeDeChambres: any[] = [];
  const listeDeConduites: any[] = [];
  listeDeChambres.push(first);
  let continueRunning = true;
  let maProchaineCible = {
    properties: { CODE_CH1: "A" },
    geometry: { coordinates: [] },
  };
  const monAncienneCible = {
    properties: { CODE_CH1: "A" },
    geometry: { coordinates: [] },
  };
  let nearest: Feature | null = null;
  while (continueRunning) {
    //console.log(maProchaineCible);
    let maCapa: any;
    if (maProchaineCible.properties.CODE_CH1 == "A") {
      maProchaineCible.properties.CODE_CH1 = first.properties.CODE_CH1;
      nearest = resolveNearestChambre(originLngLat);
    } else {
      const parsed = maProchaineCible;
      const coords = parsed.geometry?.coordinates;
      const cibleCtx = resolveObjetContext(parsed);
      const cibleLabel = objetArticleLabel(cibleCtx);
      if (!isValidLngLat(coords)) {
        await showCablePathAlert(
          "Coordonnées invalides",
          `${cibleLabel} n'a pas de coordonnées correctes sur la carte.`
        );
        return false;
      }
      nearest = resolveNearestChambre([coords[0], coords[1]]);
    }

    const refCtx =
      maProchaineCible.properties.CODE_CH1 === "A"
        ? departCtx
        : resolveObjetContext(maProchaineCible);
    const refLabel = objetArticleLabel(refCtx);

    if (!nearest?.properties?.CODE_CH1) {
      await showCablePathAlert(
        "Objet introuvable sur le PIT",
        `Impossible de rattacher ${refLabel} à une entrée du PIT. Vérifiez que le PIT est chargé pour la bonne commune et que l'objet est visible sur la carte.`
      );
      return false;
    }

    const propositions = chambresEnvirons(nearest);
    if (propositions.error) {
      await showCablePathAlert(propositions.error.title, propositions.error.message);
      return false;
    }

    let actionSheetPropositions: { text: any; role: any; data: any }[] = [];

    propositions.propositions.forEach((proposition) => {
      let texte = proposition.properties.CODE_CH1;
      if (
        proposition.properties.CODE_CH1 == monAncienneCible.properties.CODE_CH1
      ) {
        texte = proposition.properties.CODE_CH1 + " (précédente)";
      }
      actionSheetPropositions.push({
        text: texte,
        role: proposition.properties.CODE_CH1,
        data: {
          DEPART: monAncienneCible.properties.CODE_CH1,
          ARRIVEE: proposition.properties.CODE_CH1,
          proposition: proposition,
          conduite:
            propositions.propositions_conduite[
            propositions.propositions.indexOf(proposition)
            ],
        },
      });
    });
    actionSheetPropositions.push({
      text: "Terminer",
      role: "terminer",
      data: {
        proposition: {
          properties: { CODE_CH1: "terminer", DEPART: "", ARRIVEE: "" },
          geometry: { coordinates: [] },
        },
        conduite: {
          properties: { CODE_CH1: "terminer", DEPART: "", ARRIVEE: "" },
          geometry: { coordinates: [] },
        },
      },
    });
    monAncienneCible.properties.CODE_CH1 = nearest.properties.CODE_CH1;

    const uniquePropositions = {};
    actionSheetPropositions.forEach((proposition) => {
      if (!uniquePropositions[proposition.role]) {
        uniquePropositions[proposition.role] = proposition;
      }
    });

    actionSheetPropositions = Object.values(uniquePropositions);

    const liaisonCount = actionSheetPropositions.filter(
      (p) => p.role !== "terminer"
    ).length;
    if (liaisonCount === 0) {
      const ctx = resolveObjetContext(nearest);
      const label = objetArticleLabel(ctx);
      await showCablePathAlert(
        "Aucune liaison trouvée",
        `Aucune conduite ne relie ${label} à une chambre voisine (extrémités à moins de 2 m). Vérifiez que le PIT est à jour pour cette commune, ou choisissez une autre chambre de départ.`
      );
      return false;
    }

    const dataCible = await choixDePropositions(
      actionSheetPropositions,
      propositions
    );
    maProchaineCible = dataCible.proposition;
    //console.log(dataCible.conduite)
    //console.log(dataCible.DEPART)
    dataCible.conduite.properties.DEPART = dataCible.DEPART;
    dataCible.conduite.properties.ARRIVEE = dataCible.ARRIVEE;

    //console.log(maProchaineCible);
    if (maProchaineCible.properties.CODE_CH1 == "terminer") {
      continueRunning = false;
      const actionSheetCapacites: { text: any; role: any; data: any }[] = [];
      actionSheetCapacites.push({
        text: "12fo",
        role: "12",
        data: "6", //6
      });
      actionSheetCapacites.push({
        text: "24fo",
        role: "24",
        data: "7", //7
      });
      actionSheetCapacites.push({
        text: "36fo",
        role: "36",
        data: "8.5", //8,5
      });
      actionSheetCapacites.push({
        text: "48fo",
        role: "48",
        data: "9", //9
      });
      actionSheetCapacites.push({
        text: "72fo",
        role: "72",
        data: "10.5", //10,5
      });
      actionSheetCapacites.push({
        text: "96fo",
        role: "96",
        data: "96", //11
      });
      actionSheetCapacites.push({
        text: "144fo",
        role: "144",
        data: "11.5", //11,5
      });
      actionSheetCapacites.push({
        text: "288fo",
        role: "288",
        data: "14", //14
      });
      actionSheetCapacites.push({
        text: "576fo",
        role: "576",
        data: "16.5", //16,5
      });
      actionSheetCapacites.push({
        text: "720fo",
        role: "720",
        data: "17.5", //17,5
      });
      maCapa = await choixDeCapacite(actionSheetCapacites, propositions);
      listeDeConduites.map((chambre) => {
        chambre.properties.capacite = maCapa;
        chambre.properties.FCI = fciCommande.value;
        chambre.properties.COMMANDE = nomCommande.value;
      });
    } else {
      listeDeConduites.push(dataCible.conduite);
      listeDeChambres.push(dataCible.proposition);
    }
  }
  if (listeDeConduites.length + 1 === listeDeChambres.length) {
    for (let index = 0; index < listeDeConduites.length; index++) {
      const departChambre = listeDeChambres[index].properties.CODE_CH1;
      const arriveeChambre = listeDeChambres[index + 1].properties.CODE_CH1;

      listeDeConduites[index].properties.DEPART = departChambre;
      listeDeConduites[index].properties.ARRIVEE = arriveeChambre;

      //console.log(`DEPART: ${departChambre}, ARRIVEE: ${arriveeChambre}`);
    }
  } else {
    console.error("Arrays have incompatible lengths");
  }

  tableauCable.value = {
    chambres: listeDeChambres,
    conduites: listeDeConduites,
  };
  return true;
}

export function conduitesEnvirons(mesChambres: any) {
  const propositions: any[] = [];
  mesChambres.forEach((nearest: any) => {
    conduiteActif.features.forEach(
      (feature: {
        properties: { CODE_CH1: string; NUM_APPUI: string };
        geometry: { type: string; coordinates: any[] };
      }) => {
        const dist1 = distance(nearest, feature.geometry.coordinates[0][0], {
          units: "meters",
        });
        if (dist1 < 5) {
          propositions.push(feature);
        }
        const dist2 = distance(
          nearest,
          feature.geometry.coordinates[0][
          feature.geometry.coordinates[0].length - 1
          ],
          { units: "meters" }
        );
        if (dist2 < 5) {
          propositions.push(feature);
        }
      }
    );
  });
  return propositions;
}

export function elementsEnvirons(nearest: any) {
  let compteur = 0;
  const propositions: any[] = [];
  const propositions_conduite: any[] = [];
  //console.log(nearest)

  conduiteActif.features.forEach(
    (feature: {
      properties: { CODE_CH1: string; NUM_APPUI: string };
      geometry: { type: string; coordinates: any[] };
    }) => {
      compteur++;

      const extremite_1 = extremitesConduitesAsObject(
        feature.geometry.coordinates[0][0],
        1
      );
      const extremite_2 = extremitesConduitesAsObject(
        feature.geometry.coordinates[0][
        feature.geometry.coordinates[0].length - 1
        ],
        1
      );

      if (
        JSON.stringify(extremite_1?.geometry) ===
        JSON.stringify(nearest.geometry) &&
        extremite_2 != undefined &&
        JSON.stringify(extremite_2.geometry) !==
        JSON.stringify(nearest.geometry)
      ) {
        //console.log(extremite_1, extremite_2)
        propositions.push(extremite_2);
        propositions_conduite.push(feature);
      }
      if (
        JSON.stringify(extremite_2?.geometry) ===
        JSON.stringify(nearest.geometry) &&
        extremite_1 != undefined &&
        JSON.stringify(extremite_1?.geometry) !==
        JSON.stringify(nearest.geometry)
      ) {
        //console.log(extremite_2, extremite_1)
        propositions.push(extremite_1);
        propositions_conduite.push(feature);
      }
    }
  );
  const objet = {
    propositions: propositions,
    propositions_conduite: propositions_conduite,
  };
  return objet;
}

export function chambresEnvirons(nearest: any): ChambresEnvironsResult {
  const empty: ChambresEnvironsResult = {
    propositions: [],
    propositions_conduite: [],
  };

  const ctxHint = resolveObjetContext(nearest);
  const hintLabel = ctxHint.code !== "?" ? objetArticleLabel(ctxHint) : undefined;
  const pit = pitChambresConduitesReady(hintLabel);
  if (!pit.ok) {
    return { ...empty, error: { title: pit.title, message: pit.message } };
  }

  if (!isValidTurfPointFeature(nearest)) {
    const ctx = resolveObjetContext(nearest);
    const label = objetArticleLabel(ctx);
    return {
      ...empty,
      error: {
        title: `${label} : position invalide`,
        message: `${label} n'a pas de position exploitable sur la carte. Rechargez le PIT, fermez puis rouvrez la fiche.`,
      },
    };
  }

  const propositions: any[] = [];
  const propositions_conduite: any[] = [];

  for (const feature of conduiteActif.features) {
    if (feature.properties?.COMPOSITIO == null) {
      continue;
    }

    const line = getConduiteLineCoords(feature.geometry);
    if (!line || line.length < 2) {
      continue;
    }

    const start = line[0];
    const end = line[line.length - 1];

    let nearest1: Feature = nearest;
    let nearest2: Feature = nearest;

    const dist1 = safeDistanceMeters(nearest, start);
    if (dist1 == null) continue;

    if (dist1 < 2) {
      const referencePoint2 = point(end);
      const hit2 = nearestPoint(referencePoint2, chambresActif);
      if (isValidTurfPointFeature(hit2)) {
        const verifDist = safeDistanceMeters(hit2, end);
        if (verifDist != null && verifDist <= 2) {
          nearest2 = hit2;
        }
      }
    }

    const dist2 = safeDistanceMeters(nearest, end);
    if (dist2 == null) continue;

    if (dist2 < 2) {
      const referencePoint1 = point(start);
      const hit1 = nearestPoint(referencePoint1, chambresActif);
      if (isValidTurfPointFeature(hit1)) {
        const verifDist = safeDistanceMeters(hit1, start);
        if (verifDist != null && verifDist <= 2) {
          nearest1 = hit1;
        }
      }
    }

    if (
      nearest1.properties?.CODE_CH1 == nearest.properties?.CODE_CH1 &&
      nearest2.properties?.CODE_CH1 != nearest.properties?.CODE_CH1
    ) {
      propositions.push(nearest2);
      propositions_conduite.push(feature);
    }
    if (
      nearest2.properties?.CODE_CH1 == nearest.properties?.CODE_CH1 &&
      nearest1.properties?.CODE_CH1 != nearest.properties?.CODE_CH1
    ) {
      propositions.push(nearest1);
      propositions_conduite.push(feature);
    }
    if (
      nearest2.properties?.CODE_CH1 == nearest.properties?.CODE_CH1 &&
      nearest1.properties?.CODE_CH1 != nearest.properties?.CODE_CH1
    ) {
      propositions.push(nearest1);
      propositions_conduite.push(feature);
    }
  }

  return {
    propositions,
    propositions_conduite,
  };
}

export async function choixDeConduite(propositions: any) {
  const actionSheet = await actionSheetController.create({
    header: "Plusieurs conduites disponibles:",
    buttons: propositions,
  });

  await actionSheet.present();
  const { data } = await actionSheet.onDidDismiss();
  return data;
}

export async function choixDePropositions(propositions: any, chambres: any) {
  const actionSheet = await actionSheetController.create({
    header: "Chambre suivante",
    buttons: propositions,
  });

  await actionSheet.present();
  const { data } = await actionSheet.onDidDismiss();
  return data;
}

export async function choixDeCapacite(propositions: any, chambres: any) {
  const actionSheet = await actionSheetController.create({
    header: "Capacité fibre",
    buttons: propositions,
  });

  await actionSheet.present();
  const { data } = await actionSheet.onDidDismiss();
  return data;
}

export async function choixEquipementA(propositions: any, chambres: any) {
  const actionSheet = await actionSheetController.create({
    header: "Equipement A",
    buttons: propositions,
  });

  await actionSheet.present();
  const { data } = await actionSheet.onDidDismiss();
  return data;
}

export async function choixEquipementB(propositions: any, chambres: any) {
  const actionSheet = await actionSheetController.create({
    header: "Equipement B",
    buttons: propositions,
  });

  await actionSheet.present();
  const { data } = await actionSheet.onDidDismiss();
  return data;
}

export const commandeTotal = ref(0);
export const commandeTotalAll = ref(0);
export const commandeSummary = ref<{ total?: number; retard?: number; etats?: Record<string, number>; prios?: Record<string, number> }>({});

export const filtrerCommande = async (choix: any, page = 1, limit = 200, search?: string) => {
  const detailFields = [
    "precision",
    "fci",
    "etat",
    "retard",
    "prio",
    "gestionnaire",
    "soustraitant",
    "user_creation",
    "identification",
    "urgence",
    "action_crt",
    "nro",
    "sro",
    "pm",
    "statut_pm",
    "statut_nro",
    "lien_gencia",
    "date_penalite",
    "insee",
    "statut_commande",
    "statut_crt",
    "avancement",
    "fraction_avancement",
    "id_unique",
    "derniere_maj",
    "maj_precedente",
    "retour_manquant",
    "commentaire_becom",
    "retour_crt",
    "irem_in8",
    "type_commande",
    "modepose",
    "ing_foa_incomplete",
    "ing_shapes_incomplets",
    "ing_conduites_masque",
    "ing_boitier_mal_fixe",
    "ing_boitier_pied_droit",
    "ing_snake_manquant",
    "ing_photos_travaux_manquantes",
    "ing_ecart_3cm",
    "ing_percement_pied_droit",
    "ing_percement_non_identifiable",
    "ing_percement_trop_haut",
    "ing_percement_cheminee",
    "ing_in8",
    "ing_3_boitiers",
    "ing_3_fibres",
    "commande_ville",
    "elements_manquants",
    "commentaires",
    "cables_count",
    "siren",
  ];
  const params = new URLSearchParams();
  if (choix && choix !== "TOUS") {
    params.set("etat", choix);
  }
  params.set("page", String(page));
  params.set("limit", String(limit));
  params.set("fields", detailFields.join(","));
  if (search && search.trim().length >= 3) {
    params.set("search", search.trim());
  }
  const url = `${prodEnvironment.baseUrl}api/gcblo/suivi/commandes${params.toString() ? `?${params.toString()}` : ""}`;

  try {
    const res = await fetch(url, { credentials: "include" });
    if (!res.ok) {
      console.error("[filtrerCommande] Erreur HTTP", res.status, await res.text());
      return;
    }
    const payload = await res.json();
    if (payload?.tooMany) {
      // Trop de résultats côté backend, on n'affiche rien pour éviter les freezes
      commandeTotal.value = payload?.total ?? 0;
      commandeTable.value = [];
      return;
    }
    const list = Array.isArray(payload) ? payload : payload?.data || [];
    const total = Array.isArray(payload) ? list.length : payload?.total ?? list.length;
    commandeTotal.value = total;
    if (!choix || choix === "TOUS") {
      commandeTotalAll.value = total;
    }

    commandeTable.value = (list || []).map((point_technique: any) => ({
      ...point_technique,
      commentaires: Array.isArray(point_technique?.commentaires) ? point_technique.commentaires : [],
      _id:
        (point_technique?.precision && point_technique?.fci
          ? { precision: point_technique.precision, fci: point_technique.fci }
          : undefined) ??
        point_technique?._id ??
        point_technique?.id,
    }));
  } catch (err) {
    console.error("[filtrerCommande] Erreur réseau", err);
  }
};

export const fetchCommandeSummary = async () => {
  try {
    const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/suivi/commandes/summary`, {
      credentials: "include",
    });
    if (!res.ok) {
      console.error("[fetchCommandeSummary] Erreur HTTP", res.status, await res.text());
      return;
    }
    const data = await res.json();
    commandeSummary.value = data || {};
    if (typeof data?.total === "number") {
      commandeTotalAll.value = data.total;
    }
  } catch (err) {
    console.error("[fetchCommandeSummary] Erreur rǸseau", err);
  }
};

export const supprimerCommandeSuivi = async (precision: string, fci: string) => {
  if (!precision || !fci) {
    console.error("[supprimerCommandeSuivi] precision ou fci manquant");
    return;
  }
  const url = `${prodEnvironment.baseUrl}api/gcblo/suivi/commande/${encodeURIComponent(precision)}/${encodeURIComponent(fci)}`;
  try {
    const res = await fetch(url, { method: "DELETE", credentials: "include" });
    if (!res.ok) {
      console.error("[supprimerCommandeSuivi] Erreur HTTP", res.status, await res.text());
    }
  } catch (err) {
    console.error("[supprimerCommandeSuivi] Erreur réseau", err);
  }
};

export const adjustAndMoveImage = async (
  image: any,
  row: any,
  col: any,
  workbookC6: any,
  sheetRosalyna: any
) => {
  ///////////////
  //
  // Il n'existe pas de fonction de copie photo dans ExcelJS
  // Du coup 'workbook.model.media.find' est mon seul moyen d'aller chercher des images
  // Elle retourne un objet avec un buffer (nice!) et une extension avec lesquelles j'utiliserai addImage
  //
  ///////////////

  //console.log(image, " ira dans la cellule", [row, col])
  const img = workbookC6.model.media.find(
    (m: { index: any }) => m.index === image.imageId
  );
  //console.log("Image trouvée:", img); // Vérifiez que cette image a les propriétés attendues

  if (img && img.buffer) {
    const addedImageId1 = workbookC6.addImage({
      buffer: img.buffer,
      extension: img.extension,
    });

    sheetRosalyna.addImage(addedImageId1, {
      tl: { col: col - 1, row: row - 1 },
      ext: { width: 336, height: 374 },
      editAs: "oneCell",
    });

    //console.log(workbookC6.model.media)
  } else {
    //console.log("Aucune image correspondante trouvée pour l'ID:", image.imageId);
  }
};

export const downloadBlob = (blob: any, name: any) => {
  // Créer un lien de téléchargement
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

async function deleteColumnsAfterAP(worksheet: any) {
  ////////////////////////////
  //
  // Des fois Orange reproche aux C6 d'avoir des colonnes en trop (de AP jusqu'ç XY par exemple)
  // Du coup on supprime tout ce qu'il y a de la colonne 42 à 27000 pour être tranquille
  // Update: la colonne la plus lointaine XFD correspond à 16384
  //
  ////////////////////////////

  worksheet.spliceColumns(42, 16384);
  encoursc6titre.value = "Colonnes en trop supprimées. Ecriture C6..";
}

export const copyWorkSheet = async (
  worksheetCopyFrom: any,
  worksheetCopyTo: any,
  newOrder: any,
  nouveauNom?: any
) => {
  ////////////////////////////
  //
  // ExcelJS ne propose pas de fonction de copie
  // Mais j'ai trouvé le moyen en utilisant la variable model, tout est à l'intéreur
  // Le nom, les textes, les styles etc
  // J'en profite pour attribuer la position de l'onglet dans le workbook qui marche comme un array
  //
  ////////////////////////////

  //console.log("sheets", worksheetCopyFrom, worksheetCopyTo)
  //console.log("models", worksheetCopyFrom.model.name, worksheetCopyTo.model.name)
  const originalObject = worksheetCopyFrom.model;
  const { name, ...newObject } = originalObject;
  worksheetCopyTo.model = newObject;
  if (nouveauNom) {
    worksheetCopyTo.model.name = nouveauNom;
    worksheetCopyTo.name = nouveauNom;
  } else {
    worksheetCopyTo.model.name = worksheetCopyFrom.model.name;
    worksheetCopyTo.name = worksheetCopyFrom.model.name;
  }
  worksheetCopyFrom.model.merges.forEach((merge: any) =>
    worksheetCopyTo.mergeCells(merge)
  );

  worksheetCopyTo.orderNo = newOrder;
  //console.log("final", worksheetCopyTo,worksheetCopyTo.model)
};

export const gestionDesPhotosAppuisFibresFT = async (
  worksheetPhotos: any,
  sheetRosalyna: any,
  workbook: any,
  parcours: any,
  imagesPourFiches: any
) => {
  listeRemarques.value.message.unshift(
    `[OK] L'onglet Photos contient ${imagesPourFiches.length} images pour ${parcours_ft.length} appuis fibrés France Télécom.`
  );
  let compteur = 1;
  await worksheetPhotos.eachRow(
    { includeEmpty: true },
    function (row: any, rowNumber: any) {
      if (cancelLectureC6.value) return;
      compteur++;
      if (rowNumber % coef_d13.value === 0) {
        row.height = 300;
      } else {
        row.height = 15;
      }
    }
  );
  for (let rowNumber = 1; rowNumber <= 1000; rowNumber++) {
    if (cancelLectureC6.value) {
      presentToast("Lecture C6 annulée", "warning-outline");
      return;
    }
    encoursc6titre.value = "Redimension ligne " + rowNumber + "/" + compteur;
    const row = sheetRosalyna.getRow(rowNumber);
    if (rowNumber % coef_d13.value === 0) {
      row.height = 280;
    } else {
      row.height = 15;
      if (rowNumber > 1 && parcours_ft[0]) {
        sheetRosalyna.getCell(rowNumber, 1).value =
          parcours_ft[0].nom + "_1.jpg";
        sheetRosalyna.getCell(rowNumber, 1).fill = parcours_ft[0].couleuravant;
        sheetRosalyna.getCell(rowNumber, 2).value =
          parcours_ft[0].nom + "_2.jpg";
        sheetRosalyna.getCell(rowNumber, 2).fill = parcours_ft[0].couleurapres;
        parcours_ft.shift();
      }
    }
  }
  // Parcourir chaque paire d'images
  for (let i = 0; i < imagesPourFiches.length; i += 2) {
    encoursc6titre.value = `Placement des photos ${i + 1} et ${i + 2} sur ${imagesPourFiches.length
      }`;
    const rowNum = 2 + (i / 2) * 2;
    if (imagesPourFiches[i]) {
      const imageA = imagesPourFiches[i];
      await adjustAndMoveImage(imageA, rowNum, 1, workbook, sheetRosalyna);
    }
    if (imagesPourFiches[i + 1]) {
      const imageB = imagesPourFiches[i + 1];
      await adjustAndMoveImage(imageB, rowNum, 2, workbook, sheetRosalyna);
    }
  }
};

export const gestionDesPhotosAppuisFibres = async (
  worksheetPhotos: any,
  sheetRosalyna: any,
  workbook: any,
  parcours: any,
  imagesPourFiches: any
) => {
  parcours_fibre = [];
  for (const appui of parcours) {
    if (appui.pose_cable === true) {
      parcours_fibre.push(appui);
    }
  }
  let compteur = 1;
  await worksheetPhotos.eachRow(
    { includeEmpty: true },
    function (row: any, rowNumber: any) {
      compteur++;
      if (rowNumber % coef_d13.value === 0) {
        row.height = 300;
      } else {
        row.height = 15;
      }
    }
  );
  for (let rowNumber = 1; rowNumber <= 1000; rowNumber++) {
    if (cancelLectureC6.value) {
      presentToast("Lecture C6 annulée", "warning-outline");
      return;
    }
    encoursc6titre.value = "Redimension ligne " + rowNumber + "/" + compteur;
    const row = sheetRosalyna.getRow(rowNumber);
    if (rowNumber % coef_d13.value === 0) {
      row.height = 280;
    } else {
      row.height = 15;
      if (rowNumber > 1 && parcours_fibre[0]) {
        sheetRosalyna.getCell(rowNumber, 1).value =
          parcours_fibre[0].nom + "_1.jpg";
        sheetRosalyna.getCell(rowNumber, 1).fill =
          parcours_fibre[0].couleuravant;
        sheetRosalyna.getCell(rowNumber, 2).value =
          parcours_fibre[0].nom + "_2.jpg";
        sheetRosalyna.getCell(rowNumber, 2).fill =
          parcours_fibre[0].couleurapres;
        parcours_fibre.shift();
      }
    }
  }

  for (let i = 0; i < imagesPourFiches.length; i += 2) {
    encoursc6titre.value = `Placement des photos ${i + 1} et ${i + 2} sur ${imagesPourFiches.length
      }`;
    const rowNum = 2 + (i / 2) * 2;
    if (imagesPourFiches[i]) {
      const imageA = imagesPourFiches[i];
      await adjustAndMoveImage(imageA, rowNum, 1, workbook, sheetRosalyna);
    }
    if (imagesPourFiches[i + 1]) {
      const imageB = imagesPourFiches[i + 1];
      await adjustAndMoveImage(imageB, rowNum, 2, workbook, sheetRosalyna);
    }
  }
};

export const gestionSansPhotos = async (
  worksheetPhotos: any,
  sheetRosalyna: any,
  workbook: any,
  images: any
) => {
  let compteur = 1;
  const values: any[] = [];
  const valuesB: any[] = [];

  const parcours_complet = [];
  for (const appui of parcours) {
    parcours_complet.push(appui);
  }

  await worksheetPhotos.eachRow(
    { includeEmpty: true },
    function (row: any, rowNumber: any) {
      compteur++;
      if (rowNumber % coef_d13.value === 0) {
        row.height = 300;
      } else {
        row.height = 15;
      }
    }
  );
  for (let rowNumber = 1; rowNumber <= compteur; rowNumber++) {
    encoursc6titre.value = "Redimension ligne " + rowNumber + "/" + compteur;
    const row = sheetRosalyna.getRow(rowNumber);
    if (rowNumber % coef_d13.value === 0) {
      row.height = 280;
    } else {
      row.height = 15;
      if (rowNumber > 1 && parcours_complet[0]) {
        sheetRosalyna.getCell(rowNumber, 1).value =
          parcours_complet[0].nom + "_1.jpg";
        sheetRosalyna.getCell(rowNumber, 1).fill =
          parcours_complet[0].couleuravant;
        sheetRosalyna.getCell(rowNumber, 2).value =
          parcours_complet[0].nom + "_2.jpg";
        sheetRosalyna.getCell(rowNumber, 2).fill =
          parcours_complet[0].couleurapres;
        parcours_complet.shift();
      }
    }
  }
};

export const gestionDesPhotos = async (
  worksheetPhotos: any,
  sheetRosalyna: any,
  workbook: any,
  images: any
) => {
  let compteur = 1;
  const values: any[] = [];
  const valuesB: any[] = [];

  const parcours_complet = [];
  for (const appui of parcours) {
    parcours_complet.push(appui);
  }

  await worksheetPhotos.eachRow(
    { includeEmpty: true },
    function (row: any, rowNumber: any) {
      compteur++;
      if (rowNumber % coef_d13.value === 0) {
        row.height = 300;
      } else {
        row.height = 15;
      }
    }
  );
  for (let rowNumber = 1; rowNumber <= compteur; rowNumber++) {
    encoursc6titre.value = "Redimension ligne " + rowNumber + "/" + compteur;
    const row = sheetRosalyna.getRow(rowNumber);
    if (rowNumber % coef_d13.value === 0) {
      row.height = 280;
    } else {
      row.height = 15;
      if (rowNumber > 1 && parcours_complet[0]) {
        sheetRosalyna.getCell(rowNumber, 1).value =
          parcours_complet[0].nom + "_1.jpg";
        sheetRosalyna.getCell(rowNumber, 1).fill =
          parcours_complet[0].couleuravant;
        sheetRosalyna.getCell(rowNumber, 2).value =
          parcours_complet[0].nom + "_2.jpg";
        sheetRosalyna.getCell(rowNumber, 2).fill =
          parcours_complet[0].couleurapres;
        parcours_complet.shift();
      }
    }
  }

  for (let i = 0; i < images.length; i += 2) {
    encoursc6titre.value = `Placement des photos ${i + 1} et ${i + 2} sur ${images.length
      }`;
    const rowNum = 2 + (i / 2) * 2;
    if (images[i]) {
      const imageA = images[i];
      await adjustAndMoveImage(imageA, rowNum, 1, workbook, sheetRosalyna);
    }
    if (images[i + 1]) {
      const imageB = images[i + 1];
      await adjustAndMoveImage(imageB, rowNum, 2, workbook, sheetRosalyna);
    }
  }
};

export const listerSurplusCables = (excelData: any) => {
  const routeCount: { [key: string]: number } = {};
  const duplicates: string[] = [];

  // Parcours du tableau d'objets
  for (const obj of excelData) {
    // Création de la combinaison départ-arrivée
    const routeKey = `${obj.depart}-${obj.arrivee}`;

    // Incrémentation du compteur pour cette combinaison
    routeCount[routeKey] = (routeCount[routeKey] || 0) + 1;
    // Vérification si le nombre d'occurrences dépasse 3
    if (routeCount[routeKey] === 4 && !duplicates.includes(routeKey)) {
      listeRemarques.value.message.unshift(
        `Le lien ${routeKey} est présent plus de 3 fois.`
      );
      duplicates.push(routeKey);
    }
  }

  return duplicates;
};

export const statutPhotos = (imagesPourFiches: any, parcours: any) => {
  let reponse;
  if (imagesPourFiches.length != parcours.length * 2) {
    reponse = `L'onglet Photos contient ${imagesPourFiches.length
      } images au lieu de ${parcours.length * 2
      } comme attendues. Essai avec les appuis fibrés.`;
    listeRemarques.value.message.unshift(
      `L'onglet Photos contient ${imagesPourFiches.length} images au lieu de ${parcours.length * 2
      } comme attendues. Essai avec les appuis fibrés.`
    );
    calibragePhotoState = 1;
    parcours_ft = [];
    for (const appui of parcours) {
      if (appui.tiers === false && appui.pose_cable === true) {
        parcours_ft.push(appui);
      }
    }
    if (imagesPourFiches.length != parcours_ft.length * 2) {
      reponse = `[NOK] ${imagesPourFiches.length} photos pour ${parcours_ft.length} FT fibrés.`;
      listeRemarques.value.message.unshift(
        `[NOK] ${imagesPourFiches.length} photos pour ${parcours_ft.length} FT fibrés.`
      );
      calibragePhotoState = 3;
    } else {
      reponse = `[OK] L'onglet Photos contient ${imagesPourFiches.length} images pour ${parcours_ft.length} appuis fibrés France Télécom.`;
      calibragePhotoState = 2;
      listeRemarques.value.message.unshift(
        `[OK] L'onglet Photos contient ${imagesPourFiches.length} images pour ${parcours_ft.length} appuis fibrés France Télécom.`
      );
    }
  } else {
    calibragePhotoState = 0;
    reponse = `[OK] L'onglet Photos contient ${imagesPourFiches.length} images pour ${parcours.length} appuis comme attendu..`;
    listeRemarques.value.message.unshift(
      `[OK] L'onglet Photos contient ${imagesPourFiches.length} images pour ${parcours.length} appuis comme attendu..`
    );
  }
  return reponse;
};

function obtenirPremierChiffre(chaine: string): number | null {
  // Utilise une expression régulière pour trouver le premier chiffre après les deux premiers caractères
  const premierChiffreMatch = chaine.slice(2).match(/\d/);

  // Vérifie si un match est trouvé
  if (premierChiffreMatch) {
    // Utilise parseInt pour convertir le chiffre en nombre
    return parseInt(premierChiffreMatch[0], 10);
  }

  if(chaine == 'BST') {
    return 4;
  }

  // Renvoie null si aucun chiffre n'est trouvé
  return null;
}

export const lectureC6 = async (
  workbook: any,
  saisiesterrainfci: any,
  res_text: any,
  specialbatch: boolean,
  workbookModeleC6: any,
  workbookModeleC7: any,
  workbookModeleRest: any,
  logo_orange_c6: any,
  workbookModeleC6wIcon: any,
  workbook_sr: any,
  workbook_ar: any
) => {
  ///////////////////
  //
  // Les tableaux Blob vont contenir un ensemble de fichier exitants en plusieurs fois
  // Il y a 1 seule C6, une seule C7 mais il peut y avoir plusieurs dizaines ou centaines de D13 (fiches appuis)
  //
  ///////////////////

  encoursc6titre.value = "Choisssez un opérateur";
  let operateur;
  let sous_traitant;
  if (specialbatch === false) {
    operateur = await consententActionSheet("Opérateur", [
      { nom: "Corsica Fibra", role: "Corsica Fibra", data: { action: "delete" } },
      { nom: "SFR FTTH", role: "SFR_FTTH", data: { action: "delete" } },
      { nom: "Numéricable", role: "NUMERICABLE", data: { action: "delete" } },
      { nom: "SFR", role: "SFR", data: { action: "delete" } },
      { nom: "Complétel", role: "COMPLETEL", data: { action: "delete" } },
      { nom: "Annuler", role: "Annuler", data: { action: "delete" } },
    ]);
  } else {
    operateur = "SFR FTTH";
  }

  switch (operateur) {
    case "Corsica Fibra":
      siren_cible = "844052506";
      sous_traitant = "CRT"
      break;
    case "SFR_FTTH":
      siren_cible = "844717587";
      sous_traitant = "ACT"
      break;
    case "SFR":
      siren_cible = "403106537";
      sous_traitant = "ACT"
      break;
    case "NUMERICABLE":
      siren_cible = "379229529";
      sous_traitant = "ACT"
      break;
    case "COMPLETEL":
      siren_cible = "418299699";
      sous_traitant = "ACT"
      break;
    case "Annuler":
      break;
  }

  if (operateur != "Annuler") {
    tableauBlobFiches = [];
    tableauBlobC4 = [];
    tableauBlobC6 = { annexes: [] };
    communes_annexes = [];
    annexesC4 = [];
    annexesC6 = [];
    blobC3A = null;
    blobC6 = null;
    blobC7 = null;
    blobShp = null;
    blobGeoJson = null;
    cablesFromC6 = [];
    cancelLectureC6.value = false;
    inspectionProjectionDecision.value = null;
    inspectionProjectionResolver = null;
    inspectionProjectionSeen.value = false;
    inspectionProjectionOpen.value = false;
    listeRemarques.value.message = [];
    parcours_ft = [];

    let type_deploiement_transport = false;
    

    ////////////////////////////
    //
    // Chargement des onglets dont j'ai besoin pour travailler
    //
    // La page de garde contient le titre du fichier et la version (exemple 26/07/2023)
    // La base est un ensemble de variables en lecture seule, il faut juste s'assurer que c'est la bonne version
    // Les photos, bon, intuitif.
    // Saisies terrain correspond aux informations des appuis avant calcul de charge
    // Export 1 aux informations après le calcul
    //
    ////////////////////////////

    encoursc6titre.value = "Analyse des onglets";
    // const worksheetC4 = workbookModeleRest.getWorksheet("Restitution");
    const worksheetRestitutions =
      workbookModeleRest.getWorksheet("Restitution");
    let worksheetC6 = workbook.getWorksheet("Export 1");

    const worksheetPDG = workbook.getWorksheet("Page de garde");
    let worksheetPhotos = workbook.getWorksheet("Photos");
    let worksheetPhotos2 = workbook.getWorksheet("Photos (2)");
    const worksheetBases = workbook.getWorksheet("Bases");
    const worksheetSaisies = workbook.getWorksheet("Saisies terrain");

    const worksheetModeleC6PDG = workbookModeleC6.getWorksheet("Page de garde");
    const worksheetModeleC6Saisies =
      workbookModeleC6.getWorksheet("Saisies terrain");
    const worksheetModeleC6Bases = workbookModeleC6.getWorksheet("Bases");
    // const worksheetModeleC6Photos = workbookModeleC6.getWorksheet("Photos");
    let model_br;
    let model_tl;
    const worksheetPDGicon =
      workbookModeleC6wIcon.getWorksheet("Page de garde");
    if (specialbatch === false) {
      const imagesModeleC6PDG = worksheetPDGicon.getImages();
      model_br = imagesModeleC6PDG[0].range.br;
      model_tl = imagesModeleC6PDG[0].range.tl;
    }

    if (worksheetPhotos2) {
      worksheetPhotos2 = workbook.getWorksheet("Photos");
      worksheetPhotos = workbook.getWorksheet("Photos (2)");
      let worksheetC62 = workbook.getWorksheet("Export 2");
      workbook.removeWorksheet(worksheetPhotos2.id);
      worksheetPhotos.name = "Photos";
      if (worksheetC62) {
        worksheetC62 = workbook.getWorksheet("Export 1");
        worksheetC6 = workbook.getWorksheet("Export 2");
        workbook.removeWorksheet(worksheetC62.id);
        worksheetC6.name = "Export 1";
      }
    }

    if(worksheetC6.getCell("D5").value == "Oui"){
      type_deploiement_transport = true;
      worksheetC6.getCell("D4").value = "Non";
    }

    ///////////////////////////
    //
    // worksheetRestitutions est une C7 préremplie avec toutes les possibilités de remplacement
    // Il est chargé au début puis analysé pour les avoir sous forme de tableau
    // Des fois worksheeRestitution n'est pas définit quand on va trop vite, à régler
    //
    ///////////////////////////

    encoursc6titre.value = "Chargement des modèles";

    //console.log(worksheetRestitutions)
    const cellValues: { type: any; col: any; value: any }[] = [];
    worksheetRestitutions.eachRow(
      { includeEmpty: true },
      (row: any, rowNumber: any) => {
        if (row.getCell(1).text.includes("/") && row.number > 17) {
          const parts = row.getCell(1).text.split("/");
          const afterSlash = parts[1] || "";
          row.eachCell((cell: any, colNumber: any) => {
            if (cell.value && cell.value.toString().length == 1) {
              cellValues.push({
                type: afterSlash,
                col: colNumber,
                value: cell.value,
              });
            }
          });
        }
      }
    );

    //////////////////////////////////
    //
    // Premièrement nous allons vérifier que les onglets sont présents
    // Quand un onglet est absent il retourne null
    // S'il est présent, on le lui donne sa position dans le classeur
    // S'il n'y est pas, on le copie du modele avant de donner la position
    //
    //////////////////////////////////

    encoursc6titre.value = "Recherche et correction des onglets";

    if (worksheetPDG) {
      workbook.removeWorksheet(worksheetPDG.id);
    }
    const sheet = workbook.addWorksheet("Page de garde");
    copyWorkSheet(worksheetModeleC6PDG, sheet, 0);
    const sheetRosalyna = workbook.addWorksheet("Photos R");
    sheetRosalyna.getColumn("A").width = 48;
    sheetRosalyna.getColumn("B").width = 48;
    sheetRosalyna.getColumn("C").width = 48;
    sheetRosalyna.getColumn("D").width = 48;
    sheetRosalyna.mergeCells("A1:B1");
    sheetRosalyna.getCell("A1").value = "Avant travaux";
    sheetRosalyna.getCell("B1").alignment = { horizontal: "center" };
    sheetRosalyna.getCell("B1").font = {
      bold: true,
    };

    // Set the background color of the merged cell to yellow
    sheetRosalyna.getCell("A1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FEBE98" },
      bgColor: { argb: "FEBE98" },
    };
    sheetRosalyna.mergeCells("C1:D1");
    sheetRosalyna.getCell("C1").value = "Après travaux";
    sheetRosalyna.getCell("C1").alignment = { horizontal: "center" };
    sheetRosalyna.getCell("C1").font = {
      bold: true,
    };

    // Set the background color of the merged cell to yellow
    sheetRosalyna.getCell("C1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FEBE98" },
      bgColor: { argb: "FEBE98" },
    };

    if (worksheetSaisies) {
      worksheetSaisies.orderNo = 1;
    } else {
      const sheet = workbook.addWorksheet("Saisies terrain");
      copyWorkSheet(worksheetModeleC6Saisies, sheet, 1);
    }

    if (worksheetBases) {
      copyWorkSheet(worksheetModeleC6Bases, worksheetBases, 2);
    } else {
      const sheet = workbook.addWorksheet("Bases");
      copyWorkSheet(worksheetModeleC6Bases, sheet, 2);
    }

    /////////////////////
    //
    // worksheetPhotos est le plus compliqué des traitements
    // Les lignes vont être redimentionnées
    // Puis les photos seront détectées deux par deux du plus haut au plus bas
    // Elles seront ajustées aux cases grâce à adjustAndMoveImage
    // EDIT: Maintenant elles seront copiés dans sheetRosalyna pour les insérer en oneCellAnchor
    //
    /////////////////////

    encoursc6titre.value = "Calibrage des photos..";

    if (worksheetC6) {
      worksheetC6.orderNo = 4;
      await deleteColumnsAfterAP(worksheetC6);
    }

    encoursc6titre.value = "Suppression des colonnes en trop";
    /////////////
    // Suppréssion des colonnes en trop pour éviter les injections en échec
    /////////////
    await deleteColumnsAfterAP(worksheetSaisies);

    let fci = saisiesterrainfci.value;
    console.log(fci, saisiesterrainfci)
    let insee = res_text[0].COM;
    const regex = /^F\d{11}$/;
    //FCIs
    if (fci == "fciVide" && specialbatch === false) {
      fci = worksheetC6.getCell(1, 3).value?.toString() || "fciVide";
    }
    
    if (fci == "fciVide" && specialbatch === false) {
      comptageCorrection.value = comptageCorrection.value + 1;
      listeRemarques.value.message.unshift(`Pas de FCI dans la C6, corrigé.`);
    }

    
    const cell = worksheetC6.getCell("C1");
    cell.value = fciCommande.value;
    const cell2 = worksheetSaisies.getCell("C1");
    cell2.value = fciCommande.value;
    //OPE
    const cell3 = worksheetC6.getCell("C2");
    cell3.value = operateur;
    const cell4 = worksheetSaisies.getCell("C2");
    cell4.value = operateur;
    //DATE
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    const todayVal = day + "/" + month + "/" + year;
    const cell5 = worksheetC6.getCell("F1");
    cell5.value = todayVal;
    const cell6 = worksheetSaisies.getCell("F1");
    cell6.value = todayVal;
    const cell10 = worksheetSaisies.getCell("F2");
    cell10.value = sous_traitant;
    const cell11 = worksheetC6.getCell("F2");
    cell11.value = sous_traitant;
    const cell12 = worksheetSaisies.getCell("E1");
    cell12.value = "";
    const cell13 = worksheetC6.getCell("E1");
    cell13.value = "";

    encoursc7titre.value = "Ouverture du modèle C7";

    //////////////////////
    //
    // La C6 a été mise en forme et chargée, nous allons passer à la lecture
    // no_calc est une liste d'appuis non-FranceTelecom
    // Le regex sert à trouver les numéros FCI qui commencent pas F suivi de 11 chiffres
    //
    //////////////////////

    const worksheetModeleC7Commande = workbookModeleC7.getWorksheet("Commande");
    const worksheetModeleC7Restitution = workbookModeleC7.getWorksheet("Restitution");

    encoursc7titre.value = "Lecture de la C6";

    let index = 0;
    calibragePhotoState = 0;
    let currentLocation;
    excelData = [];
    lignesC6 = [];
    C6Brute = [];
    communes_annexes = [];
    parcours = [];
    parcours_fibre = [];
    compteurAppuisHorsCommunes = 0;
    completementAutreCommune = false;
    const no_calc = ["POT", "POT MIN", "POT MAX", "EDF", "ORT"];
    let depart_cable;
    ///////////////////
    //
    // Nous partons de la ligne 9 car l'entête ne nous intérésse pas
    // Pour chaque ligne, chaque valeur importante sera enregistrée dans un objet appui
    //
    ///////////////////
    const correct = await consententActionSheet("Correction C6 ?", [
      { nom: "Oui", role: "Oui", data: { action: "delete" } },
      { nom: "Non", role: "Non", data: { action: "delete" } },
    ]);
    if(correct == "Oui"){ 
      await chargementAppuisAChaud(insee, correct);
    }
    for (let rowNum = 9; rowNum <= worksheetC6.rowCount; rowNum++) {
      if (!worksheetC6.getCell(rowNum, 19).value) {
        break;
      }

      let matchingFibres = [];
      let depart = String(worksheetC6.getCell(rowNum, 1).value ?? "");
      if (depart == null || depart == undefined || depart == "" || depart == "N° appui") {
        console.log(`Ligne ${rowNum} utilisation d'une ligne plus haut pour aller de ${depart_cable} à ${worksheetC6.getCell(rowNum, 25).value} (${parseInt(worksheetC6.getCell(rowNum, 20).text)})`)
      } else {
        depart_cable = depart;
      }
      let arrivee = worksheetC6.getCell(rowNum, 25).value;
      let cable = worksheetC6.getCell(rowNum, 19).value?.toString() || "none";
      let cableCell = worksheetC6.getCell(rowNum, 19);
      let typeAppui = worksheetC6.getCell(rowNum, 2).value?.toString().trim() || "none";

      if(no_calc.includes(typeAppui)){
        typeAppui = "ORT";
        worksheetC6.getCell(rowNum, 2).value = "ORT";
      }

      const longueur = parseInt(worksheetC6.getCell(rowNum, 20).text) || "0";
      const angle = parseInt(worksheetC6.getCell(rowNum, 21).text) || "0";

      let hypothese = worksheetC6.getCell(6, 4).value?.toString() || "Non";
      let hypothese2 = worksheetC6.getCell(6, 5).value?.toString() || "Non";
      let fttx = worksheetC6.getCell(6, 5).value?.toString() || "Non";
      let fleche = worksheetC6.getCell(rowNum, 24).value?.toString() || "0.0x";
      let bfttx = worksheetC6.getCell(6, 7).value?.toString() || "Non";
      let amont = worksheetC6.getCell(5, 5).value?.toString() || "Non";

      let adresse_appui = worksheetC6.getCell(rowNum, 3).value?.toString() || "";
      let code_centre = worksheetC6.getCell(3, 5).value?.toString() || "";
      let visuel = worksheetC6.getCell(rowNum, 6).text || "0";
      let verticalite = worksheetC6.getCell(rowNum, 7).text || "0";
      let flambement = worksheetC6.getCell(rowNum, 8).text || "0";
      let voisinage = worksheetC6.getCell(rowNum, 9).text || "0";
      let pointe_carree = worksheetC6.getCell(rowNum, 10).text || "0";
      let secousses = worksheetC6.getCell(rowNum, 11).text || "0";
      let percussions = worksheetC6.getCell(rowNum, 12).text || "0";
      let etiquette = worksheetC6.getCell(rowNum, 13).text || "0";
      let utilisable = worksheetC6.getCell(rowNum, 14).text || "Oui";
      let milieu = worksheetC6.getCell(rowNum, 15).text || "0";
      let electrique = worksheetC6.getCell(rowNum, 16).text || "0";
      let strategique = worksheetC6.getCell(rowNum, 17).text || "0";
      let acces_vehicule = worksheetC6.getCell(rowNum, 18).text || "0";
      let cuivre = worksheetC6.getCell(rowNum, 26).text || "0";
      let optique = worksheetC6.getCell(rowNum, 27).text || "0";

      let effortavant = worksheetC6.getCell(rowNum, 28).text || "0";
      let effortapres = worksheetC6.getCell(rowNum, 29).text || "0";
      let effortremplace = worksheetC6.getCell(rowNum, 30).text || "0";
      let couleuravant = worksheetC6.getCell(rowNum, 28).fill;
      let couleurapres = worksheetC6.getCell(rowNum, 29).fill;

      let couleurremplacement;

      if (worksheetC6.getCell(rowNum, 30).fill) {
        couleurremplacement = worksheetC6.getCell(rowNum, 30).fill || null;
      } else {
        couleurremplacement = null;
      }


      let remplacement = worksheetC6.getCell(rowNum, 32).value?.toString() || "Non";

      if (remplacement == "Remplacement") {
        worksheetC6.getCell(rowNum, 31).value = worksheetC6.getCell(rowNum, 2).value?.toString()
      }




      let avanttravaux = worksheetC6.getCell(rowNum, 31).value?.toString() || "Non";


      if (rowNum > 8) {
        if (
          remplacement == "Remplacement" &&
          worksheetC6.getCell(rowNum, 35).text == "Oui"
        ) {
          comptageCorrection.value = comptageCorrection.value + 1;
          worksheetC6.getCell(rowNum, 35).value = "Non";
          listeRemarques.value.message.unshift(
            `L'appui ${depart} est remplacé avec réhausse, corrigé. ${rowNum}`
          );
        }
        if (
          no_calc.includes(typeAppui) &&
          worksheetC6.getCell(rowNum, 35).text == "Oui"
        ) {
          comptageCorrection.value = comptageCorrection.value + 1;
          worksheetC6.getCell(rowNum, 35).value = "Non";
          listeRemarques.value.message.unshift(
            `L'appui ${depart} est non FT avec réhausse, corrigé.`
          );
        }

        if (typeAppui == "none") {
          worksheetC6.getCell(rowNum, 35).value = "";
        }
      }

      let aprestravaux =
        worksheetC6.getCell(rowNum, 33).value?.toString() || "Non";
      aprestravaux = aprestravaux.trim();


      if (
        remplacement == "Remplacement" ||
        remplacement == "Renforcement"
      ) {
        if (avanttravaux.charAt(0) === aprestravaux.charAt(0)) {
          remplacement = "Renforcement"
          worksheetC6.getCell(rowNum, 32).value = "Renforcement"
        } else {
          remplacement = "Remplacement"
          worksheetC6.getCell(rowNum, 32).value = "Remplacement"
        }
      }

      

      if (utilisateurSiren.value == "882385602" && specialbatch === false && correct == "Oui") {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        //alert(insee)
        
        const filteredArray = appuisActif.features.filter((base) => {
          // Check if base has properties and NUM_APPUI property
          const numAppui = parseInt(base.properties.NUM_APPUI, 10);
          const appNomWithoutZeros = parseInt(depart, 10);

          return base.properties && numAppui === appNomWithoutZeros;
        });
        console.log('filteredArray', filteredArray)
        if (filteredArray[0] && estComposeDeChiffres(depart)) {
          const propertiesArray = Object.entries(
            filteredArray[0].properties
          ).map(([key, value]) => ({ key, value }));
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          //const hauban = propertiesArray.some(({ value }) => value.includes('HAU'));
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const ancrage = propertiesArray.some(({ value }) =>
            String(value || "").includes("ANC")
          );
          
          //console.log(propertiesArray)
          if (filteredArray[0].properties.TYPE_APPUI.includes("H")) {
            //console.log( "hauban detecté", filteredArray[0].properties.TYPE_APPUI, typeAppui  );



            let angle_hauban = false;
            if (
              typeAppui.includes("S30") &&
              filteredArray[0].properties.TYPE_APPUI.length == 3
            ) {
              //console.log( "s30 detecté", filteredArray[0].properties.TYPE_APPUI);
              filteredArray[0].properties.TYPE_APPUI += " S30";
              angle_hauban = true;
            }
            if (
              typeAppui.includes("S45") &&
              filteredArray[0].properties.TYPE_APPUI.length == 3
            ) {
              filteredArray[0].properties.TYPE_APPUI += " S45";
              angle_hauban = true;
            }
            if (
              typeAppui.includes("D30") &&
              filteredArray[0].properties.TYPE_APPUI.length == 3
            ) {
              filteredArray[0].properties.TYPE_APPUI += " D30";
              angle_hauban = true;
            }
            if (
              typeAppui.includes("D45") &&
              filteredArray[0].properties.TYPE_APPUI.length == 3
            ) {
              filteredArray[0].properties.TYPE_APPUI += " D45";
              angle_hauban = true;
            }
            if (
              angle_hauban === false &&
              filteredArray[0].properties.TYPE_APPUI.length == 3
            ) {
              //console.log( "aucun angle detecté", filteredArray[0].properties.TYPE_APPUI );
              filteredArray[0].properties.TYPE_APPUI += " S30";
            }
          }

          if (
            ancrage &&
            filteredArray[0].properties.TYPE_APPUI.includes("BC") &&
            filteredArray[0].properties.TYPE_APPUI.length == 3
          ) {
            filteredArray[0].properties.TYPE_APPUI += " ANC";
          }
          if (
            ancrage &&
            filteredArray[0].properties.TYPE_APPUI.includes("MC") &&
            filteredArray[0].properties.TYPE_APPUI.length == 3
          ) {
            filteredArray[0].properties.TYPE_APPUI += " ANC MAX";
          }
          if (filteredArray[0].properties.TYPE_APPUI.includes("FC")) {
            let ouverture = false;
            if (
              typeAppui.includes("MIN") &&
              filteredArray[0].properties.TYPE_APPUI.length == 3
            ) {
              filteredArray[0].properties.TYPE_APPUI += " MIN";
              ouverture = true;
            }
            if (
              typeAppui.includes("MAX") &&
              filteredArray[0].properties.TYPE_APPUI.length == 3
            ) {
              filteredArray[0].properties.TYPE_APPUI += " MAX";
              ouverture = true;
            }
            if (
              ouverture === false &&
              filteredArray[0].properties.TYPE_APPUI.length == 3
            ) {
              filteredArray[0].properties.TYPE_APPUI += " MAX";
            }
          }

          if (remplacement != "Remplacement") {
            worksheetC6.getCell(rowNum, 35).value = "Oui";
          } else {
            worksheetC6.getCell(rowNum, 35).value = "Non";
          }

          const typeHierarchy = { B: 1, M: 2, F: 3 };
          const theorique = filteredArray[0].properties.TYPE_APPUI;
          const terrain = typeAppui;
          const theoriqueCode = theorique.charAt(0);
          const terrainCode = terrain.charAt(0);
          const theoRank = typeHierarchy[theoriqueCode] || 0;
          const terrainRank = typeHierarchy[terrainCode] || 0;
          

          if (theorique != terrain && theoRank >= terrainRank) {
            listeRemarques.value.message.unshift(
              `L'appui ${depart} est ${filteredArray[0].properties.TYPE_APPUI} dans le PIT (contre ${typeAppui})`
            );
            typeAppui = filteredArray[0].properties.TYPE_APPUI;
            avanttravaux = filteredArray[0].properties.TYPE_APPUI;
            worksheetC6.getCell(rowNum, 2).value = typeAppui;
            if (remplacement == "Remplacement") {
              worksheetC6.getCell(rowNum, 31).value = typeAppui;
            }

            if (
              worksheetC6.getCell(rowNum, 30).style !== undefined &&
              worksheetC6.getCell(rowNum, 28).style !== null
            ) {
              worksheetC6.getCell(rowNum, 30).style = undefined;
            }
            comptageCorrection.value = comptageCorrection.value + 1;
            worksheetC6.getCell(rowNum, 41).value = "Type mis à jour avec le GESPOT 2024.";

            if (!typeAppui.startsWith('B')) {
              worksheetC6.getCell(rowNum, 6).value = "Oui";
              worksheetC6.getCell(rowNum, 7).value = "Oui";
              worksheetC6.getCell(rowNum, 8).value = "Oui";
              worksheetC6.getCell(rowNum, 9).value = "Oui";
              worksheetC6.getCell(rowNum, 10).value = "Oui";
              worksheetC6.getCell(rowNum, 11).value = "Oui";
              worksheetC6.getCell(rowNum, 12).value = "Oui";
              worksheetC6.getCell(rowNum, 13).value = "Oui";
              worksheetC6.getCell(rowNum, 14).value = "Oui";
            }


            worksheetC6.getCell(rowNum, 30).value = "";
            worksheetC6.getCell(rowNum, 31).value = "";
            worksheetC6.getCell(rowNum, 32).value = "";
            worksheetC6.getCell(rowNum, 33).value = "";
            worksheetC6.getCell(rowNum, 34).value = "";
            worksheetC6.getCell(rowNum, 35).value = "Oui";


          }

          if (filteredArray[0].properties.ENVIRONN && filteredArray[0].properties.ENVIRONN.includes("SOC")) {
            comptageCorrection.value = comptageCorrection.value + 1;
            listeRemarques.value.message.unshift(
              `${depart} est sur socle dans le GESPOT.`
            );

            if (
              worksheetC6.getCell(rowNum, 30).style !== undefined &&
              worksheetC6.getCell(rowNum, 28).style !== null
            ) {
              worksheetC6.getCell(rowNum, 30).style = undefined;
            }

            worksheetC6.getCell(rowNum, 41).value =
              "Attention appui sur socle.";
            worksheetC6.getCell(rowNum, 30).value = "";
            worksheetC6.getCell(rowNum, 31).value = "";
            worksheetC6.getCell(rowNum, 32).value = "";
            worksheetC6.getCell(rowNum, 33).value = "";
            worksheetC6.getCell(rowNum, 34).value = "";
            worksheetC6.getCell(rowNum, 35).value = "Oui";

          }

          if (filteredArray[0].properties.ENVIRONN && filteredArray[0].properties.ENVIRONN.includes("IN8")) {
            listeRemarques.value.message.unshift(
              `${depart} est détecté comme IN8 dans le GESPOT`
            );
            if (acces_vehicule != "IN8") {
              acces_vehicule = "IN8";
              worksheetC6.getCell(rowNum, 18).value = "IN8";
              comptageCorrection.value = comptageCorrection.value + 1;
            }

            worksheetC6.getCell(rowNum, 30).value = "";
            worksheetC6.getCell(rowNum, 31).value = "";
            worksheetC6.getCell(rowNum, 32).value = "";
            worksheetC6.getCell(rowNum, 33).value = "";
            worksheetC6.getCell(rowNum, 34).value = "";
            worksheetC6.getCell(rowNum, 35).value = "Oui";


            worksheetC6.getCell(rowNum, 6).value = "Oui";
            worksheetC6.getCell(rowNum, 7).value = "Oui";
            worksheetC6.getCell(rowNum, 8).value = "Oui";
            worksheetC6.getCell(rowNum, 9).value = "Oui";
            worksheetC6.getCell(rowNum, 10).value = "Oui";
            worksheetC6.getCell(rowNum, 11).value = "Oui";
            worksheetC6.getCell(rowNum, 12).value = "Oui";
            worksheetC6.getCell(rowNum, 13).value = "Oui";
            worksheetC6.getCell(rowNum, 14).value = "Non";

          }

          if (filteredArray[0].properties.ENVIRONN && filteredArray[0].properties.ENVIRONN.includes("IN9")) {
            listeRemarques.value.message.unshift(
              `${depart} est détecté comme IN9 dans le GESPOT`
            );
            if (acces_vehicule != "IN9") {
              acces_vehicule = "IN9";
              worksheetC6.getCell(rowNum, 18).value = "IN9";
              comptageCorrection.value = comptageCorrection.value + 1;
            }

            worksheetC6.getCell(rowNum, 30).value = "";
            worksheetC6.getCell(rowNum, 31).value = "";
            worksheetC6.getCell(rowNum, 32).value = "";
            worksheetC6.getCell(rowNum, 33).value = "";
            worksheetC6.getCell(rowNum, 34).value = "";
            worksheetC6.getCell(rowNum, 35).value = "Oui";


            worksheetC6.getCell(rowNum, 6).value = "Oui";
            worksheetC6.getCell(rowNum, 7).value = "Oui";
            worksheetC6.getCell(rowNum, 8).value = "Oui";
            worksheetC6.getCell(rowNum, 9).value = "Oui";
            worksheetC6.getCell(rowNum, 10).value = "Oui";
            worksheetC6.getCell(rowNum, 11).value = "Oui";
            worksheetC6.getCell(rowNum, 12).value = "Oui";
            worksheetC6.getCell(rowNum, 13).value = "Oui";
            worksheetC6.getCell(rowNum, 14).value = "Non";

          }

        }

        let premier_chiffreType = obtenirPremierChiffre(typeAppui);
        let premier_chiffreAprt = obtenirPremierChiffre(aprestravaux);

        if (premier_chiffreType == 0) {
          premier_chiffreType = 10;
        }
        if (premier_chiffreAprt == 0) {
          premier_chiffreAprt = 10;
        }

        if (
          premier_chiffreType > premier_chiffreAprt &&
          remplacement == "Remplacement" &&
          !no_calc.includes(typeAppui)
        ) {
          listeRemarques.value.message.unshift(
            `${depart} (${premier_chiffreType}m) ne peut pas être remplacé par plus petit (${premier_chiffreAprt}m)`
          );
          aprestravaux = aprestravaux.replace(
            /(?<=.{2})\d/,
            premier_chiffreType.toString()
          );
          comptageCorrection.value = comptageCorrection.value + 1;
        }
        if (
          premier_chiffreType < premier_chiffreAprt &&
          remplacement == "Remplacement" &&
          premier_chiffreType != 6 &&
          !no_calc.includes(typeAppui)
        ) {
          listeRemarques.value.message.unshift(
            `${depart} (${premier_chiffreType}m) ne peut pas être remplacé par plus grand (${premier_chiffreAprt}m)`
          );
          aprestravaux = aprestravaux.replace(
            /(?<=.{2})\d/,
            premier_chiffreType.toString()
          );
          comptageCorrection.value = comptageCorrection.value + 1;
        }

        if ((avanttravaux.includes("C") && !aprestravaux.includes("C")) || (avanttravaux.includes("B3") && !aprestravaux.includes("C"))) {
          switch (aprestravaux) {
            case "FR8":
              worksheetC6.getCell(rowNum, 33).value = "FC8 MAX";
              aprestravaux = "FC8 MAX";
              listeRemarques.value.message.unshift(
                `Le couplé ${depart} est remplacé par un FR8, corrigé à FC8 MAX à la place`
              );
              comptageCorrection.value = comptageCorrection.value + 1;
              break;
            case "FR7":
              worksheetC6.getCell(rowNum, 33).value = "FC7 MAX";
              aprestravaux = "FC7 MAX";
              listeRemarques.value.message.unshift(
                `Le couplé ${depart} est remplacé par un FR7, corrigé à FC7 MAX à la place`
              );
              comptageCorrection.value = comptageCorrection.value + 1;
              break;

            case "M47":
              worksheetC6.getCell(rowNum, 33).value = "FC7 MAX";
              aprestravaux = "FC7 MAX";
              listeRemarques.value.message.unshift(
                `Le couplé ${depart} est remplacé par un M47, corrigé à FC7 MAX à la place`
              );
              comptageCorrection.value = comptageCorrection.value + 1;
              break;
            case "M48":
              worksheetC6.getCell(rowNum, 33).value = "FC8 MAX";
              aprestravaux = "FC8 MAX";
              listeRemarques.value.message.unshift(
                `Le couplé ${depart} est remplacé par un M48, corrigé à FC8 MAX à la place`
              );
              comptageCorrection.value = comptageCorrection.value + 1;
              break;
          }
        } else {
          switch (aprestravaux) {
            case "ME8 MAX":
              worksheetC6.getCell(rowNum, 33).value = "FC8 MAX";
              aprestravaux = "FC8 MAX";
              listeRemarques.value.message.unshift(
                `L'appui ${depart} est remplacé par un ME8 MAX, corrigé à FC8 MAX à la place`
              );
              comptageCorrection.value = comptageCorrection.value + 1;
              break;
            case "ME7 MAX":
              worksheetC6.getCell(rowNum, 33).value = "FC7 MAX";
              aprestravaux = "FC7 MAX";
              listeRemarques.value.message.unshift(
                `L'appui ${depart} est remplacé par un ME7 MAX, corrigé à FC7 MAX à la place`
              );
              comptageCorrection.value = comptageCorrection.value + 1;
              break;
            case "ME8 MIN":
              worksheetC6.getCell(rowNum, 33).value = "FC8 MIN";
              aprestravaux = "FC8 MIN";
              listeRemarques.value.message.unshift(
                `L'appui ${depart} est remplacé par un ME8 MIN, corrigé à FC8 MIN à la place`
              );
              comptageCorrection.value = comptageCorrection.value + 1;
              break;
            case "ME7 MIN":
              worksheetC6.getCell(rowNum, 33).value = "FC7 MIN";
              aprestravaux = "FC7 MIN";
              listeRemarques.value.message.unshift(
                `L'appui ${depart} est remplacé par un ME7 MIN, corrigé à FC7 MIN à la place`
              );
              comptageCorrection.value = comptageCorrection.value + 1;
              break;
            case "M47":
              if (
                avanttravaux.includes(" S45") ||
                avanttravaux.includes(" D45") ||
                avanttravaux.includes(" D30")
              ) {
                worksheetC6.getCell(rowNum, 33).value = "FH7";
                aprestravaux = "FH7";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} S30/S45/D30 est remplacé par un M47, corrigé à FH7 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              } else {
                worksheetC6.getCell(rowNum, 33).value = "FR7";
                aprestravaux = "M47";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} est remplacé par un M47, corrigé à FR7 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              }
              break;
            case "M48":
              if (
                avanttravaux.includes(" S45") ||
                avanttravaux.includes(" D45") ||
                avanttravaux.includes(" D30")
              ) {
                worksheetC6.getCell(rowNum, 33).value = "FH8";
                aprestravaux = "FH8";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} S30/S45/D30 est remplacé par un M48, corrigé à FH8 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              } else {
                worksheetC6.getCell(rowNum, 33).value = "FR8";
                aprestravaux = "FR8";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} est remplacé par un M48, corrigé à FR8 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              }
              break;
            case "MI8":
              if (
                avanttravaux.includes(" S45") ||
                avanttravaux.includes(" D45") ||
                avanttravaux.includes(" D30")
              ) {
                worksheetC6.getCell(rowNum, 33).value = "FH8";
                aprestravaux = "FH8";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} S30/S45/D30 est remplacé par un MI8, corrigé à FH8 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              } else {
                worksheetC6.getCell(rowNum, 33).value = "FR8";
                aprestravaux = "FR8";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} est remplacé par un MI8, corrigé à FR8 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              }
              break;
            case "MI7":
              if (
                avanttravaux.includes(" S45") ||
                avanttravaux.includes(" D45") ||
                avanttravaux.includes(" D30")
              ) {
                worksheetC6.getCell(rowNum, 33).value = "FH7";
                aprestravaux = "FH7";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} S30/S45/D30 est remplacé par un MI7, corrigé à FH7 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              } else {
                worksheetC6.getCell(rowNum, 33).value = "FR7";
                aprestravaux = "FR7";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} est remplacé par un MI7, corrigé à FR7 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              }
              break;
            case "FR7":
              if (
                avanttravaux.includes(" S45") ||
                avanttravaux.includes(" D45") ||
                avanttravaux.includes(" D30")
              ) {
                worksheetC6.getCell(rowNum, 33).value = "FH7";
                aprestravaux = "FH7";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} S30/S45/D30 est remplacé par un FR7, corrigé à FH7 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              }
              break;
            case "FR8":
              if (
                avanttravaux.includes(" S45") ||
                avanttravaux.includes(" D45") ||
                avanttravaux.includes(" D30")
              ) {
                worksheetC6.getCell(rowNum, 33).value = "FH8";
                aprestravaux = "FH8";
                listeRemarques.value.message.unshift(
                  `L'appui ${depart} S30/S45/D30 est remplacé par un FR8, corrigé à FH7 à la place`
                );
                comptageCorrection.value = comptageCorrection.value + 1;
              }
              break;
          }
        }


        if (avanttravaux == aprestravaux && avanttravaux != "Non") {
          if (
            worksheetC6.getCell(rowNum, 30).style !== undefined &&
            worksheetC6.getCell(rowNum, 28).style !== null
          ) {
            worksheetC6.getCell(rowNum, 30).style = undefined;
          }
          worksheetC6.getCell(rowNum, 30).value = "";
          worksheetC6.getCell(rowNum, 31).value = "";
          worksheetC6.getCell(rowNum, 32).value = "";
          worksheetC6.getCell(rowNum, 33).value = "";
          worksheetC6.getCell(rowNum, 34).value = "";
          worksheetC6.getCell(rowNum, 35).value = "Oui";
        }

      }

      let poteaucom = worksheetC6.getCell(rowNum, 34).value?.toString() || "Non";
      let rehausse = worksheetC6.getCell(rowNum, 35).value || "0";
      const typeBoitier = worksheetC6.getCell(rowNum, 36).value?.toString() || "Non";
      let boitierexistant = worksheetC6.getCell(rowNum, 37).text || "0";
      let transition = worksheetC6.getCell(rowNum, 38).text || "0";
      let distance = worksheetC6.getCell(rowNum, 39).text || "0";

      let latitudeInitiale = worksheetC6.getCell(rowNum, 4).value?.toString() || "0";
      let longitudeInitiale = worksheetC6.getCell(rowNum, 5).value?.toString() || "0";
      latitudeInitiale = latitudeInitiale.replace('"', '" ');




      if (
        (depart !== null &&
          depart !== undefined &&
          depart !== "" &&
          depart != "N° appui") || cableCell.style.font?.bold
      ) {
        let num_traitement = rowNum;
        let rollback = false;
        if (depart == null ||
          depart == undefined ||
          depart == "" ||
          depart == "N° appui") {


          while (rollback === false) {
            num_traitement--;
            const depart_rollback = worksheetC6.getCell(num_traitement, 1).value
            if (depart_rollback !== null &&
              depart_rollback !== undefined &&
              depart_rollback !== "" &&
              depart_rollback != "N° appui") {
              rollback = true;
              currentLocation = depart;
              depart = worksheetC6.getCell(num_traitement, 1).value;
              arrivee = worksheetC6.getCell(rowNum, 25).value;
              cable = worksheetC6.getCell(rowNum, 19).value?.toString() || "none";
              cableCell = worksheetC6.getCell(rowNum, 19);
              typeAppui = worksheetC6.getCell(num_traitement, 2).value?.toString() || "none";

              //longueur = parseInt(worksheetC6.getCell(num_traitement, 20).text) || "0";
              //angle = parseInt(worksheetC6.getCell(num_traitement, 21).text) || "0";

              hypothese = worksheetC6.getCell(6, 4).value?.toString() || "Non";
              hypothese2 = worksheetC6.getCell(6, 5).value?.toString() || "Non";
              fttx = worksheetC6.getCell(6, 5).value?.toString() || "Non";
              fleche = worksheetC6.getCell(num_traitement, 24).value?.toString() || "0.0x";
              bfttx = worksheetC6.getCell(6, 7).value?.toString() || "Non";
              amont = worksheetC6.getCell(5, 5).value?.toString() || "Non";

              adresse_appui = worksheetC6.getCell(num_traitement, 3).value?.toString() || "";
              code_centre = worksheetC6.getCell(3, 5).value?.toString() || "";
              visuel = worksheetC6.getCell(num_traitement, 6).text || "0";
              verticalite = worksheetC6.getCell(num_traitement, 7).text || "0";
              flambement = worksheetC6.getCell(num_traitement, 8).text || "0";
              voisinage = worksheetC6.getCell(num_traitement, 9).text || "0";
              pointe_carree = worksheetC6.getCell(num_traitement, 10).text || "0";
              secousses = worksheetC6.getCell(num_traitement, 11).text || "0";
              percussions = worksheetC6.getCell(num_traitement, 12).text || "0";
              etiquette = worksheetC6.getCell(num_traitement, 13).text || "0";
              utilisable = worksheetC6.getCell(num_traitement, 14).text || "Oui";
              milieu = worksheetC6.getCell(num_traitement, 15).text || "0";
              electrique = worksheetC6.getCell(num_traitement, 16).text || "0";
              strategique = worksheetC6.getCell(num_traitement, 17).text || "0";
              acces_vehicule = worksheetC6.getCell(num_traitement, 18).text || "0";
              cuivre = worksheetC6.getCell(num_traitement, 26).text || "0";
              optique = worksheetC6.getCell(num_traitement, 27).text || "0";

              effortavant = worksheetC6.getCell(num_traitement, 28).text || "0";
              effortapres = worksheetC6.getCell(num_traitement, 29).text || "0";
              effortremplace = worksheetC6.getCell(num_traitement, 30).text || "0";
              couleuravant = worksheetC6.getCell(num_traitement, 28).fill;
              couleurapres = worksheetC6.getCell(num_traitement, 29).fill;
              if (worksheetC6.getCell(num_traitement, 30).filld) {
                couleurremplacement = worksheetC6.getCell(num_traitement, 30).fill;
              } else {
                couleurremplacement = null;
              }


              remplacement = worksheetC6.getCell(num_traitement, 32).value?.toString() || "Non";

              if (remplacement == "Remplacement") {
                worksheetC6.getCell(num_traitement, 31).value = worksheetC6.getCell(num_traitement, 2).value?.toString()
              }


              avanttravaux = worksheetC6.getCell(num_traitement, 31).value?.toString() || "Non";
              aprestravaux = worksheetC6.getCell(num_traitement, 33).value?.toString() || "Non";
              aprestravaux = aprestravaux.replace(/^0+/, '');

              poteaucom = worksheetC6.getCell(num_traitement, 34).value?.toString() || "Non";
              rehausse = worksheetC6.getCell(num_traitement, 35).value || "0";
              //worksheetC6.getCell(num_traitement, 36).value = 'Non';
              //typeBoitier = worksheetC6.getCell(num_traitement, 36).value?.toString() || "Non";
              boitierexistant = worksheetC6.getCell(num_traitement, 37).text || "0";
              transition = worksheetC6.getCell(num_traitement, 38).text || "0";
              distance = worksheetC6.getCell(num_traitement, 39).text || "0";

              latitudeInitiale = worksheetC6.getCell(num_traitement, 4).value?.toString() || "0";
              longitudeInitiale = worksheetC6.getCell(num_traitement, 5).value?.toString() || "0";
              latitudeInitiale = latitudeInitiale.replace('"', '" ');
              longitudeInitiale = longitudeInitiale.replace('"', '" ');



            }



          }
        }


        matchingFibres = baseFibre.cables.filter(
          (element) => element.Nom === cable
        );

        

        if (matchingFibres?.length == 0) {
          const cell = worksheetC6.getCell(rowNum, 19);
        
          if (cell.style?.font) {
            cell.style.font.bold = false;
          }
        
          if (cableCell.style?.font) {
            cableCell.style.font.bold = false;
          }
        }

        let correctionAlaVolee = typeAppui.toString();
        if(no_calc.includes(correctionAlaVolee)) {
          correctionAlaVolee = "ORT";
        }

        const appui = {
          nom: depart.toString(),
          type: correctionAlaVolee,
          tiers: false,
          pose_cable: cableCell.style?.font?.bold,
          lignes_poses: [],
          boitier: typeBoitier,
          remplacement: remplacement,
          avanttravaux: avanttravaux,
          aprestravaux: aprestravaux.trim(),
          poteaucom: poteaucom,
          insee: insee,
          latitude: "0",
          longitude: "0",
          angleSuivant: 0,
          longueurSuivant: 0,
          etiquette: etiquette,
          utilisable: utilisable,
          milieu: milieu,
          electrique: electrique,
          strategique: strategique,
          acces_vehicule: acces_vehicule,
          couleuravant: couleuravant,
          couleurapres: couleurapres,
          couleurremplacement: couleurremplacement,
          indexCalcul: rowNum,
        };
        //if (parcours.length) {
        appui.latitude = latitudeInitiale.toString();
        appui.longitude = longitudeInitiale.toString();

        //console.log(appui)

        //}
        if (no_calc.includes(appui.type) || appui.nom.includes("BT")) {
          //console.log(appui.nom, appui.type)
          appui.tiers = true;
        }
        /*if (appui.pose_cable === true && appui.tiers === false) {
          comptageC6.value = comptageC6.value + 1;
        }*/

        const filteredArray2 = annexesC4.filter(
          (appui: { nom: any }) => appui.nom == depart
        );

        if (
          (appui.remplacement == "Remplacement" ||
            appui.remplacement == "Renforcement") && filteredArray2.length < 1
          && appui.tiers === false
        ) {
          if (appui.avanttravaux.charAt(0) === appui.aprestravaux.charAt(0)) {
            appui.remplacement = "Renforcement"
            worksheetC6.getCell(rowNum, 32).value = "Renforcement"
          } else {
            appui.remplacement = "Remplacement"
            worksheetC6.getCell(rowNum, 32).value = "Remplacement"
          }
          comptageC7.value = comptageC7.value + 1;
          //console.log("c4", appui)
          annexesC4.push(appui);
        }
        const filteredArray1 = parcours.filter(
          (appui: { nom: any }) => appui.nom == depart
        );
        if (filteredArray1.length < 1) {
          parcours.push(appui);
        }

      } else {
        currentLocation = depart;
      }





      if (
        cableCell.style?.font?.bold &&
        parcours.find((objet) => objet.nom === depart)
      ) {
        const resultat = parcours.find((objet) => objet.nom === depart);
        resultat.pose_cable = true;
        resultat.lignes_poses.push(rowNum);
        //console.log("bold et existant", depart, cableCell.value, rowNum);
      }




      if (
        cableCell.font &&
        cableCell.style.font?.bold &&
        matchingFibres.length > 0
      ) {
        const ligneC6 = {
          depart: depart.toString(),
          arrivee: arrivee.toString(),
          cable: cable,
          insee_depart: res_text[0].COM,
          insee_arrivee: res_text[0].COM,
          matchingFibres: matchingFibres,
          analysed: 0,
          longueur: longueur,
          angle: angle,
          type: "aérien",
          diametre: Math.ceil(parseFloat(matchingFibres[0].Diamètre) * 2) / 2, //Arrondi au demi entier supérieur
          index: index,
        };
        let BTversBT = false;
        const filteredArray1 = parcours.filter(
          (appui: { nom: any }) => appui.nom == depart
        );
        const filteredArray2 = parcours.filter(
          (appui: { nom: any }) => appui.nom == arrivee
        );

        if (filteredArray1.length > 0 && filteredArray2.length > 0) {
          if (
            filteredArray1[0].tiers === true &&
            filteredArray2[0].tiers === true
          ) {
            BTversBT = true;
          }
        } else {
          if (
            arrivee.toString().includes("BT") &&
            no_calc.includes(typeAppui)
          ) {
            BTversBT = true;
          }
          if (
            depart.toString().includes("BT") &&
            arrivee.toString().includes("BT")
          ) {
            BTversBT = true;
          }
        }

        if (BTversBT === false) {
          excelData.push(ligneC6);
        }

        index++;
      }

      const ligneComplete = {
        depart: depart_cable,
        arrivee: arrivee,
        pose_cable: cableCell.style?.font?.bold,
        cable: cable,
        matchingFibres: matchingFibres,
        analysed: 0,
        longueur: longueur,
        angle: angle,
        type: "aérien",
        index: index,
        adresse_appui: adresse_appui,
        code_centre: code_centre,
        visuel: visuel,
        verticalite: verticalite,
        flambement: flambement,
        voisinage: voisinage,
        pointe_carree: pointe_carree,
        secousses: secousses,
        percussions: percussions,
        etiquette: etiquette,
        utilisable: utilisable,
        milieu: milieu,
        electrique: electrique,
        strategique: strategique,
        acces_vehicule: acces_vehicule,
        cuivre: cuivre,
        optique: optique,
        effortavant: effortavant,
        effortapres: effortapres,
        effortremplace: effortremplace,
        avanttravaux: avanttravaux,
        remplacement: remplacement,
        aprestravaux: aprestravaux,
        poteaucom: poteaucom,
        rehausse: rehausse,
        typeBoitier: typeBoitier,
        boitierexistant: boitierexistant,
        transition: transition,
        distance: distance,
        fttx: fttx,
        bfttx: bfttx,
        amont: amont,
        hypothese: hypothese,
        hypothese2: hypothese2,
        fleche: fleche,
      };
      lignesC6.push(ligneComplete);
      C6Brute.push(ligneComplete)
      //console.log(ligneComplete.depart, ligneComplete.cable)
    }

    ///////////////////
    //
    // excelData.map va servir à retirer les ligne dupliquées
    // elles existent car pour 1 câble, la C6 va nous afficher l'allée et le retour
    // Donc 1 câble qui va de A à B aura aussi sont B à A dedans
    //
    ///////////////////

    if (type_deploiement_transport) {
      excelData = filterTransportDuplicates(excelData);
    }

    encoursc7titre.value = "Suppression des doublons aller-retours";
    console.log('excelData', excelData);
    excelData.map((ligneC6: any) => {
      excelData = updateDuplicate(ligneC6, excelData);
      ligneC6.analysed = 1;
    });

    encoursc7titre.value = "Calibrage des coordonnées";

    ///////
    // Récupération des adjacences
    ///////

    let communes_adjacentes: any[] = [];
    for (const commune of adjacences.features) {
      if (commune.insee.length == 4) {
        commune.insee = "0" + commune.insee;
      }
      if (commune.insee == parcours[0].insee) {
        const communes_adjacentes_2 = commune.insee_v.split("|");
        //console.log(communes_adjacentes_2)
        communes_adjacentes = communes_adjacentes.concat(communes_adjacentes_2);
        //console.log(communes_adjacentes)
        for (const communeAjacente of communes_adjacentes_2) {
          for (const commune2 of adjacences.features) {
            if (commune2.insee.length == 4) {
              commune2.insee = "0" + commune2.insee;
            }
            if (commune2.insee == communeAjacente) {
              const nouvelle_adjacences = commune2.insee_v.split("|");
              communes_adjacentes =
                communes_adjacentes.concat(nouvelle_adjacences);
              //console.log(communes_adjacentes)
            }
          }
        }
      }
    }

    const uniqueCommunes = communes_adjacentes.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    //console.log("Ajacences detectees", uniqueCommunes)
    const url = `${prodEnvironment.baseUrl}api/gcblo/get/adjacences`;
    await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        adjacences: uniqueCommunes,
      }),
    }).then(async (res) => {
      const geojson = JSON.parse(await res.text());
      zoneAdjacences.value = geojson;
    });

    ///////
    // Chaque appui va être réparé ou converti au niveau des coordonnées
    ///////
    parcours = await calibrageAppuiParCoordonnees(worksheetC6, parcours, operateur);
    if (cancelLectureC6.value) {
      presentToast("Lecture C6 annulée", "warning-outline");
      return;
    }

    //console.log("Lignes C6", lignesC6)
    if (specialbatch === false) {
      await verifierIN8(worksheetC6);
      await verifierIN9(worksheetC6);
      try {
        await verifierCorrespondanceCommune(
          parcours,
          worksheetC6,
          workbook,
          excelData,
          res_text
        );
      } catch (e: any) {
        if (e.toString().includes('coordinates must contain numbers')) {
          messageAlerte.value = 'Erreur dans Export 1'
          messageAlerte2.value = "Une coordonnée n'est pas au bon format."
          setOpen(true)
        }
      }

    }

    //console.log('CCV', excelData.length, lignesC6.length)
    if (completementAutreCommune) {
      const nouvelle_commune = datagouv
        .filter((point_technique) => point_technique.COM == communes_annexes[0])
        .slice(0, 1);

      communes_annexes = [];

      if (specialbatch === true) {
        res_text = nouvelle_commune;
        insee = res_text[0].COM;
        presentToast(`Application commune ${nouvelle_commune[0].NCC}`, "info");
        for (const appui of parcours) {
          appui.insee = res_text[0].COM;
        }
      } else {
        const { value } = await Dialog.confirm({
          title: "Label",
          message: `La commande est à 100% sur ${nouvelle_commune[0].NCC} (${nouvelle_commune[0].COM}), changer les annexes?`,
        });
        if (value) {
          res_text = nouvelle_commune;
          insee = res_text[0].COM;
          presentToast(
            `Application commune ${nouvelle_commune[0].NCC}`,
            "info"
          );
          for (const appui of parcours) {
            appui.insee = res_text[0].COM;
          }
        } else {
          presentToast(
            `Changement vers ${nouvelle_commune[0].NCC} annulé`,
            "info"
          );
        }
      }
    }

    //console.log(workbook.worksheets)
    //COMMUNE
    nom_commune = res_text[0].NCC.replace(" ", "");
    const cell7 = worksheetC6.getCell("C3");
    cell7.value = res_text[0].NCC;
    const cell8 = worksheetSaisies.getCell("C3");
    cell8.value = res_text[0].NCC;
    const cell9 = worksheetC6.getCell("G3");
    cell9.value = res_text[0].COM;
    const cell0 = worksheetSaisies.getCell("G3");
    cell0.value = res_text[0].COM;
    console.log(parcours)
    const imagesPourFiches = worksheetPhotos.getImages().sort((a: any, b: any) => a.range.tl.row - b.range.tl.row);
    let traitement;
    if (specialbatch === false) {
      
      encoursc6titre.value = "Placement des photos..";

      const messagePhotos = statutPhotos(imagesPourFiches, parcours);
      traitement = await consententActionSheet(messagePhotos, [
        {
          nom: "Traiter les photos",
          role: "Traiter",
          data: { action: "delete" },
        },
        { nom: "Vider mon onglet", role: "Vider", data: { action: "delete" } },
        {
          nom: "Laisser mon onglet",
          role: "Laisser",
          data: { action: "delete" },
        },
      ]);
    }
    //console.log("traitement", traitement, calibragePhotoState)
    if (traitement == "TraiterDft") {
      checkedD13.value = true
    }
    /////////////
    //
    // calibragePhotoState
    // 0 = Le nombre de photos correspond au parcours
    // 1 = Le nombre de photos correspond au parcours d'appuis avec de la fibre dessus
    // 2 = Le nombre de photos correspond au parcours d'appuis avec de la fibre dessus mais seulement les FranceTelecom
    // 3 = Le nombre de photos ne correspond à rien
    //
    /////////////

    if (
      worksheetPhotos &&
      specialbatch === false &&
      traitement == "Traiter" &&
      checkedDFT.value === false
    ) {
      coef_d13.value = 2;
      worksheetPhotos.orderNo = 3;

      switch (calibragePhotoState) {
        case 0:
          await gestionDesPhotos(
            worksheetPhotos,
            sheetRosalyna,
            workbook,
            imagesPourFiches
          );
          break;
        case 1:
          await gestionDesPhotosAppuisFibres(
            worksheetPhotos,
            sheetRosalyna,
            workbook,
            parcours,
            imagesPourFiches
          );
          break;
        case 2:
          await gestionDesPhotosAppuisFibresFT(
            worksheetPhotos,
            sheetRosalyna,
            workbook,
            parcours_fibre,
            imagesPourFiches
          );
          break;
        case 3:
          await gestionDesPhotos(
            worksheetPhotos,
            sheetRosalyna,
            workbook,
            imagesPourFiches
          );
          break;
      }
    } else {
      listeRemarques.value.message.unshift("Pas de traitement photos.");
    }

    if (
      worksheetPhotos &&
      specialbatch === false &&
      traitement == "Vider" &&
      checkedDFT.value === false
    ) {
      await gestionSansPhotos(
        worksheetPhotos,
        sheetRosalyna,
        workbook,
        imagesPourFiches
      );
    }

    listerSurplusCables(
      excelData.filter((ligneC6: any) => ligneC6.analysed == 1)
    );

    comptageC6.value = parcours.filter((appui: any) => appui.pose_cable == true && appui.tiers === false).length;

    if (checkedShapefile.value === true || checkedGeojson.value === true) {
      encoursPlantitre.value = "Dessin du plan en cours";
      await composerShapefile(
        excelData.filter((ligneC6: any) => ligneC6.analysed == 1),
        parcours,
        fciCommande.value,
        insee,
        specialbatch,
        operateur,
        siren_cible,
        saisiesterrainfci
      );
    } else {
      encoursPlantitre.value = "Ecritures plans abandonnées.";
      encoursPlan.value = true;
      encoursGJSON.value = true;
    }

    if (specialbatch === false) {
      encoursFichesTitre.value = "Création des fiches appuis";




      if (checkedD13.value === true) {

        if (traitement == "Traiter") {
          coef_d13.value = 2;
          composerFichesAppuis(
            imagesPourFiches,
            lignesC6,
            res_text,
            parcours,
            worksheetPhotos,
            model_br,
            model_tl,
            workbook,
            todayVal,
            operateur,
            false
          );
        }





      } else {
        encoursFichesTitre.value = "Ecritures D13 abandonnées.";
        encoursFiches.value = true;
        encoursFichesDft.value = true;
      }

      ////////////////
      // Composer la C7
      ////////////////

      encoursc7titre.value = "Ecriture de la C7";
      if (checkedC7.value === true && comptageC7.value > 0) {
        composerC7(
          worksheetModeleC7Commande,
          worksheetModeleC7Restitution,
          parcours,
          operateur,
          cellValues,
          siren_cible,
          res_text, workbookModeleC7, sous_traitant
        );
        encoursc7titre.value = "Votre annexe C7 est prête.";
        encoursc7.value = true;
      } else {
        encoursc7titre.value = "Ecriture C7 abandonnée.";
        encoursc7.value = true;
      }

      if (comptageC7.value > 0) {
        if (checkedC4.value === true) {
          composerC4(res_text, fci, todayVal, sous_traitant);
        } else {
          encoursc4titre.value = "Annexes C4 abandonnées.";
          encoursc4.value = true;
        }
      } else {
        encoursc4titre.value = "Aucun remplacement, pas de C4.";
        encoursc4.value = true;
      }

      const addedImageId = workbook.addImage({
        buffer: logo_orange_c6,
        extension: "png",
      });

      sheet.addImage(addedImageId, {
        tl: { col: 0.1, row: 1 },
        ext: { width: 62, height: 70 },
        editAs: "oneCell",
      });

      model_br.worksheet = sheet;
      model_tl.worksheet = sheet;

      if (traitement == "Traiter" || traitement == "Vider") {
        workbook.removeWorksheet(worksheetPhotos.id);
        sheetRosalyna.name = "Photos";
        sheetRosalyna.orderNo = 3;
      } else {
        workbook.removeWorksheet(sheetRosalyna.id);
      }

      if (communes_annexes.length > 0) {
        workbook.xlsx
          .writeBuffer()
          .then(function (buffer: any) {
            tableauBlobC6.annexes.push({
              commune: "",
              blob: new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
            });
          })
          .catch(async function (error: any) {
            encoursc6titre.value = error;
            console.warn(error);
          });

        let LeCompteur = 0;
        for (const commune of communes_annexes) {
          LeCompteur++;
          const nouvelle_commune = datagouv
            .filter((point_technique) => point_technique.COM == commune)
            .slice(0, 1);
          //console.log(workbook)
          const newWorksheetPhotos = workbook.addWorksheet(
            "Photos " +
            nouvelle_commune[0].COM +
            " - " +
            nouvelle_commune[0].NCC
          );
          if (traitement == "Traiter" || traitement == "Vider") {
            copyWorkSheet(
              sheetRosalyna,
              newWorksheetPhotos,
              workbook.worksheets.length - 1,
              "Photos " +
              nouvelle_commune[0].COM +
              " - " +
              nouvelle_commune[0].NCC
            );
          } else {
            copyWorkSheet(
              worksheetPhotos,
              newWorksheetPhotos,
              workbook.worksheets.length - 1
            );
          }

          const newWorksheetExport1 = workbook.addWorksheet(
            nouvelle_commune[0].COM + " - " + nouvelle_commune[0].NCC
          );
          //console.log("sheets", worksheetC6, newWorksheetExport1)
          copyWorkSheet(
            worksheetC6,
            newWorksheetExport1,
            workbook.worksheets.length - 1,
            nouvelle_commune[0].COM + " - " + nouvelle_commune[0].NCC
          );
          const cell7 = newWorksheetExport1.getCell("C3");
          cell7.value = nouvelle_commune[0].NCC;
          const cell9 = newWorksheetExport1.getCell("G3");
          cell9.value = nouvelle_commune[0].COM;
          filtrerInseeWorkbook(
            parcours,
            newWorksheetExport1,
            workbook,
            commune,
            newWorksheetPhotos,
            LeCompteur,
            nouvelle_commune[0].NCC
          );
        }
      } else {
        workbook.xlsx
          .writeBuffer()
          .then(function (buffer: any) {
            tableauBlobC6.annexes.push({
              commune: "",
              blob: new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
            });
            if (communes_annexes.length > 0) {
              listeRemarques.value.message.unshift("Il y a des communes en plus à traiter")
            }
            encoursc6titre.value = "Votre annexe C6 est prête.";
            encoursc6.value = true;
          })
          .catch(async function (error: any) {
            encoursc6titre.value = error;
            //console.warn(error);
            if (error.toString().includes('Unsupported media')) {
              messageAlerte.value = "Erreur dans l'onglet Photos"
              messageAlerte2.value = "Un problème est survenu au niveau des photos."
              setOpen(true)
            }

          });
      }

      encoursc3atitre.value = "Rassemblement des informations dans la C3A";
      if (checkedC3A.value === true) {
        blobC3A = await c6versC3a(
          excelData.filter((ligneC6: any) => ligneC6.analysed == 1),
          parcours,
          fciCommande.value,
          insee
        );
        encoursc3a.value = true;
      } else {
        encoursc3atitre.value = "Ecriture C3A abandonnée";
        encoursc3a.value = true;
      }

      if (comptageC7.value > 0 && checkedC7.value === true) {
        workbookModeleC7.xlsx.writeBuffer().then(function (buffer: any) {
          blobC7 = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
        });
        encoursc7.value = true;
      } else {
        encoursc7.value = true;
      }
    }
  }
};

function filtrerInseeWorkbook(
  parcours: any,
  worksheet: any,
  workbook: any,
  insee: any,
  newWorksheetPhotos: any,
  LeCompteur: any,
  nom_commune: any
) {
  let currentLocation: any;
  for (let rowNum = 9; rowNum <= worksheet.rowCount; rowNum++) {
    if (!worksheet.getCell(rowNum, 19).value) {
      break;
    }
    let depart = worksheet.getCell(rowNum, 1).value;
    const cableCell = worksheet.getCell(rowNum, 19);
    const arrivee = worksheet.getCell(rowNum, 25).value;

    if (
      depart !== null &&
      depart !== undefined &&
      depart !== "" &&
      depart != "N° appui"
    ) {
      currentLocation = depart;
    } else {
      depart = currentLocation;
    }




    const filteredArray = parcours.filter(
      (appui: { nom: any }) => appui.nom == currentLocation
    );
    const appuisHorsCommune = parcours.filter(
      (appui: { insee_annexe: any }) => appui.insee_annexe != insee
    );
    const filteredArrayDestination = appuisHorsCommune.filter(
      (appui: { nom: any }) => appui.nom == arrivee
    );
    //const commentaire = worksheet.getCell(rowNum, 41).value?.toString() || 'Non';
    //console.log("commentaire " + rowNum, currentLocation, filteredArray[0].insee_annexe)
    if (filteredArray[0].insee_annexe != insee) {
      worksheet.spliceRows(rowNum, 1);
      rowNum = rowNum - 1;
    }
    if (filteredArrayDestination.length == 1) {
      //console.log(filteredArrayDestination[0].nom, arrivee)
      if (
        worksheet.getCell(rowNum, 19).style !== undefined &&
        worksheet.getCell(rowNum, 28).style !== null &&
        worksheet.getCell(rowNum, 19).value != "Nom du câble"
      ) {
        worksheet.getCell(rowNum, 19).style = undefined;
      }
      cacherPhotoWorksheet(newWorksheetPhotos, arrivee);
    }
  }

  //console.log("WORKBOOK", workbook)
  workbook.xlsx
    .writeBuffer()
    .then(function (buffer: any) {
      tableauBlobC6.annexes.push({
        commune: nom_commune,
        blob: new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
      });
      if (communes_annexes.length > LeCompteur) {
        listeRemarques.value.message.unshift(
          "Il y a des communes en plus à traiter"
        );
      } else {
        encoursc6titre.value = "Vos annexes C6 sont prêtes.";
        encoursc6.value = true;
      }
    })
    .catch(async function (error: any) {
      encoursc6titre.value = error;
      console.warn(error);
    });

  workbook.removeWorksheet(newWorksheetPhotos.id);
  workbook.removeWorksheet(worksheet.id);
}

function cacherPhotoWorksheet(worksheet: any, nom: any) {
  worksheet.eachRow({ includeEmpty: true }, (row: any, rowNumber: any) => {
    if (row.getCell(1).text.includes(nom)) {
      worksheet.getRow(rowNumber - 1).hidden = true;
      worksheet.getRow(rowNumber).hidden = true;
    }
  });
}

function estComposeDeChiffres(chaine: string): boolean {
  // Utilise une expression régulière pour vérifier si la chaîne est composée uniquement de chiffres
  const regex = /^[0-9]+$/;
  return regex.test(chaine);
}

async function verifierIN8(worksheetC6: any) {
  //console.log('ACV', excelData.length, lignesC6.length)

  for (const app of parcours) {
    if (app.acces_vehicule == "IN8") {
      app.remplacement = "";
      app.aprestravaux = "";
      app.avanttravaux = "";
      let currentLocation;
      let premier = true;
      for (let rowNum = 9; rowNum <= worksheetC6.rowCount; rowNum++) {
        if (!worksheetC6.getCell(rowNum, 19).value) {
          break;
        }
        let depart = worksheetC6.getCell(rowNum, 1).value;
        const cableCell = worksheetC6.getCell(rowNum, 19);
        const arrivee = worksheetC6.getCell(rowNum, 25).value;
        if (
          depart !== null &&
          depart !== undefined &&
          depart !== "" &&
          depart != "N° appui"
        ) {
          currentLocation = depart;
        } else {
          depart = currentLocation;
        }

        if (depart == app.nom && premier === true) {
          worksheetC6.getCell(rowNum, 41).value =
            "IN8 selon Orange, doit être contourné.";
          worksheetC6.getCell(rowNum, 9).value = "Non";
          worksheetC6.getCell(rowNum, 14).value = "Non";
          worksheetC6.getCell(rowNum, 16).value = "Oui";
          worksheetC6.getCell(rowNum, 26).value = "";
          worksheetC6.getCell(rowNum, 27).value = "";
          worksheetC6.getCell(rowNum, 28).value = "";
          worksheetC6.getCell(rowNum, 29).value = "";
          worksheetC6.getCell(rowNum, 30).value = "";
          worksheetC6.getCell(rowNum, 31).value = "";
          worksheetC6.getCell(rowNum, 32).value = "";
          worksheetC6.getCell(rowNum, 33).value = "";
          worksheetC6.getCell(rowNum, 34).value = "";
          worksheetC6.getCell(rowNum, 35).value = "";
          worksheetC6.getCell(rowNum, 36).value = "";

          if (
            worksheetC6.getCell(rowNum, 9).style !== undefined &&
            worksheetC6.getCell(rowNum, 9).style !== null
          ) {
            worksheetC6.getCell(rowNum, 9).style = undefined;
          }
          if (
            worksheetC6.getCell(rowNum, 14).style !== undefined &&
            worksheetC6.getCell(rowNum, 14).style !== null
          ) {
            worksheetC6.getCell(rowNum, 14).style = undefined;
          }
          if (
            worksheetC6.getCell(rowNum, 28).style !== undefined &&
            worksheetC6.getCell(rowNum, 28).style !== null
          ) {
            worksheetC6.getCell(rowNum, 28).style = undefined;
          }
          if (
            worksheetC6.getCell(rowNum, 29).style !== undefined &&
            worksheetC6.getCell(rowNum, 28).style !== null
          ) {
            worksheetC6.getCell(rowNum, 29).style = undefined;
          }
          if (
            worksheetC6.getCell(rowNum, 30).style !== undefined &&
            worksheetC6.getCell(rowNum, 28).style !== null
          ) {
            worksheetC6.getCell(rowNum, 30).style = undefined;
          }
          premier = false;
        }

        if (arrivee == app.nom && cableCell.style?.font?.bold) {
          //console.log(app.nom, 'en arrivee')
          //cableCell.value = 'Liaison';
          if (cableCell.style !== undefined && cableCell.style !== null) {
            cableCell.style = undefined;
          }
        }
        if (depart == app.nom && cableCell.style?.font?.bold) {
          //console.log(app.nom, 'en depart')
          //cableCell.value = 'Liaison';
          if (cableCell.style !== undefined && cableCell.style !== null) {
            cableCell.style = undefined;
          }
        }
      }

      excelData = excelData.filter(
        (objet: { arrivee: any; depart: any }) =>
          objet.arrivee !== app.nom && objet.depart !== app.nom
      );
      lignesC6 = lignesC6.filter(
        (objet: { arrivee: any; depart: any }) =>
          objet.arrivee !== app.nom && objet.depart !== app.nom
      );
    }
  }
  //console.log('BCV', excelData.length, lignesC6.length)
}

async function verifierIN9(worksheetC6: any) {
  //console.log('ACV', excelData.length, lignesC6.length)

  for (const app of parcours) {
    if (app.acces_vehicule == "IN9") {
      app.remplacement = "";
      app.aprestravaux = "";
      app.avanttravaux = "";
      let currentLocation;
      let premier = true;
      for (let rowNum = 9; rowNum <= worksheetC6.rowCount; rowNum++) {
        if (!worksheetC6.getCell(rowNum, 19).value) {
          break;
        }
        let depart = worksheetC6.getCell(rowNum, 1).value;
        const cableCell = worksheetC6.getCell(rowNum, 19);
        const arrivee = worksheetC6.getCell(rowNum, 25).value;
        if (
          depart !== null &&
          depart !== undefined &&
          depart !== "" &&
          depart != "N° appui"
        ) {
          currentLocation = depart;
        } else {
          depart = currentLocation;
        }

        if (depart == app.nom && premier === true) {
          worksheetC6.getCell(rowNum, 41).value =
            "IN9 selon Orange, doit être contourné.";
          worksheetC6.getCell(rowNum, 9).value = "Non";
          worksheetC6.getCell(rowNum, 14).value = "Non";
          worksheetC6.getCell(rowNum, 16).value = "Oui";
          worksheetC6.getCell(rowNum, 26).value = "";
          worksheetC6.getCell(rowNum, 27).value = "";
          worksheetC6.getCell(rowNum, 28).value = "";
          worksheetC6.getCell(rowNum, 29).value = "";
          worksheetC6.getCell(rowNum, 30).value = "";
          worksheetC6.getCell(rowNum, 31).value = "";
          worksheetC6.getCell(rowNum, 32).value = "";
          worksheetC6.getCell(rowNum, 33).value = "";
          worksheetC6.getCell(rowNum, 34).value = "";
          worksheetC6.getCell(rowNum, 35).value = "";
          worksheetC6.getCell(rowNum, 36).value = "";

          if (
            worksheetC6.getCell(rowNum, 9).style !== undefined &&
            worksheetC6.getCell(rowNum, 9).style !== null
          ) {
            worksheetC6.getCell(rowNum, 9).style = undefined;
          }
          if (
            worksheetC6.getCell(rowNum, 14).style !== undefined &&
            worksheetC6.getCell(rowNum, 14).style !== null
          ) {
            worksheetC6.getCell(rowNum, 14).style = undefined;
          }
          if (
            worksheetC6.getCell(rowNum, 28).style !== undefined &&
            worksheetC6.getCell(rowNum, 28).style !== null
          ) {
            worksheetC6.getCell(rowNum, 28).style = undefined;
          }
          if (
            worksheetC6.getCell(rowNum, 29).style !== undefined &&
            worksheetC6.getCell(rowNum, 28).style !== null
          ) {
            worksheetC6.getCell(rowNum, 29).style = undefined;
          }
          if (
            worksheetC6.getCell(rowNum, 30).style !== undefined &&
            worksheetC6.getCell(rowNum, 28).style !== null
          ) {
            worksheetC6.getCell(rowNum, 30).style = undefined;
          }
          premier = false;
        }

        if (arrivee == app.nom && cableCell.style?.font?.bold) {
          //console.log(app.nom, 'en arrivee')
          //cableCell.value = 'Liaison';
          if (cableCell.style !== undefined && cableCell.style !== null) {
            cableCell.style = undefined;
          }
        }
        if (depart == app.nom && cableCell.style?.font?.bold) {
          //console.log(app.nom, 'en depart')
          //cableCell.value = 'Liaison';
          if (cableCell.style !== undefined && cableCell.style !== null) {
            cableCell.style = undefined;
          }
        }
      }

      excelData = excelData.filter(
        (objet: { arrivee: any; depart: any }) =>
          objet.arrivee !== app.nom && objet.depart !== app.nom
      );
      lignesC6 = lignesC6.filter(
        (objet: { arrivee: any; depart: any }) =>
          objet.arrivee !== app.nom && objet.depart !== app.nom
      );
    }
  }
  //console.log('BCV', excelData.length, lignesC6.length)
}

async function verifierCorrespondanceCommune(
  parcours: any,
  worksheetC6: any,
  workbook: any,
  excelData: any,
  res_text: any
) {
  ////////
  //
  // Avec l'insee de la C6, récupérer les communes adjacentes
  //
  ////////
  let communes_adjacentes: any[] = [];
  for (const commune of adjacences.features) {
    if (commune.insee.length == 4) {
      commune.insee = "0" + commune.insee;
    }
    if (commune.insee == parcours[0].insee) {
      const communes_adjacentes_2 = commune.insee_v.split("|");
      //console.log(communes_adjacentes_2)
      communes_adjacentes = communes_adjacentes.concat(communes_adjacentes_2);
      //console.log(communes_adjacentes)
      for (const communeAjacente of communes_adjacentes_2) {
        for (const commune2 of adjacences.features) {
          if (commune2.insee.length == 4) {
            commune2.insee = "0" + commune2.insee;
          }
          if (commune2.insee == communeAjacente) {
            const nouvelle_adjacences = commune2.insee_v.split("|");
            communes_adjacentes =
              communes_adjacentes.concat(nouvelle_adjacences);
            //console.log(communes_adjacentes)
          }
        }
      }
    }
  }

  const uniqueCommunes = communes_adjacentes.filter((value, index, self) => {
    return self.indexOf(value) === index;
  });
  //console.log("Ajacences detectees", uniqueCommunes)
  const url = `${prodEnvironment.baseUrl}api/gcblo/get/adjacences`;
  await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      adjacences: uniqueCommunes,
    }),
  }).then(async (res) => {
    const geojson = JSON.parse(await res.text());
    //console.log(geojson)
    const pfibre = [];
    for (const appui of parcours) {
      if (appui.pose_cable === true) {
        pfibre.push(appui);
      }
    }

    const polygoneCorrespondant = geojson.features.find((polygone: any) => {
      return polygone.properties.insee == parcours[0].insee;
    });

    let polygon;
    if (polygoneCorrespondant) {
      //console.log("poly", polygoneCorrespondant)
      polygon = turf.polygon(polygoneCorrespondant);
    } else {
      polygon = turf.polygon(geojson.features[0]);
    }

    for (const app of parcours) {
      //console.log(app)
      const x = parseFloat(app.longitude);
      const y = parseFloat(app.latitude);
      const point = turf.point([x, y]);
      //console.log('pour point', point)
      let trouve = false;

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      for (const feature of geojson.features) {
        let estDansleTampon = false;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const distance = distanceToPolygon(point, polygoneCorrespondant);
        //console.log("distance", distance)
        if (distance < 100) {
          estDansleTampon = true;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (turf.inside(point, feature)) {
          //console.log(app.insee, feature.properties.insee)
          if (app.insee != feature.properties.insee && app.pose_cable) {
            compteurAppuisHorsCommunes++;
            listeRemarques.value.message.unshift(
              `(${compteurAppuisHorsCommunes}/${pfibre.length}) L'appui ${app.nom} se trouve à ${feature.properties.nom} (${feature.properties.insee})`
            );
            comptageCorrection.value = comptageCorrection.value + 1;
            if (!communes_annexes.includes(feature.properties.insee)) {
              communes_annexes.push(feature.properties.insee);
              annexesC6.push({ nom: feature.properties.insee });
            }
            excelData.forEach(
              (objet: {
                arrivee: any;
                insee_arrivee: string;
                depart: any;
                insee_depart: string;
              }) => {
                if (objet.arrivee === app.nom) {
                  objet.insee_arrivee = feature.properties.insee;
                }
                if (objet.depart === app.nom) {
                  objet.insee_depart = feature.properties.insee;
                }
              }
            );

            let currentLocation;
            for (let rowNum = 9; rowNum <= worksheetC6.rowCount; rowNum++) {
              if (!worksheetC6.getCell(rowNum, 19).value) {
                break;
              }
              let depart = worksheetC6.getCell(rowNum, 1).value;

              if (
                depart !== null &&
                depart !== undefined &&
                depart !== "" &&
                depart != "N° appui"
              ) {
                currentLocation = depart;
              } else {
                depart = currentLocation;
              }

              if (depart === app.nom) {
                //worksheetC6.getCell(rowNum, 41).value = feature.properties.insee;
              }
            }
          }
          app.insee_annexe = feature.properties.insee;
          trouve = true;
          break;
          //}
        }
      }
      if (!trouve) {
        listeRemarques.value.message.unshift(
          `L'appui ${app.nom} semble très éloigné de votre commune.`
        );
      }
    }

    for (const [index, app] of parcours.entries()) {
      const previousApp = index > 0 ? parcours[index - 1] : null;
      const nextApp = parcours[index + 1];
      if (previousApp === null && nextApp.insee_annexe != app.insee_annexe) {
        //Si je suis au premier élément et que le prochain appui est d'un autre insee
        app.insee_annexe = nextApp.insee_annexe;
      }
      if (
        previousApp !== null &&
        nextApp !== undefined &&
        nextApp.insee_annexe != app.insee_annexe &&
        previousApp.insee_annexe != app.insee_annexe
      ) {
        //Si je suis dans un element intermediaire et que le suivant et precedent sont differents
        app.insee_annexe = previousApp.insee_annexe;
      }
      if (
        nextApp === undefined &&
        previousApp !== null &&
        previousApp.insee_annexe != app.insee_annexe
      ) {
        //Si je suis au dernier élément et que le precedent appui est d'un autre insee
        app.ininsee_annexesee = previousApp.insee_annexe;
      }
    }

    if (
      pfibre.length == compteurAppuisHorsCommunes &&
      communes_annexes.length == 1
    ) {
      completementAutreCommune = true;
    }
  });
}

export function updateDuplicate(ligneC6: any, excelData: any) {
  excelData.map((ligneC6A: any) => {
    if (
      ligneC6.depart == ligneC6A.arrivee &&
      ligneC6.arrivee == ligneC6A.depart &&
      ligneC6.cable == ligneC6A.cable &&
      ligneC6.longueur == ligneC6A.longueur
    ) {
      ligneC6A.analysed = 2; //2 pour doublon
    }
  });
  return excelData;
}

  ////////
  //
  // En cas de déploiement transport, filtrer les doublons du calcul de charge
  //
  ////////
export function filterTransportDuplicates(lc6: any[]) {
  const seen = new Set<string>();
  const result: any[] = [];

  for (const ligne of lc6) {
    // ordre indépendent pour le couple départ/arrivée
    const couple = [ligne.depart, ligne.arrivee].sort().join("|");
    const key = `${couple}|${ligne.cable}|${ligne.longueur}`;

    if (!seen.has(key)) {
      seen.add(key);
      result.push(ligne);
    }
  }

  return result;
}

export const composerFichesAppuisDFT = async (
  res_text: any,
  parcours: any,
  worksheetPhotos: any,
  model_br: any,
  model_tl: any,
  workbookC6: any,
  today: any,
  operateur: any
) => {
  let nouvelleFiche = new ExcelJS.Workbook();
  const limite_vide = 40;
  let vide = 0;
  const imagesPourFiches = worksheetPhotos.getImages().sort((a: any, b: any) => a.range.tl.row - b.range.tl.row);


  for (const image of imagesPourFiches) {
    if (image.range.tl.nativeRow % 2 === 0) {
      image.range.tl.nativeRow++;
    }
  }

  for (const image of imagesPourFiches) {
    if (image.range.tl.nativeRow % 2 !== 0) {
      const filteredArrayPhotos = imagesPourFiches.filter(
        (photo) => photo.range && photo.range.tl && photo.range.tl.nativeRow == image.range.tl.nativeRow && photo.range.tl.nativeCol == image.range.tl.nativeCol && photo.imageId != image.imageId
      );
      if (filteredArrayPhotos[0]) {
        if (filteredArrayPhotos[0].range.tl.nativeColOff > image.range.tl.nativeColOff) {
          filteredArrayPhotos[0].range.tl.nativeColOff = 0;
          filteredArrayPhotos[0].range.tl.nativeCol++;
        } else {
          image.range.tl.nativeColOff = 0;
          image.range.tl.nativeCol++;
        }
      }
    }
  }

  //console.log('lignes photos', worksheetPhotos.rowCount)

  for (let rowNum = 2; rowNum <= worksheetPhotos.rowCount; rowNum++) {

    if (!worksheetPhotos.getCell(rowNum, 1).value) {
      vide++;
      if (limite_vide < vide) {
        messageAlerte.value = "Remarque sur l'onglet Photos"
        messageAlerte2.value = "Vérifiez que vous ayez bien le bon nombre de fiches."
        setOpen(true)
        break;
      }
    } else {
      vide = 0;
    }

    const depart = worksheetPhotos.getCell(rowNum, 1).value;

    if (
      depart !== null &&
      depart !== undefined &&
      depart !== "" &&
      depart != "N° appui"
    ) {
      vide = 0;
      const nom_appui = depart.replace("_1.jpg", "")
      //console.log(nom_appui.replace(/^0+/, ''))
      const filteredArrayA = parcours.filter(
        (appui: { nom: any, tiers: boolean, pose_cable: boolean }) => appui.nom.replace(/^0+/, '') == nom_appui.replace(/^0+/, '')
      );

      //console.log('parcours', nom_appui.replace(/^0+/, ''), filteredArrayA)
      if (filteredArrayA[0] && filteredArrayA[0].pose_cable === true) {
        const filteredArrayPhotos = imagesPourFiches.filter(
          (photo) => photo.range && photo.range.tl && photo.range.tl.nativeRow == rowNum - 2
        );
        const appui = filteredArrayA[0];
        //console.log('photos', nom_appui, rowNum, filteredArrayPhotos)

        nouvelleFiche = new ExcelJS.Workbook();
        const response = await fetch("xlsx/fiche appui.xlsx");
        const data = await response.arrayBuffer();
        await nouvelleFiche.xlsx.load(data);

        const worksheetFicheAppui = nouvelleFiche.getWorksheet("Fiche Appui");
        worksheetFicheAppui.name = appui.nom;

        worksheetFicheAppui.getCell("D3").value = appui.nom;
        worksheetFicheAppui.getCell("A26").value = appui.nom;
        worksheetFicheAppui.getCell("C26").value = appui.type;
        worksheetFicheAppui.getCell("D4").value = res_text[0].NCC;
        worksheetFicheAppui.getCell("J3").value = operateur;
        worksheetFicheAppui.getCell("T1").value = today;

        worksheetFicheAppui.getCell("T3").value = "";
        worksheetFicheAppui.getCell("P4").value = res_text[0].COM;

        worksheetFicheAppui.getCell("V4").value = appui.insee;
        worksheetFicheAppui.getCell("P5").value = appui.latitude;
        worksheetFicheAppui.getCell("P6").value = appui.longitude;

        worksheetFicheAppui.getCell("J9").value = appui.visuel;
        worksheetFicheAppui.getCell("J10").value = appui.verticalite;
        worksheetFicheAppui.getCell("J11").value = appui.flambement;
        worksheetFicheAppui.getCell("J12").value = appui.voisinage;
        worksheetFicheAppui.getCell("F13").value = appui.com;

        worksheetFicheAppui.getCell("V4").value = res_text[0].COM;

        let img;
        let img2;
        let img3;
        let img4;
        let img5;

        const img1Array = filteredArrayPhotos.filter(
          (photo) => photo.range && photo.range.tl && photo.range.tl.nativeCol == 0
        );
        if (img1Array[0]) {
          img = workbookC6.model.media.find(
            (m: { index: any }) => m.index === img1Array[0].imageId
          );
        }
        const img2Array = filteredArrayPhotos.filter(
          (photo) => photo.range && photo.range.tl && photo.range.tl.nativeCol == 1
        );
        if (img2Array[0]) {
          img2 = workbookC6.model.media.find(
            (m: { index: any }) => m.index === img2Array[0].imageId
          );
        }
        const img3Array = filteredArrayPhotos.filter(
          (photo) => photo.range && photo.range.tl && photo.range.tl.nativeCol == 2
        );
        
        if (img3Array[0]) {
          img3 = Object.values(allImagesBuffers.value).flat().filter(item => item.nom == appui.nom && item.position == "0");

        }
        const img4Array = filteredArrayPhotos.filter(
          
          (photo) => photo.range && photo.range.tl && photo.range.tl.nativeCol == 3
        );
        if (img4Array[0]) {
          //console.log("IMG4",imagesBuffers.value)
          img4 = Object.values(allImagesBuffers.value).flat().filter(item => item.nom == appui.nom && item.position == "1");
        }
        const img5Array = filteredArrayPhotos.filter(
          (photo) => photo.range && photo.range.tl && photo.range.tl.nativeCol == 4
        );
        if (img5Array[0]) {
          //console.log("IMG5",imagesBuffers.value)
          img5 = Object.values(allImagesBuffers.value).flat().filter(item => item.nom == appui.nom && item.position == "2");
        }

        //console.log("3", img3)

        let addedImageId = 9999;
        let addedImageId2 = 9999;
        let addedImageId3 = 9999;
        let addedImageId4 = 9999;
        let addedImageId5 = 9999;


        if (img != undefined && img.buffer != undefined) {
          //console.log(appui, "img")
          addedImageId = nouvelleFiche.addImage({
            buffer: img.buffer,
            extension: img.extension,
          });
          worksheetFicheAppui.addImage(addedImageId, {
            tl: Object.assign({}, model_tl),
            br: Object.assign({}, model_br),
          });
        }
        if (img2 != undefined && img2.buffer != undefined) {
          //console.log(appui, "img2")
          addedImageId2 = nouvelleFiche.addImage({
            buffer: img2.buffer,
            extension: img2.extension,
          });
          worksheetFicheAppui.addImage(addedImageId2, {
            tl: Object.assign({}, model_tl),
            br: Object.assign({}, model_br),
          });
        }

        if (img3 != undefined && img3[0] != undefined && img3[0].image != undefined) {
          //console.log(appui, "img3")
          addedImageId3 = nouvelleFiche.addImage({
            buffer: img3[0].image,
            extension: img3[0].ext,
          });
          worksheetFicheAppui.addImage(addedImageId3, {
            tl: Object.assign({}, model_tl),
            br: Object.assign({}, model_br),
          });
        }
        if (img4 != undefined && img4[0] != undefined && img4[0].image != undefined) {
          //console.log(appui, "img2")
          addedImageId4 = nouvelleFiche.addImage({
            buffer: img4[0].image,
            extension: img4[0].ext,
          });
          worksheetFicheAppui.addImage(addedImageId4, {
            tl: Object.assign({}, model_tl),
            br: Object.assign({}, model_br),
          });
        }
        if (img5 != undefined && img5[0] != undefined && img5[0].image != undefined) {
          //console.log(appui, "img2")
          addedImageId5 = nouvelleFiche.addImage({
            buffer: img5[0].image,
            extension: img5[0].ext,
          });
          worksheetFicheAppui.addImage(addedImageId5, {
            tl: Object.assign({}, model_tl),
            br: Object.assign({}, model_br),
          });
        }

        for (const image of worksheetFicheAppui.getImages()) {
          if (image.imageId.toString() == addedImageId?.toString()) {
            //console.log(appui.nom, "gauche", image, addedImageId)
            //image.range.tl = Object.assign({}, model_tl);
            image.range.tl.col = 0; // Juste un peu avant la colonne A (qui est la 1ère colonne)
            image.range.tl.row = 63; // Juste un peu avant la ligne 62
            image.range.tl.nativeCol = 0; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeRow = 63; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

            //image.range.br = Object.assign({}, model_br);
            image.range.br.col = 12; // Juste un peu avant la colonne L (qui est la 12ème colonne)
            image.range.br.row = 81; // Juste un peu avant la ligne 79
            image.range.br.nativeCol = 12; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeRow = 81; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.worksheet = worksheetFicheAppui;
            //console.log(image)
          }
          if (image.imageId.toString() == addedImageId2?.toString()) {
            //console.log(appui.nom, "droite", image, addedImageId2?.toString())
            //image.range.tl = Object.assign({}, model_tl);
            image.range.tl.col = 12; // Juste un peu avant la colonne A (qui est la 1ère colonne)
            image.range.tl.row = 63; // Juste un peu avant la ligne 62
            image.range.tl.nativeCol = 12; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeRow = 63; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

            //image.range.br = Object.assign({}, model_br);
            image.range.br.col = 24; // Juste un peu avant la colonne L (qui est la 12ème colonne)
            image.range.br.row = 81; // Juste un peu avant la ligne 79
            image.range.br.nativeCol = 24; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeRow = 81; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.worksheet = worksheetFicheAppui;
            //console.log(image)
          }
          if (image.imageId.toString() == addedImageId3?.toString()) {
            //console.log(appui.nom, "droite", image, addedImageId2?.toString())
            //image.range.tl = Object.assign({}, model_tl);
            image.range.tl.col = 0; // Juste un peu avant la colonne A (qui est la 1ère colonne)
            image.range.tl.row = 83; // Juste un peu avant la ligne 62
            image.range.tl.nativeCol = 0; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeRow = 83; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

            //image.range.br = Object.assign({}, model_br);
            image.range.br.col = 12; // Juste un peu avant la colonne L (qui est la 12ème colonne)
            image.range.br.row = 101; // Juste un peu avant la ligne 79
            image.range.br.nativeCol = 12; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeRow = 101; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.worksheet = worksheetFicheAppui;
            //console.log(image)
          }
          if (image.imageId.toString() == addedImageId4?.toString()) {
            //console.log(appui.nom, "droite", image, addedImageId2?.toString())
            //image.range.tl = Object.assign({}, model_tl);
            image.range.tl.col = 12; // Juste un peu avant la colonne A (qui est la 1ère colonne)
            image.range.tl.row = 83; // Juste un peu avant la ligne 62
            image.range.tl.nativeCol = 12; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeRow = 83; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

            //image.range.br = Object.assign({}, model_br);
            image.range.br.col = 24; // Juste un peu avant la colonne L (qui est la 12ème colonne)
            image.range.br.row = 101; // Juste un peu avant la ligne 79
            image.range.br.nativeCol = 24; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeRow = 101; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.worksheet = worksheetFicheAppui;
            //console.log(image)
          }
          if (image.imageId.toString() == addedImageId5?.toString()) {
            //console.log(appui.nom, "droite", image, addedImageId2?.toString())
            //image.range.tl = Object.assign({}, model_tl);
            image.range.tl.col = 24; // Juste un peu avant la colonne A (qui est la 1ère colonne)
            image.range.tl.row = 83; // Juste un peu avant la ligne 62
            image.range.tl.nativeCol = 24; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeRow = 83; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

            //image.range.br = Object.assign({}, model_br);
            image.range.br.col = 29; // Juste un peu avant la colonne L (qui est la 12ème colonne)
            image.range.br.row = 101; // Juste un peu avant la ligne 79
            image.range.br.nativeCol = 29; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeRow = 101; // Pour un positionnement précis à l'intérieur de la cellule
            image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
            image.range.br.worksheet = worksheetFicheAppui;
            //console.log(image)
          }
        }

        const filteredArray = C6Brute.filter((ligne: { depart: any }) => ligne.depart === appui.nom);

        /*const filteredArray = lignesC6.filter(
          (ligne: { depart: any }) => ligne.depart === appui.nom
        );*/

        let nommageFiche = `FicheAppui_${appui.nom}.xlsx`;
        if (appui.tiers === true || appui.pose_cable === false) {
          nommageFiche = `NC-FicheAppui_${appui.nom}.xlsx`;
        }


        let compteur = 26;

        //console.log(filteredArray)

        for (const cable of filteredArray) {
          //console.log(compteur, cable)

          if (cable.arrivee != null) {
            if (cable.visuel) {
              worksheetFicheAppui.getCell("D5").value = cable.adresse_appui;

              worksheetFicheAppui.getCell("E7").value = cable.fttx;
              worksheetFicheAppui.getCell("Q7").value = cable.amont;
              worksheetFicheAppui.getCell("W7").value = cable.bfttx;

              worksheetFicheAppui.getCell("J9").value = cable.visuel;
              worksheetFicheAppui.getCell("J10").value = cable.verticalite;
              worksheetFicheAppui.getCell("J11").value = cable.flambement;
              worksheetFicheAppui.getCell("J12").value = cable.electrique;
              worksheetFicheAppui.getCell("U9").value = cable.pointe_carree;
              worksheetFicheAppui.getCell("U10").value = cable.secousses;
              worksheetFicheAppui.getCell("U11").value = cable.percussions;
              worksheetFicheAppui.getCell("U12").value = cable.etiquette;
              worksheetFicheAppui.getCell("W12").value = cable.utilisable;
              if (cable.etiquette == "Non") {
                worksheetFicheAppui.getCell("W13").value = "Non";
                worksheetFicheAppui.properties.tabColor = { argb: "FFFF0000" };
                listeRemarques.value.message.unshift(
                  `L'appui ${cable.depart} a une étiquette jaune.`
                );
              }

              worksheetFicheAppui.getCell("F18").value = cable.rehausse;
              worksheetFicheAppui.getCell("H19").value = cable.boitierexistant;
              worksheetFicheAppui.getCell("H19").value = cable.boitierexistant;
              worksheetFicheAppui.getCell("N18").value = cable.typeBoitier;
              worksheetFicheAppui.getCell("P19").value = cable.transition;
              worksheetFicheAppui.getCell("W19").value = cable.distance;
              //manque lovage

              worksheetFicheAppui.getCell("C26").value = appui.type;
              worksheetFicheAppui.getCell("O26").value = cable.cuivre;
              worksheetFicheAppui.getCell("Q26").value = cable.optique;
              worksheetFicheAppui.getCell("S26").value = cable.effortavant;
              worksheetFicheAppui.getCell("U26").value = cable.effortapres;

              if (cable.aprestravaux != "Non") {
                worksheetFicheAppui.getCell("W26").value = cable.effortremplace;
                worksheetFicheAppui.getCell("M52").value = cable.aprestravaux;
                worksheetFicheAppui.getCell("M53").value = appui.remplacement;
              }

              worksheetFicheAppui.getCell("W52").value = cable.milieu;
              worksheetFicheAppui.getCell("W53").value = cable.voisinage;
              worksheetFicheAppui.getCell("W54").value = cable.acces_vehicule;
              worksheetFicheAppui.getCell("O54").value = cable.strategique;
              worksheetFicheAppui.getCell("W53").value = cable.voisinage;
            }

            worksheetFicheAppui.getCell(compteur, 5).value = cable.cable;
            worksheetFicheAppui.getCell(compteur, 7).value = cable.longueur;
            worksheetFicheAppui.getCell(compteur, 9).value = cable.angle;
            worksheetFicheAppui.getCell(
              compteur,
              11
            ).value = `${cable.fleche} m, à 15°C`;
            worksheetFicheAppui.getCell(compteur, 13).value = cable.arrivee;

            if (cable.pose_cable && cable.matchingFibres.length > 0) {
              //console.log(cable.matchingFibres[0])
              if (
                worksheetFicheAppui.getCell("D15").value === null ||
                worksheetFicheAppui.getCell("D15").value === undefined
              ) {
                worksheetFicheAppui.getCell("D15").value = {
                  richText: [
                    { font: { bold: true }, text: cable.matchingFibres[0].Nom },
                  ],
                };
                worksheetFicheAppui.getCell("J15").value = {
                  richText: [
                    {
                      font: { bold: true },
                      text: cable.matchingFibres[0].Description,
                    },
                  ],
                };
                worksheetFicheAppui.getCell("U15").value = {
                  richText: [
                    {
                      font: { bold: true },
                      text: cable.matchingFibres[0].Diamètre,
                    },
                  ],
                };
              }
              worksheetFicheAppui.getCell(compteur, 5).value = {
                richText: [{ font: { bold: true }, text: cable.cable }],
              };
            }

            compteur++;
          }
        }

        await nouvelleFiche.xlsx.writeBuffer().then(function (buffer: any) {
          encoursFichesTitre.value = `FicheAppui_${appui.nom}.xlsx`;
          tableauBlobFiches.push(
            {
              blob: new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
              nom: nommageFiche
            }
          );
          /*if (tableauBlobFiches.length == parcours.filter((appui: any) => appui.pose_cable == true && appui.tiers === false).length) {
            //console.log(parcours.length, tableauBlobFiches)
            encoursFiches.value = true;
            encoursFichesDft.value = true;
          }*/
        })
          .catch(async function (error) {
            console.error("Une erreur est survenue lors de l'écriture du buffer :", error);
          });

      }
    }

  }
  //15 aout 2024: a voir si la ligne 4081 règle le bug
  //encoursFiches.value = true
  encoursFichesDft.value = true;

}

const composerFichesAppuis = async (
  imagesPourFiches: any,
  lignesC6: any,
  res_text: any,
  parcours: any,
  worksheetPhotos: any,
  model_br: any,
  model_tl: any,
  workbookC6: any,
  today: any,
  operateur: any,
  dft: boolean
) => {
  let nouvelleFiche = new ExcelJS.Workbook();

  //console.log(model_br)
  //console.log(workbookC6.model.media)
  for (let i = 0; i < imagesPourFiches.length; i += coef_d13.value) {
    const parcoursIndex = i / coef_d13.value;
    if (parcoursIndex < parcours.length) {
      parcours[parcoursIndex].imageIds = ["AUCUN", "AUCUN"];
      if (parcours[parcoursIndex]) {
        if (coef_d13.value == coef_d13.value) {
          parcours[parcoursIndex].imageIds = [
            imagesPourFiches[i]?.imageId,
            imagesPourFiches[i + 1]?.imageId,
          ];
        }
        if (coef_d13.value == 4) {
          parcours[parcoursIndex].imageIds = [
            imagesPourFiches[i]?.imageId,
            imagesPourFiches[i + 1]?.imageId,
            imagesPourFiches[i + 2]?.imageId,
            imagesPourFiches[i + 3]?.imageId,
          ];
        }
      } else {
        listeRemarques.value.message.unshift(
          `Aucun objet parcours trouvé pour l'index ${parcoursIndex}.`
        );
      }
    }
  }

  for (const appui of parcours) {
    if (appui.pose_cable === true && appui.tiers === false) {


      nouvelleFiche = new ExcelJS.Workbook();
      const response = await fetch("xlsx/fiche appui.xlsx");
      const data = await response.arrayBuffer();
      await nouvelleFiche.xlsx.load(data);

      const worksheetFicheAppui = nouvelleFiche.getWorksheet("Fiche Appui");
      worksheetFicheAppui.name = appui.nom;

      worksheetFicheAppui.getCell("D3").value = appui.nom;
      worksheetFicheAppui.getCell("A26").value = appui.nom;
      worksheetFicheAppui.getCell("D4").value = res_text[0].NCC;
      worksheetFicheAppui.getCell("J3").value = operateur;
      worksheetFicheAppui.getCell("T1").value = today;

      worksheetFicheAppui.getCell("T3").value = "ACT";
      worksheetFicheAppui.getCell("P4").value = res_text[0].COM;

      worksheetFicheAppui.getCell("V4").value = appui.insee;
      worksheetFicheAppui.getCell("P5").value = appui.latitude;
      worksheetFicheAppui.getCell("P6").value = appui.longitude;

      worksheetFicheAppui.getCell("V4").value = res_text[0].COM;

      let img;
      let img2;
      let img3;
      let img4;

      if (appui.imageIds) {
        img = workbookC6.model.media.find(
          (m: { index: any }) => m.index === appui.imageIds[0]
        );
        img2 = workbookC6.model.media.find(
          (m: { index: any }) => m.index === appui.imageIds[1]
        );
        if (coef_d13.value == 4) {
          img3 = workbookC6.model.media.find(
            (m: { index: any }) => m.index === appui.imageIds[2]
          );
          img4 = workbookC6.model.media.find(
            (m: { index: any }) => m.index === appui.imageIds[3]
          );
        }
      }

      let addedImageId = 999;
      let addedImageId2 = 999;
      let addedImageId3 = 999;
      let addedImageId4 = 999;

      if (img != undefined && img.buffer != undefined) {
        //console.log(appui, "img")
        addedImageId = nouvelleFiche.addImage({
          buffer: img.buffer,
          extension: img.extension,
        });
        worksheetFicheAppui.addImage(addedImageId, {
          tl: Object.assign({}, model_tl),
          br: Object.assign({}, model_br),
        });
      }
      if (img2 != undefined && img2.buffer != undefined) {
        //console.log(appui, "img2")
        addedImageId2 = nouvelleFiche.addImage({
          buffer: img2.buffer,
          extension: img2.extension,
        });
        worksheetFicheAppui.addImage(addedImageId2, {
          tl: Object.assign({}, model_tl),
          br: Object.assign({}, model_br),
        });
      }

      if (coef_d13.value == 4) {
        if (img3 != undefined && img3.buffer != undefined) {
          //console.log(appui, "img2")
          addedImageId3 = nouvelleFiche.addImage({
            buffer: img3.buffer,
            extension: img3.extension,
          });
          worksheetFicheAppui.addImage(addedImageId3, {
            tl: Object.assign({}, model_tl),
            br: Object.assign({}, model_br),
          });
        }
        if (img4 != undefined && img4.buffer != undefined) {
          //console.log(appui, "img2")
          addedImageId4 = nouvelleFiche.addImage({
            buffer: img4.buffer,
            extension: img4.extension,
          });
          worksheetFicheAppui.addImage(addedImageId4, {
            tl: Object.assign({}, model_tl),
            br: Object.assign({}, model_br),
          });
        }
      }

      for (const image of worksheetFicheAppui.getImages()) {
        if (image.imageId.toString() == addedImageId?.toString()) {
          //console.log(appui.nom, "gauche", image, addedImageId)
          //image.range.tl = Object.assign({}, model_tl);
          image.range.tl.col = 0; // Juste un peu avant la colonne A (qui est la 1ère colonne)
          image.range.tl.row = 63; // Juste un peu avant la ligne 62
          image.range.tl.nativeCol = 0; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.tl.nativeRow = 63; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

          //image.range.br = Object.assign({}, model_br);
          image.range.br.col = 12; // Juste un peu avant la colonne L (qui est la 12ème colonne)
          image.range.br.row = 81; // Juste un peu avant la ligne 79
          image.range.br.nativeCol = 12; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.br.nativeRow = 81; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.br.worksheet = worksheetFicheAppui;
          //console.log(image)
        }
        if (image.imageId.toString() == addedImageId2?.toString()) {
          //console.log(appui.nom, "droite", image, addedImageId2?.toString())
          //image.range.tl = Object.assign({}, model_tl);
          image.range.tl.col = 12; // Juste un peu avant la colonne A (qui est la 1ère colonne)
          image.range.tl.row = 63; // Juste un peu avant la ligne 62
          image.range.tl.nativeCol = 12; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.tl.nativeRow = 63; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

          //image.range.br = Object.assign({}, model_br);
          image.range.br.col = 24; // Juste un peu avant la colonne L (qui est la 12ème colonne)
          image.range.br.row = 81; // Juste un peu avant la ligne 79
          image.range.br.nativeCol = 24; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.br.nativeRow = 81; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.br.worksheet = worksheetFicheAppui;
          //console.log(image)
        }
        if (image.imageId.toString() == addedImageId3?.toString()) {
          //console.log(appui.nom, "droite", image, addedImageId2?.toString())
          //image.range.tl = Object.assign({}, model_tl);
          image.range.tl.col = 0; // Juste un peu avant la colonne A (qui est la 1ère colonne)
          image.range.tl.row = 83; // Juste un peu avant la ligne 62
          image.range.tl.nativeCol = 0; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.tl.nativeRow = 83; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

          //image.range.br = Object.assign({}, model_br);
          image.range.br.col = 12; // Juste un peu avant la colonne L (qui est la 12ème colonne)
          image.range.br.row = 101; // Juste un peu avant la ligne 79
          image.range.br.nativeCol = 12; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.br.nativeRow = 101; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.br.worksheet = worksheetFicheAppui;
          //console.log(image)
        }
        if (image.imageId.toString() == addedImageId4?.toString()) {
          //console.log(appui.nom, "droite", image, addedImageId2?.toString())
          //image.range.tl = Object.assign({}, model_tl);
          image.range.tl.col = 12; // Juste un peu avant la colonne A (qui est la 1ère colonne)
          image.range.tl.row = 83; // Juste un peu avant la ligne 62
          image.range.tl.nativeCol = 12; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.tl.nativeRow = 83; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.tl.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.tl.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.tl.worksheet = worksheetFicheAppui; // Assure-toi que c'est le bon worksheet

          //image.range.br = Object.assign({}, model_br);
          image.range.br.col = 24; // Juste un peu avant la colonne L (qui est la 12ème colonne)
          image.range.br.row = 101; // Juste un peu avant la ligne 79
          image.range.br.nativeCol = 24; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.br.nativeRow = 101; // Pour un positionnement précis à l'intérieur de la cellule
          image.range.br.nativeColOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.br.nativeRowOff = 0; // Pas de décalage supplémentaire nécessaire
          image.range.br.worksheet = worksheetFicheAppui;
          //console.log(image)
        }
      }

      const filteredArray = lignesC6.filter(
        (ligne: { depart: any }) => ligne.depart === appui.nom
      );
      let compteur = 26;
      for (const cable of filteredArray) {
        //console.log(compteur, cable)

        if (cable.arrivee != null) {
          if (cable.visuel != "0") {
            worksheetFicheAppui.getCell("D5").value = cable.adresse_appui;

            worksheetFicheAppui.getCell("E7").value = cable.fttx;
            worksheetFicheAppui.getCell("Q7").value = cable.amont;
            worksheetFicheAppui.getCell("W7").value = cable.bfttx;

            worksheetFicheAppui.getCell("J9").value = cable.visuel;
            worksheetFicheAppui.getCell("J10").value = cable.verticalite;
            worksheetFicheAppui.getCell("J11").value = cable.flambement;
            worksheetFicheAppui.getCell("J12").value = cable.electrique;
            worksheetFicheAppui.getCell("U9").value = cable.pointe_carree;
            worksheetFicheAppui.getCell("U10").value = cable.secousses;
            worksheetFicheAppui.getCell("U11").value = cable.percussions;
            worksheetFicheAppui.getCell("U12").value = cable.etiquette;
            worksheetFicheAppui.getCell("W12").value = cable.utilisable;
            if (cable.etiquette == "Non") {
              worksheetFicheAppui.getCell("W13").value = "Non";
              worksheetFicheAppui.properties.tabColor = { argb: "FFFF0000" };
              listeRemarques.value.message.unshift(
                `L'appui ${cable.depart} a une étiquette jaune.`
              );
            }

            worksheetFicheAppui.getCell("F18").value = cable.rehausse;
            worksheetFicheAppui.getCell("H19").value = cable.boitierexistant;
            worksheetFicheAppui.getCell("H19").value = cable.boitierexistant;
            worksheetFicheAppui.getCell("N18").value = cable.typeBoitier;
            worksheetFicheAppui.getCell("P19").value = cable.transition;
            worksheetFicheAppui.getCell("W19").value = cable.distance;
            //manque lovage

            worksheetFicheAppui.getCell("C26").value = appui.type;
            worksheetFicheAppui.getCell("O26").value = cable.cuivre;
            worksheetFicheAppui.getCell("Q26").value = cable.optique;
            worksheetFicheAppui.getCell("S26").value = cable.effortavant;
            worksheetFicheAppui.getCell("U26").value = cable.effortapres;

            if (cable.aprestravaux != "Non") {
              worksheetFicheAppui.getCell("W26").value = cable.effortremplace;
              worksheetFicheAppui.getCell("M52").value = cable.aprestravaux;
              worksheetFicheAppui.getCell("M53").value = appui.remplacement;
            }

            worksheetFicheAppui.getCell("W52").value = cable.milieu;
            worksheetFicheAppui.getCell("W53").value = cable.voisinage;
            worksheetFicheAppui.getCell("W54").value = cable.acces_vehicule;
            worksheetFicheAppui.getCell("O54").value = cable.strategique;
            worksheetFicheAppui.getCell("W53").value = cable.voisinage;
          }

          worksheetFicheAppui.getCell(compteur, 5).value = cable.cable;
          worksheetFicheAppui.getCell(compteur, 7).value = cable.longueur;
          worksheetFicheAppui.getCell(compteur, 9).value = cable.angle;
          worksheetFicheAppui.getCell(
            compteur,
            11
          ).value = `${cable.fleche} m, à 15°C`;
          worksheetFicheAppui.getCell(compteur, 13).value = cable.arrivee;
          if (cable.pose_cable && cable.matchingFibres.length > 0) {
            //console.log(cable.matchingFibres[0])
            if (
              worksheetFicheAppui.getCell("D15").value === null ||
              worksheetFicheAppui.getCell("D15").value === undefined
            ) {
              worksheetFicheAppui.getCell("D15").value = {
                richText: [
                  { font: { bold: true }, text: cable.matchingFibres[0].Nom },
                ],
              };
              worksheetFicheAppui.getCell("J15").value = {
                richText: [
                  {
                    font: { bold: true },
                    text: cable.matchingFibres[0].Description,
                  },
                ],
              };
              worksheetFicheAppui.getCell("U15").value = {
                richText: [
                  {
                    font: { bold: true },
                    text: cable.matchingFibres[0].Diamètre,
                  },
                ],
              };
            }
            worksheetFicheAppui.getCell(compteur, 5).value = {
              richText: [{ font: { bold: true }, text: cable.cable }],
            };
          }

          compteur++;
        }
      }

      nouvelleFiche.xlsx
        .writeBuffer()
        .then(function (buffer: any) {
          encoursFichesTitre.value = `FicheAppui_${appui.nom}.xlsx`;
          tableauBlobFiches.push(
            {
              blob: new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
              nom: `FicheAppui_${appui.nom}.xlsx`
            }
          );
          if (tableauBlobFiches.length == parcours.filter((appui: any) => appui.pose_cable == true && appui.tiers === false).length) {
            encoursFiches.value = true;
            encoursFichesDft.value = true;
          }
        })
        .catch(async function (error) {
          console.error("Une erreur est survenue lors de l'écriture du buffer :", error);
        });
    }
  }
};

export const composerC4 = async (res_text: any, fci: any, date: any, sous_traitant: any) => {
  encoursc4titre.value = "Création des annexes C4.";
  let nouvelleC4 = new ExcelJS.Workbook();
  let compteurC4 = 0;
  //console.log(annexesC4)
  for (const appuiRemplace of annexesC4) {
    const ges_text = basegespot
      .filter((point_technique) =>
        point_technique.GESPOT.toLowerCase().includes(
          appuiRemplace.aprestravaux.toLowerCase()
        )
      )
      .slice(0, 1);
    if (ges_text.length > 0) {
      compteurC4++;
      nouvelleC4 = new ExcelJS.Workbook();
      const response = await fetch("xlsx/GESPOT.xlsx");
      const data = await response.arrayBuffer();
      await nouvelleC4.xlsx.load(data);
      encoursc4titre.value =
        "Ecriture buffer GESPOT_" + appuiRemplace.nom + ".xlsx";
      const worksheetC4 = nouvelleC4.getWorksheet("Fiche GESPOT");
      worksheetC4.getCell("D8").value = appuiRemplace.nom;
      worksheetC4.getCell("P13").value = "X";
      worksheetC4.getCell("J8").value = appuiRemplace.adresse_appui;
      worksheetC4.getCell("C11").value = appuiRemplace.latitude;
      worksheetC4.getCell("M11").value = appuiRemplace.longitude;
      worksheetC4.getCell("G6").value = "X";

      if (appuiRemplace.etiquette == "Non") {
        worksheetC4.getCell("P14").value = appuiRemplace.latitude;
      }
      worksheetC4.getCell("D9").value = res_text[0].NCC;
      worksheetC4.getCell("K9").value = res_text[0].COM;
      worksheetC4.getCell("R2").value = date;
      worksheetC4.getCell("I4").value = fci;
      worksheetC4.getCell("I3").value = sous_traitant;

      switch (appuiRemplace.electrique) {
        case "BGC":
          worksheetC4.getCell("T25").value = "X";
          break;
        case "BGP":
          worksheetC4.getCell("T26").value = "X";
          break;
        case "BNC":
          worksheetC4.getCell("T23").value = "X";
          break;
        case "BNP":
          worksheetC4.getCell("T24").value = "X";
          break;
        case "HAC":
          worksheetC4.getCell("T27").value = "X";
          break;
        case "HAP":
          worksheetC4.getCell("T28").value = "X";
          break;
        case "HBC":
          worksheetC4.getCell("T29").value = "X";
          break;
        case "HBP":
          worksheetC4.getCell("T30").value = "X";
          break;
        case "BMP":
          worksheetC4.getCell("T22").value = "X";
          break;
        default:
          break;
      }
      switch (appuiRemplace.strategique) {
        case "TRM":
          worksheetC4.getCell("J39").value = "X";
          // Code pour TRM
          break;
        case "TDL":
          worksheetC4.getCell("J38").value = "X";
          // Code pour TDL
          break;
        case "TCR":
          worksheetC4.getCell("J37").value = "X";
          // Code pour TCR
          break;
        case "SPC":
          worksheetC4.getCell("J30").value = "X";
          // Code pour SPC
          break;
        case "SPB":
          worksheetC4.getCell("J29").value = "X";
          // Code pour SPB
          break;
        case "PCH":
          worksheetC4.getCell("J33").value = "X";
          // Code pour PCH
          break;
        case "PCG":
          worksheetC4.getCell("J31").value = "X";
          // Code pour PCG
          break;
        case "PCP":
          worksheetC4.getCell("J32").value = "X";
          // Code pour PCP
          break;
        default:
        // Code par défaut
      }

      switch (appuiRemplace.acces_vehicule) {
        case "INV":
          worksheetC4.getCell("T31").value = "X";
          break;
        case "IN1":
          worksheetC4.getCell("T32").value = "X";
          break;
        case "IN2":
          worksheetC4.getCell("T33").value = "X";
          break;
        case "IN3":
          worksheetC4.getCell("T34").value = "X";
          break;
        case "IN4":
          worksheetC4.getCell("T35").value = "X";
          break;
        case "IN5":
          worksheetC4.getCell("T36").value = "X";
          break;
        case "IN6":
          worksheetC4.getCell("T37").value = "X";
          break;
        case "IN7":
          worksheetC4.getCell("T38").value = "X";
          break;
        case "IN8":
          worksheetC4.getCell("T39").value = "X";
          break;
        case "IN9":
          worksheetC4.getCell("T40").value = "X";
          break;
        default:
        // Code par défaut
      }

      //console.log(appuiRemplace.aprestravaux, ges_text)
      if (ges_text[0].Description.includes("Bois")) {
        worksheetC4.getCell("E18").value = "X";
      }
      if (ges_text[0].Description.includes("Métal")) {
        worksheetC4.getCell("E19").value = "X";
      }
      if (ges_text[0].Description.includes("Composite")) {
        worksheetC4.getCell("E20").value = "X";
      }
      if (ges_text[0].Description.includes("R0 ")) {
        worksheetC4.getCell("H20").value = "X";
      }
      if (ges_text[0].Description.includes("R1 ")) {
        worksheetC4.getCell("K20").value = "X";
      }
      if (ges_text[0].Description.includes("ligne ")) {
        worksheetC4.getCell("H19").value = "X";
      }
      if (ges_text[0].Description.includes("190 ")) {
        worksheetC4.getCell("K18").value = "X";
      }
      /*if(ges_text[0].Description.includes("simple") || ges_text[0].Description.includes("simple,")){
        worksheetC4.getCell("N18").value = 'X';
      }*/
      if (
        ges_text[0].Description.includes("Moisés ") ||
        ges_text[0].Description.includes("moisés ")
      ) {
        worksheetC4.getCell("K19").value = "X";
      }
      if (
        ges_text[0].Description.includes("Haubané ") ||
        ges_text[0].Description.includes("haubané ")
      ) {
        worksheetC4.getCell("N19").value = "X";
      }
      if (
        ges_text[0].Description.includes("Triple ") ||
        ges_text[0].Description.includes("triple ")
      ) {
        worksheetC4.getCell("N18").value = "X";
      }
      if (
        ges_text[0].Description.includes("Couple") ||
        ges_text[0].Description.includes("couple")
      ) {
        worksheetC4.getCell("N20").value = "X";
      }
      if (ges_text[0].Description.includes(" 6 m")) {
        worksheetC4.getCell("T18").value = "X";
      }
      if (ges_text[0].Description.includes(" 7 m")) {
        worksheetC4.getCell("Q19").value = "X";
      }
      if (ges_text[0].Description.includes(" 8 m")) {
        worksheetC4.getCell("T19").value = "X";
      }
      if (ges_text[0].Description.includes(" 10 m")) {
        worksheetC4.getCell("Q20").value = "X";
      }
      if (ges_text[0].Description.includes(" 12 m")) {
        worksheetC4.getCell("T20").value = "X";
      }

      nouvelleC4.xlsx
        .writeBuffer()
        .then(function (buffer: any) {
          encoursc4titre.value = `Ecriture buffer GESPOT_${appuiRemplace.nom}.xlsx (${compteurC4}/${annexesC4.length})`;
          tableauBlobC4.push(
            new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          //console.log(tableauBlobC4);
          if (tableauBlobC4.length == annexesC4.length) {
            encoursc4titre.value = "Les C4 associées sont prêtes.";
            encoursc4.value = true;
            encoursc4Dft.value = true;
          }
        })
        .catch(async function (error) {
          console.error(
            "Une erreur est survenue lors de l'écriture du buffer :",
            error
          );
          //console.log("REMPLA", appuiRemplace);
        });
    }
  }
};

export const composerC7 = (
  worksheetModeleC7Commande: any,
  worksheetModeleC7Restitution: any,
  parcours: any,
  operateur: any,
  annexe: any,
  siren_cible: any,
  res_text: any,
  workbookModeleC7: any, sous_traitant:any
) => {
  /////////////////////////
  //
  // REGLES DE REMPLACEMENT CONDITIONS DU 26 07 2023
  //
  // APPUIS SIMPLES -> SI FILS NUS: COMPOSITE OU COMPOSITE RENFORCE / SINON: POSSIBILITE METAL OU METAL RENFORCE
  //
  // APPUIS MOISES -> SI FILS NUS: COMME SIMPLES MAIS PRIVILEGIE RENFORCES
  //
  // HAUBAN SIMPLE 30 -> COMPOSITE RENFORCE OU METAL RENFORCE SI AUCUN FILS NUS
  //
  // HAUBAN S45 D30 D45 -> COMPOSITE HAUBANE OU COMPOSITE RENFORCE / OU METAL HAUBANE SI AUCUN FILS NUS
  //
  // COUPLE SANS ANC -> COUPLE COMPOSITE RENFORCE / SI AUCUN FILS NUS COMPOSITE METAL
  //
  // COUPLE AVEC ANC -> COUPLE COMPO ANCRE / OU METAL ANCRE SI AUCUN FILS NUS
  //
  /////////////////////////

  let ligneC7 = 17;
  worksheetModeleC7Commande.getCell(3, 4).value = fciCommande.value;
  worksheetModeleC7Commande.getCell(5, 8).value = operateur;
  worksheetModeleC7Commande.getCell(4, 2).value = res_text[0].NCC;
  worksheetModeleC7Commande.getCell(7, 8).value = sous_traitant;

  for (const appui of parcours) {
    if (
      appui.remplacement &&
      appui.remplacement.length > 5 &&
      appui.remplacement != "Recalage"
    ) {
      ligneC7++;

      worksheetModeleC7Commande.getCell(ligneC7, 1).value = appui.nom;
      worksheetModeleC7Commande.getCell(ligneC7, 2).value = appui.avanttravaux;
      worksheetModeleC7Commande.getCell(ligneC7, 3).value = appui.remplacement;
      worksheetModeleC7Commande.getCell(ligneC7, 4).value = appui.aprestravaux;
      switch (appui.aprestravaux) {
        case "M47":
          worksheetModeleC7Commande.getCell(ligneC7, 8).value = 1;
          break;
        case "M48":
          worksheetModeleC7Commande.getCell(ligneC7, 9).value = 1;
          break;
        case "FR7":
          worksheetModeleC7Commande.getCell(ligneC7, 13).value = 1;
          break;
        case "FR8":
          worksheetModeleC7Commande.getCell(ligneC7, 14).value = 1;
          break;
        case "FH7":
          worksheetModeleC7Commande.getCell(ligneC7, 10).value = 1;
          break;
        case "FH8":
          worksheetModeleC7Commande.getCell(ligneC7, 11).value = 1;
          break;
        case "FC7 ANC MAX":
          worksheetModeleC7Commande.getCell(ligneC7, 10).value = 2;
          break;
        case "FC7 MAX":
          worksheetModeleC7Commande.getCell(ligneC7, 10).value = 2;
          break;
        case "FC7 MIN":
          worksheetModeleC7Commande.getCell(ligneC7, 10).value = 2;
          break;
        case "FC7 ANC MIN":
          worksheetModeleC7Commande.getCell(ligneC7, 10).value = 2;
          break;
        case "FC8 ANC MAX":
          worksheetModeleC7Commande.getCell(ligneC7, 11).value = 2;
          break;
        case "FC8 MAX":
          worksheetModeleC7Commande.getCell(ligneC7, 11).value = 2;
          break;
        case "FC8 MIN":
          worksheetModeleC7Commande.getCell(ligneC7, 11).value = 2;
          break;
        case "FC8 ANC MIN":
          worksheetModeleC7Commande.getCell(ligneC7, 11).value = 2;
          break;
        case "ME8 ANC MAX":
          worksheetModeleC7Commande.getCell(ligneC7, 6).value = 2;
          break;
        case "ME8 MAX":
          worksheetModeleC7Commande.getCell(ligneC7, 6).value = 2;
          break;
        case "ME8 ANC MIN":
          worksheetModeleC7Commande.getCell(ligneC7, 6).value = 2;
          break;
        case "ME8 MIN":
          worksheetModeleC7Commande.getCell(ligneC7, 6).value = 2;
          break;
        default:
          worksheetModeleC7Commande.properties.tabColor = { argb: "FFFF0000" };
          break;
      }

      worksheetModeleC7Restitution.getCell(ligneC7, 1).value =
        appui.nom + "/" + appui.type;
      const filteredArray = annexe.filter(
        (item: { type: any; col: any; value: any }) => item.type == appui.type
      );
      //console.log(appui.type, filteredArray)
      filteredArray.forEach((item: { type: any; col: any; value: any }) => {
        worksheetModeleC7Restitution.getCell(ligneC7, item.col).value =
          item.value;
      });
    }
  }

  workbookModeleC7.xlsx.writeBuffer().then(function (buffer: any) {
    blobC7 = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    encoursc7Dft.value = true;
    encoursc7titre.value = "L'annexe C7 est prête."
  });

};

export const composerShapefile = async (
  lignesC6: any,
  parcours: any,
  fci: any,
  insee: any,
  specialbatch: boolean,
  operateur: any,
  siren_cible: any,
  specialbatchfci: any
) => {
  const fci_utilise = fci;
  /*if (specialbatch === true) {
    fci_utilise = specialbatchfci;
  }*/

  const featureCollection = {
    type: "FeatureCollection",
    features: [],
  };

  for (let i = 0; i < parcours.length; i++) {
    const feature = {
      type: "Feature",
      properties: {
        NOM: parcours[i].nom,
        //SUIVANT: parcours[i + 1]?.nom || 'Aucun',
        BOITIER: parcours[i].boitier,
        REMPLACEMENT: parcours[i].remplacement,
        TYPE: parcours[i].type,
        SIREN: siren_cible,
        OPERATEUR: operateur,
        DEPART: "",
        ARRIVEE: "",
        FCI: fci_utilise,
        ID: "",
        ETAT: "",
        LIEN: "",
        GEST: "",
        COMMENTAIRE: "",
      },
      geometry: {
        type: "Point",
        coordinates: [
          parseFloat(parcours[i].longitude),
          parseFloat(parcours[i].latitude),
        ],
      },
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    featureCollection.features.push(feature);

    //if(!feature.properties.NOM.includes("Appui")){
      
    //}
    
  }
  const featureCollectionLines = {
    type: "FeatureCollection",
    features: [],
  };
  cablesFromC6 = [];

  lignesC6.map((ligneC6: any) => {
    ligneC6.alveole = ligneC6.type;
    ligneC6.insee = insee;
    ligneC6.fci = fci_utilise;
    ligneC6.capacite = ligneC6.diametre;
    const accroche1 = featureCollection.features.filter((accroche: any) => {
      return accroche.properties.NOM.replace(/^0+/, '') == ligneC6.depart.replace(/^0+/, '');
    });
    const accroche2 = featureCollection.features.filter((accroche: any) => {
      return accroche.properties.NOM.replace(/^0+/, '') == ligneC6.arrivee.replace(/^0+/, '');
    });
    //console.log(ligneC6.depart, accroche1, ligneC6.arrivee, accroche2)

    if (accroche1.length == 1 && accroche2.length == 1) {
      let floatCoords: number[] = [0, 0];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      floatCoords = accroche1[0].geometry.coordinates.map((coord) =>
        parseFloat(coord)
      );
      let floatCoords2: number[] = [0, 0];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      floatCoords2 = accroche2[0].geometry.coordinates.map((coord) =>
        parseFloat(coord)
      );

      const feature = {
        type: "Feature",
        properties: {
          depart: ligneC6.depart,
          arrivee: ligneC6.arrivee,
          alveole: ligneC6.alveole,
          insee: ligneC6.insee,
          fci: ligneC6.fci,
          capacite: ligneC6.capacite,
          longueur: ligneC6.longueur,
          angle: ligneC6.angle,
          type: ligneC6.type,
          diametre: ligneC6.diametre,
          apbo: trouveBoiteEtReindex(ligneC6.depart, parcours),
          bpbo: trouveBoiteEtReindex(ligneC6.arrivee, parcours),
          index: ligneC6.index,
        },
        geometry: {
          type: "MultiLineString",
          coordinates: [
            [
              floatCoords,
              floatCoords2
            ]
          ],
        },
      };
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      featureCollectionLines.features.push(feature);
      // Préparer le câble pour insertion DB
      cablesFromC6.push({
        ...feature,
        properties: {
          ...feature.properties,
          precision: nomCommandePrecision.value || "",
          siren: siren_cible,
          entite_a: accroche1[0],
          entite_b: accroche2[0],
        },
      });
    }
  });
  if (specialbatch === false && checkedShapefile.value === true) {
    //console.log(featureCollectionLines, featureCollection)
    const url = `${prodEnvironment.baseUrl}api/gcblo/shapefile/c6shapefile`;
    await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        collection: featureCollectionLines,
        commandeoufci: fci,
        insee: insee,
        operateur: operateur,
        appuis: featureCollection,
      }),
    }).then(async (res) => {
      res
        .blob()
        .then((blob) => {
          blobShp = blob;
          encoursPlantitre.value = "Votre geoJSON et shapefile sont prêts.";
          encoursPlan.value = true;
          encoursPlanDft.value = true;
        })
        .catch((err) => console.error(err));
    });
  } else {
    operateur = "SFR_FTTH";
    encoursPlantitre.value = "Shapefile abandonné.";
    encoursPlan.value = true;
  }

  const geojsonName = fci_utilise;
  /*if (fci_utilise == "F00000jjmmaa") {
    geojsonName =
      lignesC6[0].depart + "_" + lignesC6[lignesC6.length - 1].arrivee;
  }*/

  for (const feature of featureCollection.features) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    feature.properties.DEPART = lignesC6[0].depart;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    feature.properties.ARRIVEE = lignesC6[lignesC6.length - 1].arrivee;
  }

  const textContent = JSON.stringify(featureCollection);
  blobGeoJson = new Blob([textContent], { type: "text/plain" });
  encoursGJSON.value = true;
  if (specialbatch === true) {
    const url2 = URL.createObjectURL(blobGeoJson);
    const downloadLink = document.createElement("a");
    downloadLink.download = `${geojsonName}.geojson`; // Set the desired file name
    downloadLink.href = url2;
    downloadLink.click();
    URL.revokeObjectURL(url2);
  }
};

function trouveBoiteEtReindex(app: any, parcours: any) {
  for (const appui of parcours) {
    //console.log(appui.nom, app)
    if (appui.nom.replace(/^0+/, '') == app.replace(/^0+/, '') && appui.boitier != "Non") {
      //console.log(appui.nom, appui.boitier)
      return appui.boitier;
    }
  }
}


// Retourne: "WGS84 Decimal" | "WGS84 DMS" | "Lambert 93" | "Lambert 2 étendu"
export async function determinerProjection(app: any, operateur: any){

  const latRawStr = String(app?.latitude ?? "");
  const lonRawStr = String(app?.longitude ?? "");
  const latStr = latRawStr.replace(/\s+/g, "").replace(/^0+/, "");   
  const lonStr = lonRawStr.replace(/\s+/g, "").replace(/^0+/, "");
  const declaredProjection = String(app?.projection ?? "").toLowerCase();
  const ensureProjDefs = () => {
    if (!proj4.defs("EPSG:2154")) {
      proj4.defs(
        "EPSG:2154",
        "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +no_defs"
      );
    }
    if (!proj4.defs("EPSG:27572")) {
      proj4.defs(
        "EPSG:27572",
        "+proj=lcc +lat_1=45.89891888888889 +lat_2=47.69601444444445 +lat_0=46.8 +lon_0=2.337229166666667 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs"
      );
    }
    if (!proj4.defs("EPSG:3857")) {
      proj4.defs(
        "EPSG:3857",
        "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0 +y_0=0 +k=1.0 +units=m +no_defs"
      );
    }
  };
  const previewConvert = (
    projection: "Lambert 93" | "Lambert 2 étendu" | "Web Mercator",
    yRaw: number,
    xRaw: number
  ): { lat: number; lon: number } | null => {
    try {
      ensureProjDefs();
      const x = Number(xRaw);
      const y = Number(yRaw);
      if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
      switch (projection) {
        case "Lambert 93": {
          const [lon, lat] = proj4("EPSG:2154", "EPSG:4326", [x, y]);
          return { lat, lon };
        }
        case "Lambert 2 étendu": {
          const [lon, lat] = proj4("EPSG:27572", "EPSG:4326", [x, y]);
          return { lat, lon };
        }
        case "Web Mercator": {
          const [lon, lat] = proj4("EPSG:3857", "EPSG:4326", [x, y]);
          return { lat, lon };
        }
        default:
          return null;
      }
    } catch {
      return null;
    }
  };
  const openInspection = async (projection: string, latConv?: number | string, lonConv?: number | string) => {
    if (inspectionProjectionOpen.value) {
      await waitInspectionProjection();
      return;
    }
    if (inspectionProjectionSeen.value) return;
    inspectionProjectionData.value = {
      projection,
      latRaw: latRawStr,
      lonRaw: lonRawStr,
      latConv: latConv ?? "N/A",
      lonConv: lonConv ?? "N/A",
    };
    inspectionProjectionOpen.value = true;
    inspectionProjectionSeen.value = true;
    await waitInspectionProjection();
  };
  if (declaredProjection.includes("mercator") || declaredProjection.includes("3857")) {
    if (!inspectionProjectionSeen.value) {
      await openInspection("Web Mercator", latRawStr, lonRawStr);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Web Mercator";
  }

  // 1) Détection DMS (avec ou sans N/E/S/W)
  const dmsCandidate = `${latRawStr} ${lonRawStr}`;
  const [latDms, lonDms] = parseLatLonFlexible(dmsCandidate);
  if (isFinite(latDms) && isFinite(lonDms) && isDeg(latDms, lonDms)) {
    app.latitude = latDms;
    app.longitude = lonDms;
    await openInspection("WGS84 DMS", latDms, lonDms);
    if (cancelLectureC6.value) return "Inconnu";
    return "WGS84 DMS";
  }

  // 2) Normalisation classique
  const latRaw = normalizeCoord(latStr);
  const lonRaw = normalizeCoord(lonStr);
  if (!isFinite(latRaw) || !isFinite(lonRaw)) {
    if (!inspectionProjectionSeen.value) {
      await openInspection("Inconnu", latRawStr, lonRawStr);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Lambert 93";
  }
  const hasDecimalSource = /[.,]/.test(latStr) || /[.,]/.test(lonStr);
  const hasNegativeSource = latStr.includes("-") || lonStr.includes("-");

  // 3) Test WGS84 Decimal
  if (isDeg(latRaw, lonRaw) || isDeg(lonRaw, latRaw)) {
    await openInspection("WGS84 Decimal", latRaw, lonRaw);
    if (cancelLectureC6.value) return "Inconnu";
    return "WGS84 Decimal";
  }

  // 4) Heuristiques Lambert
  const looksL93 =
    looksLambert93(lonRaw, latRaw) || looksLambert93(latRaw, lonRaw);
  const looksL2E =
    looksLambert2E(lonRaw, latRaw) || looksLambert2E(latRaw, lonRaw);
  const looksWM =
    looksWebMercator(lonRaw, latRaw) || looksWebMercator(latRaw, lonRaw);

  // Heuristique renforcée pour distinguer L93 vs WebMercator (ex: Corse ~ 5.1M y)
  if (isLambert93XY(lonRaw, latRaw) || isLambert93XY(latRaw, lonRaw)) {
    if (!inspectionProjectionSeen.value) {
      const preview = previewConvert("Lambert 93", latRaw, lonRaw);
      await openInspection("Lambert 93", preview?.lat ?? latRaw, preview?.lon ?? lonRaw);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Lambert 93";
  }
  const looksL2EBox = isLambert2EXY(lonRaw, latRaw) || isLambert2EXY(latRaw, lonRaw);
  if (looksL2EBox) {
    if (!inspectionProjectionSeen.value) {
      const preview = previewConvert("Lambert 2 étendu", latRaw, lonRaw);
      await openInspection("Lambert 2 étendu", preview?.lat ?? latRaw, preview?.lon ?? lonRaw);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Lambert 2 étendu";
  }
  if (isWebMercatorFR(lonRaw, latRaw) || isWebMercatorFR(latRaw, lonRaw)) {
    if (!inspectionProjectionSeen.value) {
      const preview = previewConvert("Web Mercator", latRaw, lonRaw);
      await openInspection("Web Mercator", preview?.lat ?? latRaw, preview?.lon ?? lonRaw);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Web Mercator";
  }

  if (
    looksWM &&
    (hasDecimalSource || hasNegativeSource || (!looksL93 && !looksL2E))
  ) {
    return "Web Mercator";
  }

  if (looksL93 && !looksL2E) {
    if (!inspectionProjectionSeen.value) {
      const preview = previewConvert("Lambert 93", latRaw, lonRaw);
      await openInspection("Lambert 93", preview?.lat ?? latRaw, preview?.lon ?? lonRaw);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Lambert 93";
  }
  if (looksL2E && !looksL93) {
    if (!inspectionProjectionSeen.value) {
      const preview = previewConvert("Lambert 2 étendu", latRaw, lonRaw);
      await openInspection("Lambert 2 étendu", preview?.lat ?? latRaw, preview?.lon ?? lonRaw);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Lambert 2 étendu";
  }

  // 5) Ambigu → tranche sur Y
  const yCandidate = Math.max(Math.abs(latRaw), Math.abs(lonRaw));
  if (inRange(yCandidate, 5_800_000, 7_400_000)) {
    if (!inspectionProjectionSeen.value) {
      const preview = previewConvert("Lambert 93", latRaw, lonRaw);
      await openInspection("Lambert 93", preview?.lat ?? latRaw, preview?.lon ?? lonRaw);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Lambert 93";
  }
  if (inRange(yCandidate, 1_600_000, 2_800_000)) {
    if (!inspectionProjectionSeen.value) {
      const preview = previewConvert("Lambert 2 étendu", latRaw, lonRaw);
      await openInspection("Lambert 2 étendu", preview?.lat ?? latRaw, preview?.lon ?? lonRaw);
      if (cancelLectureC6.value) return "Inconnu";
    }
    return "Lambert 2 étendu";
  }

  await openInspection("Inconnu", latRaw, lonRaw);
  if (cancelLectureC6.value) return "Inconnu";
  return "Inconnu";
}

/* ---------------- Utils ---------------- */

function normalizeCoord(value: any): number {
  if (value == null) return NaN;

  const s = String(value)
    .replace(/,/g, ".")
    .replace(/\s|\u00A0|\u202F/g, "")
    .trim();

  const n = Number(s);
  if (!isFinite(n)) return NaN;

  if (!s.includes(".")) {
    if (Math.abs(n) < 1000) return n / 10000;
    // WGS84 sans séparateur (ex: 42416248 -> 42.416248)
    const absN = Math.abs(n);
    if (absN >= 1_000_000 && absN <= 180_000_000) {
      return n / 1_000_000;
    }
    if (Math.abs(n) > 1e9) {
      let scaled = n;
      while (Math.abs(scaled) > 20_000_000) scaled /= 10;
      return scaled;
    }
  }
  return n;
}

function isLambert93XY(x: number, y: number): boolean {
  return (
    isFinite(x) &&
    isFinite(y) &&
    x >= 0 &&
    x <= 1300000 &&
    y >= 6000000 &&
    y <= 7300000
  );
}

function isLambert2EXY(x: number, y: number): boolean {
  return (
    isFinite(x) &&
    isFinite(y) &&
    x >= 0 &&
    x <= 1300000 &&
    y >= 1600000 &&
    y <= 2800000
  );
}

function isWebMercatorFR(x: number, y: number): boolean {
  return (
    isFinite(x) &&
    isFinite(y) &&
    Math.abs(x) <= 20100000 &&
    Math.abs(y) <= 20100000 &&
    !isLambert93XY(x, y) &&
    y >= 4000000 &&
    y <= 5600000
  );
}

// Parse "48°51'24\"N" -> 48.8567
function parseDMS262092025(dms: string): number {
  const regex =
    /(\d+(?:[.,]\d+)?)°?\s*(\d+(?:[.,]\d+)?)?['′]?\s*(\d+(?:[.,]\d+)?)?["″]?\s*([NSEOW])?/i;
  const match = dms.match(regex);
  if (!match) return NaN;

  const deg = parseFloat(match[1].replace(",", "."));
  const min = match[2] ? parseFloat(match[2].replace(",", ".")) : 0;
  const sec = match[3] ? parseFloat(match[3].replace(",", ".")) : 0;
  const hemi = match[4]?.toUpperCase();

  let dec = deg + min / 60 + sec / 3600;
  if (hemi === "S" || hemi === "O" || hemi === "W") dec = -dec;

  return dec;
}

function parseLatLonFlexible(dmsPair: string): [number, number] {
  const cleaned = dmsPair.replace(/\s+/g, " ").trim();
  const reorderIfSwapped = (lat: number, lon: number): [number, number] => {
    // Heuristique : certains fichiers inversent N/E (lat/lon).
    // Si la "lat" est faible (<20) et la "lon" élevée (>20) mais que l'inversion tombe en France métropolitaine,
    // on inverse. Cela corrige par exemple "42°...\" E, 9°...\" N" pour la Corse.
    if (
      Number.isFinite(lat) &&
      Number.isFinite(lon) &&
      lat < 20 &&
      lon > 20 &&
      inFranceBBox(lon, lat)
    ) {
      return [lon, lat];
    }
    return [lat, lon];
  };

  // 1) Avec lettres N/E/S/W
  const regexWithHemi =
    /(\d+(?:[.,]\d+)?)°?\s*(\d+(?:[.,]\d+)?)?['′]?\s*(\d+(?:[.,]\d+)?)?["″]?\s*([NSEOW])/gi;
  const matchesHemi = [...cleaned.matchAll(regexWithHemi)];
  if (matchesHemi.length >= 2) {
    const latMatch = matchesHemi.find((m) => /[NS]/i.test(m[4]))!;
    const lonMatch = matchesHemi.find((m) => /[EOW]/i.test(m[4]))!;
    return reorderIfSwapped(toDecimalDms(latMatch), toDecimalDms(lonMatch));
  }

  // 2) Sans lettres, deux blocs DMS consécutifs
  const regexNoHemi =
    /(\d+(?:[.,]\d+)?)°?\s*(\d+(?:[.,]\d+)?)?['′]?\s*(\d+(?:[.,]\d+)?)?["″]?/gi;
  const matchesNoHemi = [...cleaned.matchAll(regexNoHemi)].filter((m) => m[0].trim().length);
  if (matchesNoHemi.length >= 2) {
    const lat = toDecimalDms(matchesNoHemi[0], true);
    const lon = toDecimalDms(matchesNoHemi[1], false);
    return reorderIfSwapped(lat, lon);
  }

  return [NaN, NaN];
}

function toDecimalDms(match: RegExpMatchArray, isLat = true): number {
  const deg = parseFloat(match[1].replace(",", "."));
  const min = match[2] ? parseFloat(match[2].replace(",", ".")) : 0;
  const sec = match[3] ? parseFloat(match[3].replace(",", ".")) : 0;
  const hemi = match[4]?.toUpperCase();
  let dec = deg + min / 60 + sec / 3600;
  if (hemi === "S" || hemi === "W" || hemi === "O") dec = -dec;
  // Sans hémisphère, on suppose lat >0 et lon >0 (cas métropole) ; si besoin, ajouter heuristiques.
  return Math.round(dec * 1e6) / 1e6;
}



function isDeg(lat: number, lon: number): boolean {
  return lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180;
}
function inRange(v: number, min: number, max: number): boolean {
  return v >= min && v <= max;
}
function looksLambert93(x: number, y: number): boolean {
  return inRange(Math.abs(x), 0, 1_300_000) && inRange(Math.abs(y), 5_800_000, 7_400_000);
}
function looksLambert2E(x: number, y: number): boolean {
  return inRange(Math.abs(x), 0, 1_200_000) && inRange(Math.abs(y), 1_600_000, 2_800_000);
}
function looksWebMercator(x: number, y: number): boolean {
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    return false;
  }
  const absX = Math.abs(x);
  const absY = Math.abs(y);
  const max = 20_037_510; // Limites EPSG:3857
  if (absX > max || absY > max) {
    return false;
  }
  // Pour la métropole : y reste supérieur à ~3 000 000 m
  return absY >= 3_000_000;
}




async function determinerProjection_04092025(app: any, operateur) {
  //////////
  // En fonction des erreurs et de la position des points
  //////////

  const lat = app.latitude.toString();
  const lon = app.longitude.toString();
  // Vérifier si la latitude contient un apostrophe
  if (lat.includes('"')) {
    return "WGS84 DMS"; // WGS84 degrés, minutes, secondes
  } else {
    // Vérifier si la latitude contient un point ou une virgule

    const projection = [];
    //console.log("lat long", lat, lon)
    if (!lat.includes(".") && !lat.includes(",")) {
      // Extraire les 3 premiers chiffres
      const chiffres_lat = parseInt(lat.slice(0, 3), 10);
      const chiffres_lon = parseInt(lon.slice(0, 3), 10);

      // Déterminer la projection
      if (chiffres_lon > 612 && chiffres_lat > 100) {
        projection.push("Lambert 93");
      }
      
      if (
        chiffres_lat >= 420 &&
        chiffres_lat <= 5200 &&
        chiffres_lon > -519 &&
        chiffres_lon < 820
      ) {
        projection.push("WGS84 Decimal");
      }
      if (
        chiffres_lat >= 420 &&
        chiffres_lat <= 431 &&
        chiffres_lon > 844 &&
        chiffres_lon < 970 &&
        operateur.includes("Corsica")
      ) {
        projection.push("WGS84 Decimal");
      }
      if (chiffres_lat >= 169 && chiffres_lat <= 270) {
        projection.push("Lambert 2 étendu");
      }
      if (projection.length == 0) {
        projection.push("Inconnu");
      }
      //console.log('projections', projection);
      if (projection.length == 1) {
        return projection[0];
      } else {
        //console.log('plusieurs projections', projection);
        //console.log('pour insee', app.insee)
        const x = parseFloat(
          app.longitude.slice(0, 1) + "." + app.longitude.slice(1)
        );
        const y = parseFloat(
          app.latitude.slice(0, 2) + "." + app.latitude.slice(2)
        );
        const point = turf.point([x, y]);
        //console.log('pour point', point)
        let trouve = false;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        for (const feature of zoneAdjacences.value.features) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          if (turf.inside(point, feature)) {
            //if(app.insee == feature.properties.insee_com){
            //console.log("Le point est dans le polygone :", feature);
            trouve = true;
            break;
            //}
          }
        }

        if (!trouve) {
          //console.log('pas trouvé')
          const filteredArray = projection.filter(
            (element) => element !== "WGS84 Decimal"
          );
          return filteredArray[0];
        } else {
          return "WGS84 Decimal";
        }
      }
    } else {
      const chiffres_lat = parseInt(lat, 10);
      const chiffres_lon = parseInt(lon, 10);

      //console.log(chiffres_lat, chiffres_lon)
      // Déterminer la projection
      if (chiffres_lon > 6120000) {
        return "Lambert 93 avec point";
      } else if (chiffres_lat >= 42 && chiffres_lat <= 52) {
        return "WGS84 Decimal avec point";
      } else if (chiffres_lon >= 1690000 && chiffres_lon <= 2700000) {
        return "Lambert 2 étendu avec point";
      } else {
        return "Inconnu"; // Retourne 'Inconnu' si aucune condition n'est remplie
      }
    }
  }
}

function DMSToDecimal_22082025(dmsStr: any) {
  /////
  // Tout est dans le titre
  /////
  const matches = dmsStr.match(/(\d+)°\s*(\d+)'\s*([\d.]+)"\s*([NSEW])?/);

  if (!matches) {
    return null;
  }

  const degrees = parseFloat(matches[1]);
  const minutes = parseFloat(matches[2]);
  const seconds = parseFloat(matches[3]);
  const direction = matches[4];

  // Conversion en format décimal
  let decimal = degrees + minutes / 60 + seconds / 3600;

  // Correction de la direction
  if (direction === "S" || direction === "W") {
    decimal *= -1;
  }

  return decimal;
}

function DMSToDecimal(dmsStr: string): number | null {
  if (!dmsStr) return null;

  // Normalisation : virgule → point, espaces spéciaux → espace normal
  const s = dmsStr
    .replace(/,/g, ".")
    .replace(/\u00A0|\t|\s+/g, " ")
    .trim();

  // Regex plus souple (direction avant ou après, minutes/secondes optionnelles)
  const re =
    /([NSEW])?\s*([+-]?\d+(?:\.\d+)?)\s*(?:°|º|˚|d)?\s*(\d+(?:\.\d+)?)?\s*(?:'|’|m)?\s*(\d+(?:\.\d+)?)?\s*(?:"|”|″|s)?\s*([NSEW])?/i;

  const m = s.match(re);
  if (!m) return null;

  const dir = (m[1] || m[6] || "").toUpperCase();
  const deg = parseFloat(m[2]);
  const min = m[3] ? parseFloat(m[3]) : 0;
  const sec = m[4] ? parseFloat(m[4]) : 0;

  let dec = Math.abs(deg) + min / 60 + sec / 3600;

  // Signe selon direction (ou signe déjà inclus dans deg)
  if (deg < 0 || dir === "S" || dir === "W") {
    dec = -dec;
  }
  //listeRemarques.value.message.unshift(dmsStr+" devient "+dec)
  return dec;
}

function correctionProjection(app: any, worksheetC6: any) {
  ///////////////////////
  // Projections utilisées en FR : Lambert 93, Lambert 2 étendu, WGS84
  ///////////////////////

  // Définitions Proj4 fiables
  proj4.defs(
    "EPSG:2154",
    "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +no_defs"
  );
  proj4.defs(
    "EPSG:27572",
    "+proj=lcc +lat_1=45.89891888888889 +lat_2=47.69601444444445 +lat_0=46.8 +lon_0=2.337229166666667 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs"
  );
  proj4.defs(
  "EPSG:3857",
  "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0 +y_0=0 +k=1.0 +units=m +no_defs"
);


  // Parse robuste (remplace virgule, supprime espaces/insécables)
  const num = (v: any): number => {
    if (v == null) return NaN;
    return Number(String(v).trim().replace(/,/g, ".").replace(/\s|\u00A0|\u202F/g, ""));
  };

  // Helpers
  const inDegBounds = (lat: number, lon: number) =>
    Number.isFinite(lat) &&
    Number.isFinite(lon) &&
    Math.abs(lat) <= 90 &&
    Math.abs(lon) <= 180;

  // IMPORTANT : proj4 attend [X, Y] = [lon_Easting, lat_Northing]
  const X_fromApp = () => num(app.longitude);
  const Y_fromApp = () => num(app.latitude);

  const wgs84Coords: [number, number] = [0, 0];

  switch (app.projection) {
    case "WGS84 DMS": {
      //app.latitude = DMSToDecimal(app.latitude);
      //app.longitude = DMSToDecimal(app.longitude);
      break;
    }

    case "WGS84 Decimal": {
      // S’assure que virgules → points
      app.latitude = num(app.latitude);
      app.longitude = num(app.longitude);
      break;
    }

    case "Lambert 2 étendu": {
      const X = X_fromApp(); // Easting
      const Y = Y_fromApp(); // Northing
      // Entrée [X,Y], sortie [lon, lat]
      const [lon, lat] = proj4("EPSG:27572", "EPSG:4326", [X, Y]);
      app.latitude = lat;
      app.longitude = lon;
      break;
    }

    case "Lambert 93": {
      const X = X_fromApp(); // Easting
      const Y = Y_fromApp(); // Northing
      const [lon, lat] = proj4("EPSG:2154", "EPSG:4326", [X, Y]);
      app.latitude = lat;
      app.longitude = lon;
      break;
    }

    case "Web Mercator": {
      const X = X_fromApp(); // Easting
      const Y = Y_fromApp(); // Northing
      const [lon, lat] = proj4("EPSG:3857", "EPSG:4326", [X, Y]);
      app.latitude = lat;
      app.longitude = lon;
      break;
    }

    case "Inconnu": {
      listeRemarques.value.message.unshift(
        `[TEST] Les coordonnées ${app.projection} de l'appui ${app.nom} n'ont pas pu être traitées et seront réinitialisées.`
      );

      const filteredArray = appuisActif.features.filter((base: any) => {
        const numAppui = parseInt(base?.properties?.NUM_APPUI, 10);
        const appNomWithoutZeros = parseInt(app.nom, 10);
        return base?.properties && numAppui === appNomWithoutZeros;
      });

      if (filteredArray[0]) {
        worksheetC6.getCell(app.indexCalcul, 4).value =
          filteredArray[0].geometry.coordinates[1];
        worksheetC6.getCell(app.indexCalcul, 5).value =
          filteredArray[0].geometry.coordinates[0];

        app.latitude = filteredArray[0].geometry.coordinates[1];
        app.longitude = filteredArray[0].geometry.coordinates[0];

        listeRemarques.value.message.unshift(
          `[OK] Les coordonnées ${app.projection} de l'appui ${app.nom} ont été trouvées dans le PIT.`
        );
      } else {
        worksheetC6.getCell(app.indexCalcul, 4).value = "0.290303";
        worksheetC6.getCell(app.indexCalcul, 4).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" }, // Jaune
        };

        worksheetC6.getCell(app.indexCalcul, 5).value = "0.561851";
        worksheetC6.getCell(app.indexCalcul, 5).fill = { // <-- corrige la colonne
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" }, // Jaune
        };
      }
      return app; // pas de break après un return
    }

    default: {
      break;
    }
  }

  // Écriture Excel uniquement si on est en WGS84 valide
  if (inDegBounds(Number(app.latitude), Number(app.longitude))) {
    worksheetC6.getCell(app.indexCalcul, 4).value = app.latitude;
    worksheetC6.getCell(app.indexCalcul, 5).value = app.longitude;
  }

  return app;
}



function correctionProjection_05092025(app: any, worksheetC6: any) {


  ///////////////////////
  //
  // En France, 3 projections sont majoritairement utilisées
  // Lambert 93, Lambert 2E et Google
  // Mapbox fonctionne en Google, donc le front doit convertir les coordonnées si besoin
  //
  ///////////////////////

  proj4.defs(
    "EPSG:27572",
    "+proj=lcc +lat_1=45.89891888888889 +lat_0=45.89891888888889 +lon_0=2.337229166666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs"
  );
  proj4.defs(
    "EPSG:2154",
    "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
  );

  const lambertCoords = [app.latitude, app.longitude];
  const lambert93Coords = [app.latitude, app.longitude];
  let wgs84Coords = [0, 0];
  let wgs84Coords1 = [0, 0];
  let floatCoords: number[] = [0, 0];

  switch (app.projection) {
    case "WGS84 DMS":
      app.latitude = DMSToDecimal(app.latitude);
      app.longitude = DMSToDecimal(app.longitude);
      break;
    case "WGS84 Decimal": //OK
      //console.log('WGS84 Decimal')
      break;
    case "Lambert 2 étendu": //OK
      floatCoords = lambertCoords.map((coord) => parseFloat(coord));
      wgs84Coords = proj4("EPSG:27572", "WGS84", floatCoords);
      app.latitude = wgs84Coords[1];
      app.longitude = wgs84Coords[0];
      break;
    case "Lambert 93":
      //console.log('Lambert 93', lambert93Coords)
      floatCoords = lambert93Coords.map((coord) => parseFloat(coord));
      wgs84Coords1 = proj4("EPSG:2154", "WGS84", floatCoords);
      app.latitude = wgs84Coords1[1];
      app.longitude = wgs84Coords1[0];
      break;
    case "Inconnu": {
      listeRemarques.value.message.unshift(
        `[TEST] Les coordonnées ${app.projection} de l'appui ${app.nom} n'ont pas pu être traitées et seront réinitalisées.`
      );

      const filteredArray = appuisActif.features.filter((base) => {
            // Check if base has properties and NUM_APPUI property
            const numAppui = parseInt(base.properties.NUM_APPUI, 10);
            const appNomWithoutZeros = parseInt(app.nom, 10);

            return base.properties && numAppui === appNomWithoutZeros;
      });
            

      if(filteredArray[0]){
        worksheetC6.getCell(app.indexCalcul, 4).value = filteredArray[0].geometry.coordinates[1];
        worksheetC6.getCell(app.indexCalcul, 5).value = filteredArray[0].geometry.coordinates[0];

        app.latitude  = filteredArray[0].geometry.coordinates[1];
        app.longitude = filteredArray[0].geometry.coordinates[0];

        listeRemarques.value.message.unshift(
        `[OK] Les coordonnées ${app.projection} de l'appui ${app.nom} ont été trouvées dans le PIT.`
      );
      } else {
        worksheetC6.getCell(app.indexCalcul, 4).value = '0.290303';
        worksheetC6.getCell(app.indexCalcul, 4).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFF00' } // Jaune
        };

        worksheetC6.getCell(app.indexCalcul, 5).value = '0.561851';
        worksheetC6.getCell(app.indexCalcul, 4).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFF00' } // Jaune
        };
      }
      return app;
      }
      break;
  }
  if (
    typeof app.latitude === "number" &&
    typeof app.longitude === "number" &&
    Number.isFinite(app.latitude) &&
    Number.isFinite(app.longitude) &&
    Math.abs(app.latitude) <= 90 &&
    Math.abs(app.longitude) <= 180
  ) {
    worksheetC6.getCell(app.indexCalcul, 4).value = app.latitude;
    worksheetC6.getCell(app.indexCalcul, 5).value = app.longitude;
  }


  return app;
}
 
export const calibrageAppuiParCoordonnees = async (
  worksheetC6: any,
  parcours: any,
  operateur: any
) => {
  ///////////////////
  //
  // Chaque appuis dans parcours va être analysé pour déterminer sa projection
  // Un maximum d'erreur seront détectées (absence de points, coordonnées non-Google)
  // Une fois l'erreur retirée on converti en 4326
  //
  ///////////////////

  for (let i = 0; i < parcours.length; i++) {
    if (cancelLectureC6.value) break;
    const projection_depart = await determinerProjection(parcours[i], operateur);
    if (cancelLectureC6.value) break;

    // On normalise les deux valeurs en nombre (une seule fois)
    const latNum = normalizeCoord(parcours[i].latitude);
    const lonNum = normalizeCoord(parcours[i].longitude);

    let projection = projection_depart;

    switch (projection_depart) {
      case "WGS84 DMS":
        // Tu avais dit vouloir distinguer ce format.
        // Ici on se contente de marquer la projection sans toucher aux valeurs d'origine.
        projection = "WGS84 DMS";
        parcours[i].projection = "WGS84 DMS";
        break;

      case "WGS84 Decimal": {
        // On s'assure que ce sont bien des décimaux corrects, pas de "slice" en dur.
        // Formatage à 6 décimales max (classique pour des coords GPS).
        if (isFinite(latNum) && isFinite(lonNum) && inDegBounds(latNum, lonNum)) {
          parcours[i].latitude = toStringFixed(latNum, 6);
          parcours[i].longitude = toStringFixed(lonNum, 6);
        }
        projection = "WGS84 Decimal";
        parcours[i].projection = "WGS84 Decimal";
        break;
      }

      case "Lambert 2 étendu": {
        // On garde en mètre, avec 3 décimales max si besoin (selon la source).
        if (isFinite(latNum)) parcours[i].latitude = toStringFixed(latNum, 3);
        if (isFinite(lonNum)) parcours[i].longitude = toStringFixed(lonNum, 3);
        projection = "Lambert 2 étendu";
        parcours[i].projection = "Lambert 2 étendu";
        break;
      }

      case "Lambert 93": {
        if (isFinite(latNum)) parcours[i].latitude = toStringFixed(latNum, 3);
        if (isFinite(lonNum)) parcours[i].longitude = toStringFixed(lonNum, 3);
        projection = "Lambert 93";
        parcours[i].projection = "Lambert 93";
        break;
      }

      case "Web Mercator": {
        if (isFinite(latNum)) parcours[i].latitude = toStringFixed(latNum, 3);
        if (isFinite(lonNum)) parcours[i].longitude = toStringFixed(lonNum, 3);
        projection = "Web Mercator";
        parcours[i].projection = "Web Mercator";
        break;
      }

      default:
        // Par sécurité: on ne touche pas aux valeurs si on ne sait pas,
        // mais on peut marquer "Lambert 93" si c'est ton fallback global.
        projection = "Lambert 93";
        break;
    }

    // BBOX France : si en dehors, tenter un fallback (Saisies ou PIT)
    const latCheck = parseFloat(parcours[i].latitude);
    const lonCheck = parseFloat(parcours[i].longitude);
    let adjusted = false;
    if (!(inFranceBBox(latCheck, lonCheck))) {
      const fallback = fallbackCoordonneesAppui(parcours[i]);
      if (fallback) {
        parcours[i].latitude = toStringFixed(fallback[1], 6);
        parcours[i].longitude = toStringFixed(fallback[0], 6);
        parcours[i].projection = "WGS84 Decimal";
        projection = "WGS84 Decimal";
        adjusted = true;
        listeRemarques.value.message.unshift(
          `[INFO] Coordonnées ajustées via PIT pour l'appui ${parcours[i].nom} (${fallback[1]}, ${fallback[0]}).`
        );
      } else {
        listeRemarques.value.message.unshift(
          `[WARN] Coordonnées hors bbox pour l'appui ${parcours[i].nom} (lat:${parcours[i].latitude}, lon:${parcours[i].longitude}).`
        );
      }
    }

    if (!adjusted) {
      listeRemarques.value.message.unshift(
          `[INFO] Les coordonnées sont ${parcours[i].projection} pour l'appui ${parcours[i].nom}.`
      );
    }

    parcours[i] = correctionProjection(parcours[i], worksheetC6);
  }
  return parcours;
};

// Vérifie si (lat, lon) sont plausibles en degrés
function inDegBounds(lat: number, lon: number): boolean {
  return lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180;
}
function inFranceBBox(lat: number, lon: number): boolean {
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return false;
  return lat >= 40 && lat <= 52 && lon >= -6 && lon <= 11;
}

// Formate un nombre avec un maximum de décimales, sans trailing zeros
function toStringFixed(n: number, maxDigits: number): string {
  const s = n.toFixed(maxDigits);
  return s.replace(/\.?0+$/, ""); // supprime les zéros inutiles
}

function fallbackCoordonneesAppui(appui: any): [number, number] | null {
  // Utilise les appuis déjà chargés (PIT) pour récupérer des coords WGS84
  try {
    const code = String(appui?.nom || "").replace(/^0+/, "");
    const feature = (chambresActif?.features || []).find((f: any) => {
      const prop = f?.properties || {};
      const codeCh1 = String(prop.CODE_CH1 || prop.NOM || "").replace(/^0+/, "");
      return codeCh1 === code;
    });
    if (feature?.geometry?.coordinates) {
      const [lon, lat] = feature.geometry.coordinates;
      if (Number.isFinite(lat) && Number.isFinite(lon)) {
        return [lon, lat];
      }
    }
  } catch (e) {
    console.warn("[fallbackCoordonneesAppui] error", e);
  }
  return null;
}


function distanceToPolygon(point: any, polygon: any) {
  if (polygon.type === "Feature") {
    polygon = (polygon as any).geometry;
  }

  let distance: number;

  if (polygon.type === "MultiPolygon") {
    distance = (polygon as any).coordinates
      .map((coords: number[][][]) =>
        distanceToPolygon(point, turf.polygon(coords).geometry)
      )
      .reduce((smallest: number, current: number) =>
        current < smallest ? current : smallest
      );
  } else {
    if ((polygon as any).coordinates.length > 1) {
      const [exteriorDistance, ...interiorDistances] = (
        polygon as any
      ).coordinates.map((coords: number[][]) =>
        distanceToPolygon(point, turf.polygon([coords]).geometry)
      );

      if (exteriorDistance < 0) {
        const smallestInteriorDistance = interiorDistances.reduce(
          (smallest: number, current: number) =>
            current < smallest ? current : smallest
        );

        if (smallestInteriorDistance < 0) {
          distance = smallestInteriorDistance * -1;
        } else {
          distance =
            smallestInteriorDistance < exteriorDistance * -1
              ? smallestInteriorDistance * -1
              : exteriorDistance;
        }
      } else {
        distance = exteriorDistance;
      }
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      distance = turf.pointToLineDistance(point, turf.polygonToLineString(polygon as any)) * 1000;

      if (turf.booleanPointInPolygon(point, polygon as any)) {
        distance = distance * -1;
      }
    }
  }

  return distance;
}

export async function coordonneesSelonDistance(feature, distance) {

  //console.log(feature, distance)
  let lineString;
  if (feature.geometry.type === 'MultiLineString') {
    // If it's a MultiLineString, merge all coordinates into one LineString
    const coordinates = feature.geometry.coordinates.flat();
    lineString = turf.lineString(coordinates);
  } else if (feature.geometry.type === 'LineString') {
    // If it's already a LineString, use it directly
    lineString = feature;
  } else {
    // If it's neither MultiLineString nor LineString, return null or handle as needed
    return null;
  }

  // Find coordinates based on the given distance
  const point = turf.along(lineString, distance, { units: 'meters' });

  return point.geometry.coordinates;
}
